import { Component, OnInit, OnDestroy, Input, OnChanges, SimpleChanges, Inject, EventEmitter, Output, HostListener, ElementRef, DOCUMENT } from '@angular/core';
import { UntypedFormControl, Validators } from '@angular/forms';
import { ENTER, COMMA, I, D, J } from '@angular/cdk/keycodes';

import * as _ from 'underscore';
import * as __ from 'lodash';
import { CallStage } from '../enums/CallStage';
import { PersonSearchService } from '../_services/person-search.service';
import { AggReqObjectHandlerService } from '../_services/agg-req-object-handler.service';
import { FilterDataHandlerService } from '../_services/filter-data-handler.service';
import { FilterParams } from '../common-interfaces-classes/FilterParams';
import { AggregationService } from '../_services/aggregation.service';
import { ActivatedRoute, Router } from '@angular/router';
import { LocalStorageService } from '../_services/local-storage.service';
import { ExtraInfo } from './ExtraInfo';
import { GlobalService } from '../_services/global.service';
import { MatrixFilter } from '../common-interfaces-classes/MatrixFilter';
import { StatsMatrixHandlerService } from '../_services/stats-matrix-handler.service';
import { Observable, Subject, Subscription, SubscriptionLike } from 'rxjs';
import { catchError, concatMap, debounceTime, distinctUntilChanged, distinctUntilKeyChanged, filter, groupBy, mergeMap, switchMap, takeUntil, tap } from 'rxjs/operators';
import { DataService } from '../data.service';
import { SessionStorageService } from '../_services/session-storage.service';
import { TalentInsightsReqHandlerService } from '../_services/talent-insights-req-handler.service';
import { GeneralConstants } from '../constants/GeneralConstants';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SaveSearchModalComponent } from '../save-search-modal/save-search-modal.component';
import { SimilarCandidateService } from '../_services/similar-candidate.service';
import { SuggestedTitle } from "../openai/suggested-titles/suggested-titles.component";
import { Location } from '@angular/common';
import { JdDataService } from '../jd-data.service';
import { CompanyInsightsService } from '../_services/company-insights.service';
import { ContinentHandlerService } from '../_services/continent-handler.service';
import { EuropeAccessModalComponent } from '../europe-access-modal/europe-access-modal.component';
import cjson from 'compressed-json';
import { InsightsDataService } from '../_services/insights-data.service';
import { TransactionService } from '../_services/transaction.service';
import { AiSourcingHandlerService } from '../_services/ai-sourcing-handler.service';
import { AiSourcingService } from '../_services/ai-sourcing.service';
import moment from 'moment';
import { LoaderEventsService } from '../_services/loader-events.service';
import { LoaderType } from '../enums/LoaderType';

@Component({
    selector: "app-person-search-filter",
    templateUrl: "./person-search-filter.component.html",
    styleUrls: ["./person-search-filter.component.scss"],
    standalone: false
})
export class PersonSearchFilterComponent implements OnInit, OnDestroy, OnChanges {
  // Job title
  jobTitleInput: UntypedFormControl = new UntypedFormControl(null);
  jobTitleTopList: any;
  jobTitleSelectedList: any[] = [];
  jobTitleStatus = CallStage.CURRENT.toString();
  showJobTitleLoader: boolean = false;
  jobTitleList: any = [];

  // Past Job Title
  pastJobTitleInput: UntypedFormControl = new UntypedFormControl(null);
  pastJobTitleTopList: any;
  pastJobTitleSelectedList: any[] = [];
  pastJobTitleList: any = [];
  showPastJobTitleLoader: boolean = false;

  // location
  locationInput: UntypedFormControl = new UntypedFormControl(null);
  locationTopList: any = [];
  locationSelectedList: any = [];
  locationList: any = [];
  showLocationLoader = false;

  // company
  companyInput: UntypedFormControl = new UntypedFormControl(null);
  companySelectedList: any = [];
  companyList: any = [];
  companyStatus = CallStage.CURRENT.toString();
  companyTopList: any = [];
  showCompanyLoader = false;
  shouldShowStatusCompany = true;

  // industry
  industryStatus: string = 'Current';
  industrySelectedList: any = [];
  industryTopList: any = [];
  industryInput: UntypedFormControl = new UntypedFormControl(null);
  showIndustryLoader = false;
  industryList = [];

  // years of experience
  yearsofexperience: any = 'Total';
  yearsofexperienceFrom: UntypedFormControl = new UntypedFormControl(null);
  yearsofexperienceTo: UntypedFormControl = new UntypedFormControl(null);
  filterAppliedOnYearsOfExperience: boolean = false;
  dataSourceYearsOfExperience: any;

  /**
   * Valid range of years of experience
   */
  experienceYearRange = {
    min: 0,
    max: 40
  }

  /** Years of experience "From" data, Used to set in filterData only when click on apply button*/
  yearsofexperienceFromFilterData: any = null;
  /** Years of experience "To" data, Used to set in filterData only when click on apply button*/
  yearsofexperienceToFilterData: any = null;

  // current years of experience
  currentfromyearsofexperience: UntypedFormControl = new UntypedFormControl(null);
  currenttoyearsofexperience: UntypedFormControl = new UntypedFormControl(null);
  filterAppliedOnCurrentYearsOfExperience: boolean = false;
  dataSourceCurrentYearsOfExperience: any;

  /** current Years in company "From" data, Used to set in filterData only when click on apply button*/
  currentfromyearsofexperienceFilterData: any = null;
  /** current Years in company "TO" data, Used to set in filterData only when click on apply button*/
  currenttoyearsofexperienceFilterData: any = null;

  // education
  educationInput: UntypedFormControl = new UntypedFormControl(null);
  educationList: any = [];
  educationSelectedList: any = [];
  educationTopList: any = [];
  showEducationLoader = false;


  // Education Location
  schoolLocationInput: UntypedFormControl = new UntypedFormControl(null);
  schoolLocationList: any = [];
  schoolLocationSelectedList: any = [];
  schoolLocationTopList: any = [];
  showSchoolLocationLoader = false;

  // field of study
  fieldOfStudyInput: UntypedFormControl = new UntypedFormControl(null);
  fieldOfStudyList: any = [];
  fieldOfStudySelectedList: any[] = []
  fieldOfStudyTopList: any = [];
  showFieldOfStudyLoader = false;

  /**Full name Filter */
  fullNameInput: UntypedFormControl = new UntypedFormControl(null);
  fullNameList: any = []
  fullNameSelectedList: any[] = [];
  showFullNameLoader:boolean = false;


  // gender
  gender: 'Male' | 'Female' | 'All' = 'All';
  isGenderSelected: boolean = false;
  isGenderSelectionDisabled = false;

  // School
  schoolInput: UntypedFormControl = new UntypedFormControl(null);
  schoolList: any = [];
  schoolSelectedList: any = [];
  schoolTopList: any = [];
  showSchoolLoader = false;

  // company size
  companySizeInput: UntypedFormControl = new UntypedFormControl(null);
  companySizeList: any = [];
  companySizeSelectedList: any = [];
  companysize: any = [];
  isCompanySizeSelected: boolean = false;
  companySizeOption: any = ["1-10", "11-50", "51-200", "201-500", "501-1000", "1001-5000", "5001-10000", "10001+"]

  // skills
  skillsInput: UntypedFormControl = new UntypedFormControl(null);
  skillsList: any = [];
  skillsSelectedList: any = [];
  skillsTopList: any = [];
  showSkillLoader: boolean = false;

  // Likely To Move In
  filterLikelyToMoveIn: any = 'All';
  isLikelyToMoveInFilterSelected = false;
  candidateslikelytomove: String | null = null;

  // seniority
  seniority: any = [];
  seniorityList = GlobalService.seniorityLevels;

  // function
  functionStatus: any = 'Current';
  functionsList: any = [];
  functionSelectedList: any = [];
  functionsInput: UntypedFormControl = new UntypedFormControl(null);
  functionTopList = [];
  showFunctionsLoader = false;

  // changed jobs
  changedJobStatus: any = null;
  changedJobDuration: any = null;
  changedJobStartDuration: number = 0;
  changedJobEndDuration: number = 12;
  changedJobStatusMatrix: any = null;

  //Highlights
  /**List of filters selected from highlights */
  highlightsSelectedList: any[] = [];
  /** List of id's of selected highlights to control prime multi select*/
  highlightSelectedControl: any[] = []


  // keyword filter
  keywordSelectedList: any[] = [];
  keyword_input: UntypedFormControl = new UntypedFormControl(null);
  keywordlist: any[] = [];
  // keywordTopList: any = [];
  showKeywordLoader = false;

  filterData: FilterParams;
  reportsAggs: any = {};

  // Properties for mat-chip
  selectable = true;
  removable = true;

  // These properties are for data fetched through local storage whenver we are redirected from talent insights or different page
  extraInfo: ExtraInfo;

  // Keeping track of all subscriptions to unsubscribe later
  subscriptions: Subscription[] = [];
  subscriptionsLike: SubscriptionLike[] = [];
  browserBackEvent: boolean = false;

  searchHistoryRegion: string | null = null;
  // Typeahead
  private typeAheadSubject = new Subject<{ event: Event, type: string }>();
  minSearchLengthToActivateTypeaheads: number = 3;
  separatorKeysCodes: number[] = [ENTER, COMMA];
  separatorKeysCodesForLocation: number[] = [ENTER];

  @Input() similarobject: any;
  @Input() redirectSource: any;
  @Input('aiSuggestion') aiSuggestion: SuggestedTitle[] = [];
  addOnBlur: any;
  isSimilarCanidate: boolean = false;

  // General constant - used to name all filters
  filterNames = GeneralConstants.FILTER_NAMES;

  // Properties for styling
  isPersonSearchListingPage = false;
  isReportDetails = false;
  filterType: string;
  searchKeyword: string;

  //keyword or boolean search input
  keywordInput: UntypedFormControl = new UntypedFormControl(null);
  showSearchKeywordLoader: Boolean = false;
  searchKeywordList: any;
  searchDisable: Boolean = true;
  filterValue: string;
  isSearchSaved: boolean = false;
  talentDiscoveryHistoryId: any;
  savedSearchDetails: any;
  successMessage: string;
  errorMessage: string;
  showregion: string;
  searchTitle: string;
  searchCompany: string;
  @Input() similarContinent;

  /**Type of distance */
  locationDistanceUnit: string = 'kilometers';
  /**Value of range of distance in location filter */
  locationDistanceRange: string = '20';

  /**Value will update with ngModel varaibles, Only when click on apply and used to sent in request object */
  locationDistanceUnitForFilterData: any = null;
  locationDistanceRangeForFilterData: any = null;

  locationDistanceRangefromAdvance: string = '20';
  wholeNumberForDistance: boolean = true;

  comingFromJd = false;
  tabType: string;

  searchSource: string = null;

  companyAiSuggestions: any[] = [];

  industryForCompanyAiSuggestions: string[] | [] = [];

  // OpenAI
  isOpenAITitleLoading: boolean = true;
  showOpenAITitleSuggestions: number;

  isOpenAISkillsLoading: boolean = false;
  showOpenAISkillsSuggestions: number;

  updatedAiTitleChips: EventEmitter<SuggestedTitle[]> = new EventEmitter<SuggestedTitle[]>();

  updatedAiPastJobTitleChips: EventEmitter<SuggestedTitle[]> = new EventEmitter<SuggestedTitle[]>();

  updatedAiSkillChips: EventEmitter<SuggestedTitle[]> = new EventEmitter<SuggestedTitle[]>();

  selectedTitles: SuggestedTitle[] = [];

  selectedSkills: SuggestedTitle[] = [];

  aiSuggestedTitles: SuggestedTitle[] = [];

  aiSuggestedPastJobTitles: SuggestedTitle[] = [];

  aiSuggestedSkills: SuggestedTitle[] = [];

  /** List of options of highlights filter */
  highLightOptions: { id: number, value: string, label: string, color: string, imageName: string }[] = [];

  /**Talent insights tab or not */
  isTalentInsightsPage: boolean = false;


  tograduationyearFilter: number | string | null = null;
  fromgraduationyearFilter: number | string | null = null;
  isGraduationFilterApplied: boolean = false;

  /** Recomended API Loader */
  showLoaderbeforeDataLoad: boolean = false;

  @Input() showAISourcingBackButton: boolean;

  dataSourceGraduationYears:any;
  graduationYearRange = {
    min: new Date().getFullYear() - 10,
    max: new Date().getFullYear() + 5
  }

  get aiQuery() {
    const jobTitle = this.jobTitleSelectedList?.length ?  this.jobTitleSelectedList.filter(jt => !jt.isSuggested).map(jobTitle => `"${jobTitle.chipkey}"`): [];
    const skills = this.skillsSelectedList?.length ? this.skillsSelectedList.filter(s => !s.isSuggested).map(skill => `"${skill.chipkey}"`):[];
    const pastJobTitle = this.pastJobTitleSelectedList?.length ? this.pastJobTitleSelectedList.filter(jt => !jt.isSuggested).map(jobTitle => `"${jobTitle.key.replace('.searchastext', '')}"`): [];
    const keyword = this.keyWordInputValue && this.keyWordInputValue.trim() ? `"${this.keyWordInputValue}"` : null;

    return keyword ? [keyword].concat(jobTitle).concat(skills).concat(pastJobTitle).join(' OR ') || '' : jobTitle.concat(skills).concat(pastJobTitle).join(' OR ') || '';
  }

  get openAIExcludeJobTitles(): string[] {
    return this.jobTitleSelectedList.map(jobTitle => jobTitle.chipkey);
  }

  get openAIExcludeSkills(): string[] {
    return this.skillsSelectedList.map(skill => skill.chipkey);
  }

  get showCompanyAiSuggestions() {
    return this.companySelectedList.filter(c => !c.isSuggested).length;
  }


  /**
   * Years of experience values are in valid range or not
   * For now it is only getting used for redirection range
   * @returns
   */
  get hasYearsOfExperInsightsRangeError(){
   if(this.experienceYearRange.min || this.experienceYearRange.max){
      if(
        (this.yearsofexperienceFrom.value && (this.yearsofexperienceFrom.value < this.experienceYearRange.min ||  this.yearsofexperienceFrom.value > this.experienceYearRange.max))
        || (this.yearsofexperienceTo.value && (this.yearsofexperienceTo.value < this.experienceYearRange.min || this.yearsofexperienceTo.value > this.experienceYearRange.max))
      ){
        return {error: true, message:`Experience must be between ${this.experienceYearRange.min} and ${this.experienceYearRange.max}.` }
      }
    }
    if(typeof this.yearsofexperienceFrom.value == 'number' && typeof this.yearsofexperienceTo.value == 'number'){
      if(this.yearsofexperienceFrom.value > this.yearsofexperienceTo.value){
        return {error: true, message:`Invalid input` }
      }
   }
   return {error: false};
  }

  keyWordInputValue: string = '';



  get jobtitleAndSkillAIData(): { boolean?: string | null, jobtitles?: string[], skills?: string[], filterList?:string } {
    const titles = this.jobTitleSelectedList?.length ? this.jobTitleSelectedList.filter(jt => !jt.isSuggested).map(jobTitle => jobTitle.chipkey) : [];
    const pasttitles = this.pastJobTitleSelectedList?.length ? this.pastJobTitleSelectedList.filter(jt => !jt.isSuggestion).map(jobTitle => jobTitle.key.replace('.searchastext', '')) : [];
    return {
      boolean: this.keyWordInputValue || null,
      // @ts-ignore
      jobtitles: [...titles, ...pasttitles],
      skills: this.skillsSelectedList?.length ? this.skillsSelectedList.filter(s => !s.isSuggested).map(skill => skill.chipkey) : [],
      filterList: this.filterList
    }
  }
  isOpenAIPastJobTitleLoading: boolean = false;
  showOpenAIPastJobTitleSuggestions: number;

  get openAIPastJobTitles() {
    return this.pastJobTitleSelectedList.filter(jt => !jt.isSuggestion).map(jobTitle => `"${jobTitle.key.replace('.searchastext', '')}"`).join(' OR ') || '';
  }

  get jobTitleAggregateType(): string {
    return this.jobTitleStatus == 'Current' ? 'current_jobtitle' : this.jobTitleStatus == 'Past' ? 'pastjobtitle' : 'jobtitle';
  }

  get jobTitleType(): string {
    return this.jobTitleStatus;
  }

  get pastJobTitleAggregateType(): string {
    return 'pastjobtitle';
  }

  get pastJobTitleType(): string {
    return "Past";
  }

  get openAIExcludePastJobTitles(): string[] {
    return this.pastJobTitleSelectedList.map(jobTitle => jobTitle.chipkey);
  }

  get selectedContinent() {
    if (this.filterDataHandlerService.isCompanyInsightsPage || this.filterDataHandlerService.isCompanyComparePage) {
      return '';
    } else if (this.isReportDetails) {
      const talentRegion = this.showregion || this.localstorageservice.getItem('talentRegion');
      if (talentRegion) {
        return talentRegion;
      } else if (this.sessionStorageService.getItem('historyRegion')) {
        return this.sessionStorageService.getItem('historyRegion');
      } else {
        return this.localstorageservice.getItem('region');
      }
    } else if (this.isSimilarCanidate) {
      if(this.similarContinent)
        return this.similarContinent;
      else return '';
    } else {
      if (this.sessionStorageService.getItem('historyRegion')) {
        return this.sessionStorageService.getItem('historyRegion');
      } else {
        return this.localstorageservice.getItem('region');
      }
    }

  }

  /**
   * Used to get list of year in valid range
   * @param type type of request i.e. `to`, `from`
   * @returns
   */
  graduationYearList(type:string) {
    let start = this.graduationYearRange?.min;;
    let end = this.graduationYearRange?.max;

    if(type == 'from'){
      end = Number(this.tograduationyearFilter) || end;
    } else if(type == 'to'){
      start = Number(this.fromgraduationyearFilter) || start;
    }

    const output = [];
    for (let i = start; i <= end; i++) {
      output.push(i);
    }
    return output;
  }

  continentList: any[] = [{ value: 'asia', type: 'location' }, { value: 'africa', type: 'location' }, { value: 'south america', type: 'location' }, { value: 'north america', type: 'location' }, { value: 'oceania', type: 'location' }];
  continentSelectedList: any[] = [];
  isCompanyInsightsDetails = false;

  searchChips: string;

  private destroy$ = new Subject<void>();
  private requestNotifier$ = new Subject<{ aggregatetype: string, localRequestObject: any, updateSelectedList: boolean }>();
  private activeRequests: { [key: string]: Subject<void> } = {};

  stopQucksearchAPICall: boolean = false;
  savehistory: boolean = true;
  isInsightsActive: boolean = false;
  isListingActive: boolean = true;
  positionHierarchyData: any[] = GlobalService.positionHierarchyData;
  positionHierarchyChipList: any[] = [];
  positionhierarchy: any[] = [];

  isCompanyComparePage: boolean = false;

  isCalledFromComponent: string = null;

  overallMatchFilters: string[] = [];
  private matchTypes = ['EXCELLENT', 'GOOD', 'POTENTIAL', 'NOT_A_MATCH'];
  projectDetails: any;

  /** Used to trigger the Suggested-titles-component on filter change */
  filterList:string = '';
  hasEuAccess: number;
  hasEUTalentInsightsAccess: number;
  location_type: string = null;
  comingFromNL: boolean = false;
  locationContinents: any[] = [];
  @Output() filterEvent: EventEmitter<string> = new EventEmitter<string>();
  locationcontinentsName: any[] = [];
  defaultContinent: string;
  isOpen: boolean = false;
  saveSearchTalentDiscoveryHistoryId: any = null;
  saveSearchName: string = null;

  companySubscription: Subscription = null;
  skillSubscription: Subscription = null;
  isRedirectedFromCompanyInsights: boolean = false;
  isRedirectedFromTalentInsights: boolean = false;
  isAiSourcingTab: boolean = false;
  isCollapsed: boolean = true;
  collapsedFilters: { [key: string]: boolean } = {};


  constructor(
    private personSearchService: PersonSearchService,
    private filterDataHandlerService: FilterDataHandlerService,
    private aggService: AggregationService,
    private route: ActivatedRoute,
    private localstorageservice: LocalStorageService,
    private statsMatrixHandlerService: StatsMatrixHandlerService,
    private dataService: DataService,
    private sessionStorageService: SessionStorageService,
    private talentInsightsReqHandler: TalentInsightsReqHandlerService,
    private aggReqObjectHandlerService: AggReqObjectHandlerService,
    private router: Router,
    private modalService: NgbModal,
    private similarCandidateService: SimilarCandidateService,
    @Inject(DOCUMENT) private document: Document,
    private jdDataService: JdDataService,
    private companyInsightsService: CompanyInsightsService,
    private continentHandlerService: ContinentHandlerService,
    private locationService: Location,
    private insightsDataService: InsightsDataService,
    private transactionService: TransactionService,
    private aiSourcingHandlerService: AiSourcingHandlerService,
    private aiSourcingService: AiSourcingService,
    private eRef: ElementRef,

    private loaderEventService : LoaderEventsService
  ) {
    this.fieldOfStudySelectedList = [];
    this.insightsDataService.isInsightsActive().subscribe((res: any) => {
      if(res && res.insightsActive) {
        this.isInsightsActive = true;
        this.isListingActive = false;
      } else {
        this.isInsightsActive = false;
        this.isListingActive = true;
      }
    })

    if (this.aiSourcingService.isAISourcingTab) {
      this.isCalledFromComponent = 'ai-sourcing';
    } else if(this.aiSourcingService.isResumeScreenTab) {
      this.isCalledFromComponent = 'resume-screen';
    } else {
      this.isCalledFromComponent = null;
    }

    this.tabType = this.route.snapshot.queryParams['type'];
    if (this.route.snapshot.queryParams.type === 'quick-search' ||
       this.route.snapshot.queryParams.type === 'advanced-search' ||
       this.route.snapshot.queryParams.type === 'similar-candidate-from-linkedinurl' ||
       this.route.snapshot.queryParams.type === 'similar-candidate-resume-upload' ||
       this.route.snapshot.queryParams.type === 'job-description' ||
       this.route.snapshot.queryParams.redirectSource === 'talent-insights' ||
       this.route.snapshot.queryParams.redirectSource === 'company-insights' ||
       this.route.snapshot.queryParams.searchSource== 'history-component' ||
       this.router.url.includes('/report-details') || this.route.snapshot.queryParams.type === 'nl-search'
      ) {
        this.searchKeyword = this.route.snapshot.queryParams['keyword'] || '';
        // console.log('here line 434');
      if (!this.router.url.includes("filter=")) {
      this.setFilterDataInLocalStorage(true);
    } else {
      // console.log('here line 437');
      const cacheRequest = localStorage.getItem(this.route.snapshot.queryParams.filter);
      const filterData = cjson.decompress(JSON.parse(cacheRequest));
      if ( filterData?.calledFrom == "history" || filterData?.calledFrom == "advance") {
        this.dataService.setData(filterData);
        this.setReceivedData();
      } else {
        this.stopQucksearchAPICall = true;
        // console.log(filterData,'line 449');
        this.loadFilterFromLocalStorage(filterData);
      }
    }
  }

    const statemanagementSub = this.locationService.subscribe((p) => {
      this.browserBackEvent = true;
      const parsedUrl = this.router.parseUrl(p.url);
      const searchSource = parsedUrl.queryParams.searchSource;
      const localKey = parsedUrl.queryParams.filter;
      const filterType = parsedUrl.queryParams.filtertype;
      const filtervalue = parsedUrl.queryParams.filtervalue;
      const keyword = parsedUrl.queryParams.keyword;
      const type = parsedUrl.queryParams.type;
      const redirectSource = parsedUrl.queryParams.redirectSource;
      const isReportsPage = p.url.includes('/report-details')

      if (filterType) {
        this.filterType = filterType;
      }
      if (filtervalue) {
        this.filterValue = filtervalue;
      }
      if (keyword) {
        this.searchKeyword = keyword;
      }
      if (type) {
        this.tabType = type;
      }
      if (searchSource) {
        this.searchSource = searchSource;
      }
      if (redirectSource) {
        this.redirectSource = searchSource;
      }

      // debugger;

      if ( localKey && (type == "quick-search" || type == "advanced-search" || type == 'similar-candidate-from-linkedinurl' || type === 'similar-candidate-resume-upload' || type === 'job-description' || searchSource == "history-component" || redirectSource == 'talent-insights' || redirectSource == 'company-insights' || isReportsPage) || type === 'nl-search' ) {
        const cacheRequest = localStorage.getItem(localKey);
        const filterData = cjson.decompress(JSON.parse(cacheRequest));
        // debugger
        if ( filterData?.calledFrom == "history" || filterData?.calledFrom == "advance") {
          if(filterData?.calledFrom == 'history'){
            filterData.allLists['booleanquery'] = filterData.requestObject?.booleanquery;
          }
          this.dataService.setData(filterData);
          this.getexpandrefresheddata(null)
          this.loadFilterFromLocalStorage(filterData.allLists);
        } else {

          // const recommendedCandidateSub = this.aggService.recCandidateDataEvent.subscribe(_res => { this.getExpandFilterData(); this.getTopList(); this.talentDiscoveryHistoryId = _res.talentdiscoveryhistoryid; });
          const recommendedCandidateSub = this.aggService.recCandidateDataEvent.subscribe(_res => {this.talentDiscoveryHistoryId = _res.talentdiscoveryhistoryid; });
          this.subscriptions.push(recommendedCandidateSub);
          this.loadFilterFromLocalStorage(filterData);
          this.getexpandrefresheddata(null);
        }
      }
    });

    this.subscriptionsLike.push(statemanagementSub);


    this.extraInfo = new ExtraInfo();
    this.filterData = filterDataHandlerService.fetchFilterData;
    // This is being handled in ngOnInit, can be reomoved after testing...
    // this.syncLocalDataWithFilterObject();
    if (!this.talentInsightsReqHandler.isTalentInsightsTab) {
      this.setReceivedData();
      this.syncFilterData();
      this.filterDataHandlerService.setFilterData(this.filterData);
    }

    this.comingFromJd = this.jdDataService.isComingFromJobDescription;
    this.hasEuAccess = this.localstorageservice.getItem('hasEUPersonSearchAccess');
    this.hasEUTalentInsightsAccess = this.localstorageservice.getItem('hasEUTalentInsightsAccess');
    this.comingFromNL = this.jdDataService.isComingFromNLSearch;
    this.isRedirectedFromCompanyInsights = this.filterDataHandlerService.isRedirectFromCompanyInsightsPage;
    this.isRedirectedFromTalentInsights = this.filterDataHandlerService.isRedirectFromTalentInsightsPage;

  }
  @HostListener('document:click', ['$event'])
clickOutside(event: any) {
  if (!this.eRef.nativeElement.contains(event.target)) {
    this.isOpen = false;
  }
}
  ngOnInit() {
    this.defaultContinent = this.localstorageservice.getItem('defaultContinent');
    /** Event Subscriber to get current project details  */
    setTimeout((res) => {
      this.projectDetails = this.aiSourcingHandlerService.fetchProjectDetails;
    }, 1000);
    const loaderSub = this.loaderEventService.loaderEvent.subscribe(event => {
      if (event === LoaderType.RECOMMENDED_CANDIDATE) {
        this.showLoaderbeforeDataLoad = true;
      }
    });
    this.subscriptions.push(loaderSub);

    const recCandidateDataSub = this.aggService.recCandidateDataEvent.subscribe(data =>{
this.showLoaderbeforeDataLoad = false;
const filterData = this.filterDataHandlerService.fetchFilterData;
this.locationcontinentsName = filterData.locationcontinents;
this.locationContinents = filterData.continentstobeincluded;
    } );
    this.subscriptions.push(recCandidateDataSub);


    if(this.talentInsightsReqHandler.isCompanyCompareTab){
      this.isCompanyComparePage = true
   }
    const s0 = this.filterDataHandlerService.fetchSuggestedLocation().subscribe((res) => {
      this.locationSelectedList = this.locationSelectedList.concat(_.uniq(res, 'chipkey'));
      this.syncFilterData();
      this.filterDataHandlerService.setFilterData(this.filterData);
      this.aggReqObjectHandlerService.setStartIndex(0);
      this.aggService.getPersonSearchRecommendedCandidates(this.extraInfo);
      this.aggReqObjectHandlerService.setStartIndex(0);
      this.filterDataHandlerService.emitfilterMethodObject({ methodName: "selectedItem" });
    });
    this.subscriptions.push(s0);

    const s2 = this.filterDataHandlerService.fetchSuggestedCompany().subscribe((res) => {
      this.companySelectedList = this.companySelectedList.concat(_.uniq(res, 'chipkey'));
      this.syncFilterData();
      this.filterDataHandlerService.setFilterData(this.filterData);
      this.aggReqObjectHandlerService.setStartIndex(0);
      this.aggService.getPersonSearchRecommendedCandidates(this.extraInfo);
      this.aggReqObjectHandlerService.setStartIndex(0);
      this.filterDataHandlerService.emitfilterMethodObject({ methodName: "selectedItem" });
      this.getCompanyAiSuggestions();
    });
    this.subscriptions.push(s2);

    this.aiSourcingHandlerService.clearFilterEvent.subscribe((res)=>{
      if (res && res.status === 'clear') {
        this.clearFilters('all', 'tabChange')
        // this.hideExpandSuggession();
      }

      })



    const s1 = this.filterDataHandlerService.fetchCompanyFilter().subscribe((res) => {
      if (res.company.length > 0) {
        this.companySelectedList.push(res.company[0])
        this.companyStatus = CallStage.CURRENT_OR_PAST.toString();
        const event = {
          option: {
            value: {
              key: res.company[0].key,
              chipkey: res.company[0].chipkey
            }
          }
        }
       this.selectedItem(event, 'company')
      }
    });
    this.subscriptions.push(s1);

    const s3 = this.similarCandidateService.getSimilarCandidate().subscribe(() => {
      this.isSearchSaved = false;
    });

    this.subscriptions.push(s3);

    const fetchPersonSearchListingInsightsFilterSub = this.filterDataHandlerService.fetchPersonSearchListingInsightsFilter.subscribe(filterEvent => {
      const type = filterEvent.type;
      switch (type) {
        case 'yearsofexperience': {
          this.yearsofexperienceFrom.setValue(filterEvent.event);
          this.yearsofexperienceTo.setValue(filterEvent.event);
          this.applyFilter(type);
          break;
        }
        case 'currentyearsofexperience': {
          this.currentfromyearsofexperience.setValue(filterEvent.event);
          this.currenttoyearsofexperience.setValue(filterEvent.event);
          this.applyFilter(type);
          break;
        }
        case 'gender': {
         this.selectedItem({ target: { value: filterEvent.event == 'Men' ? 'Male' : 'Female' } }, type);
          break;
        }
        case 'seniority': {
          const seniorityData = _.uniq(this.seniority.concat(filterEvent.event.toLowerCase()));
        this.selectedItem({ value: seniorityData }, type);
          break;
        }
        case 'location': {
          const filterData = this.filterDataHandlerService.fetchFilterData;
          filterData.locationcontinents.push({key: filterEvent?.event?.key, continent: filterEvent?.event?.location_continent[0]?.key, calledFrom: 'Filter'});
          filterData.continentstobeincluded.push(filterEvent?.event?.location_continent[0]?.key);
          this.locationcontinentsName = filterData.locationcontinents;
          this.locationContinents = filterData.continentstobeincluded;
          this.filterDataHandlerService.setFilterData(filterData);
        }
        default: {
          this.addToSelectedList(filterEvent.event, type);
        }
      }
    });
    this.subscriptions.push(fetchPersonSearchListingInsightsFilterSub);

    const recommendedCandidateSub = this.aggService.recCandidateDataEvent.subscribe(_res => { this.getExpandFilterData(); this.getTopList(); this.talentDiscoveryHistoryId = _res.talentdiscoveryhistoryid;
      const filterData = this.filterDataHandlerService.fetchFilterData;
      this.locationcontinentsName = filterData.locationcontinents;
     });
    this.subscriptions.push(recommendedCandidateSub);

    this.extraInfo = this.filterDataHandlerService.isRedirectFromTalentInsightsPage || this.filterDataHandlerService.isRedirectFromCompanyInsightsPage ? this.aggService.getRedirectDataV2() : this.aggService.getRedirectData();

    const matrixSelectionSub = this.statsMatrixHandlerService.matrixSelectionEvent.subscribe(matrixFilter => this.setMatrixFilterData(matrixFilter));
    this.subscriptions.push(matrixSelectionSub);

    const typeaheadSub = this.typeAheadSubject.pipe(debounceTime(500)).subscribe(({ event, type }) => {
      this.callTypeAheadSearch(event, type);
    });
    this.subscriptions.push(typeaheadSub);

    const filterDataUpdateSub = this.filterDataHandlerService.filterMethodEvent.subscribe(_el => {
      // console.log('filterDataUpdateSub', JSON.stringify(this.filterDataHandlerService.fetchFilterData));
      if (this.talentInsightsReqHandler.isCompanyInsightsTab)
        this.localstorageservice.setItem(GeneralConstants.LS_KEYS.COMPANY_FILTERS, JSON.stringify(this.filterDataHandlerService.fetchFilterData));
    });
   this.subscriptions.push(filterDataUpdateSub);



    const yoeTypeUpdateEvent = this.filterDataHandlerService.yearsOfExperienceTypeEvent.subscribe(typeData => this.handleYOEUpdateEvent(typeData));
    this.subscriptions.push(yoeTypeUpdateEvent);
    // The above filter dataa from local storage will be used for state management
    if (this.talentInsightsReqHandler.isTalentInsightsTab) {

      const filterData = JSON.parse(this.localstorageservice.getItem(GeneralConstants.LS_KEYS.TALENT_FILTERS));
      // console.log(filterData,this.filterDataHandlerService.fetchFilterData, 'filter data for talent insights');
      this.searchHistoryRegion = filterData?.continentstobeincluded?.length ? filterData?.continentstobeincluded[0] : this.localstorageservice.getItem('talentRegion');

      if (!filterData || _.isEmpty(filterData)) {
        this.filterDataHandlerService.reset();
      } else {
        this.filterDataHandlerService.setFilterData(filterData);
      }
      this.filterData = this.filterDataHandlerService.fetchFilterData;
      // console.log(filterData,'line 662');
      if (this.filterData.jobTitleSelectedList.length > 0) {
        this.getFilterWiseDataToDisplay('jobtitle');
      } if (this.filterData.skillsSelectedList.length > 0) {
        this.getFilterWiseDataToDisplay('skills');
      } if (this.filterData.locationSelectedList.length > 0) {
        this.getFilterWiseDataToDisplay('location');
      }
      if (this.filterData.booleanquery && this.filterData.booleanquery !== "" && this.filterData.booleanquery !== "*") {
        this.keywordInput.patchValue(this.filterData.booleanquery);
        this.keyWordInputValue = this.filterData.booleanquery;
        this.searchDisable = false;
      }
      if(this.filterData.locationcontinents?.length > 0) {
        this.locationcontinentsName = this.filterData.locationcontinents;
      }
      this.syncLocalDataWithFilterObject();
    }

    if (this.talentInsightsReqHandler.isCompanyInsightsTab) {
      if(this.router.url.includes('/company-details')) {
        const filterData = this.aggService.getCompanyInsightsRedirectDataV2();
        if (!filterData || _.isEmpty(filterData)) {
          this.filterDataHandlerService.reset();
        } else {
          this.filterDataHandlerService.setFilterData(filterData);
        }
        this.filterData = this.filterDataHandlerService.fetchFilterData;
        this.syncLocalDataWithFilterObject();
      }

  }
    this.checkGenderSelectionFromInsights();
    this.syncCompanySizeData();
    this.checkGraduationYearFilter();
    this.checkExpYearFilter();
    this.isPersonSearchListingPage = this.filterDataHandlerService.isPersonSearchListingPage();
    this.isTalentInsightsPage = this.filterDataHandlerService.isReportDetailsPage;
    this.isReportDetails = this.filterDataHandlerService.isReportDetailsPage;
    this.isCompanyInsightsDetails = this.filterDataHandlerService.isCompanyInsightsPage;
    this.shouldShowStatusCompany = this.getShouldShowStatusCompany();
    this.isAiSourcingTab = this.aiSourcingService.isAISourcingTab;

    this.filterType = this.route.snapshot.queryParams['filtertype'];
    this.searchKeyword = this.route.snapshot.queryParams['keyword'];
    this.filterValue = this.route.snapshot.queryParams['filtervalue'];
    const searchSource = this.route.snapshot.queryParams['searchSource'];
    this.searchSource = searchSource;
    this.searchTitle = this.route.snapshot.queryParams['title'];
    this.searchCompany = this.route.snapshot.queryParams['company'];
    this.searchChips = this.route.snapshot.queryParams['searchedFrom'];
    this.tabType = this.route.snapshot.queryParams['type'];
    if ((this.filterType == 'searchKeyword' || (searchSource && searchSource == 'history-component')) || this.searchKeyword) {
      this.keywordInput.patchValue(this.searchKeyword !== "*" ? this.searchKeyword : '');
      this.keyWordInputValue = this.searchKeyword;
      this.searchDisable = false;
    }
    if (!this.filterDataHandlerService.isRedirectFromTalentInsightsPage && !this.stopQucksearchAPICall && !searchSource && !this.filterDataHandlerService.isRedirectFromCompanyInsightsPage && !this.jdDataService.isComingFromJobDescription && this.tabType != 'advanced-search' && this.tabType != 'similar-candidate-from-linkedinurl' && this.tabType != 'similar-candidate-resume-upload' && this.tabType != 'job-description' && this.tabType != 'nl-search' && !this.aiSourcingService.isResumeScreenTab && !this.aiSourcingService.isAISourcingTab && !this.similarCandidateService.isListingCalledFromSimilarCandidate) {
      this.showQuickSearchFilters();
    }

    this.personSearchService.getGeoIpLocationOfUser.subscribe((response: any) => {
      this.showregion = this.localstorageservice.getItem('region') ? this.localstorageservice.getItem('region') : response.continent ? response.continent.toLowerCase() : 'asia';
      this.localstorageservice.setItem('region', this.showregion);
    });
    if (searchSource == "history-component") {
        this.saveSearchTalentDiscoveryHistoryId = this.route.snapshot.queryParams.talentdiscoveryhistoryid ? this.route.snapshot.queryParams.talentdiscoveryhistoryid : null;
      if(this.isTalentInsightsPage) {
        this.localstorageservice.setItem('talentInsightsHistoryId', this.saveSearchTalentDiscoveryHistoryId);
      }
      this.searchHistoryRegion = this.sessionStorageService.getItem("historyRegion")
    } else {
      this.searchHistoryRegion = null;
    }

    if (this.isTalentInsightsPage) {
      this.showregion = this.filterData?.continentstobeincluded?.length ? this.filterData?.continentstobeincluded[0] : this.localstorageservice.getItem('talentRegion');;
      this.searchHistoryRegion = this.showregion;
    }
    else if (this.isPersonSearchListingPage) {
      this.showregion = this.localstorageservice.getItem('region');
    }

    if (this.similarCandidateService.isListingCalledFromSimilarCandidate) {
      this.isSimilarCanidate = true;
    }

    // Highlight filter is only present in person search listing
    this.isPersonSearchListingPage && this.highlightOptionsCall();
    const jdFilterUpdateSub = this.jdDataService.jdFilterUpdateObs.subscribe(() => {this.getexpandrefresheddata(null)});
    this.subscriptions.push(jdFilterUpdateSub);

    const similarCandidateUpdateSub = this.similarCandidateService.getSimilarCandidate().subscribe(() => {
      this.getexpandrefresheddata(null)});
    this.subscriptions.push(similarCandidateUpdateSub);
    this.initializeRequestHandling();

    const continentUpdateSub = this.continentHandlerService.continentUpdateObservable.subscribe(continent => {
      if(!this.browserBackEvent) {
        if (!(this.talentInsightsReqHandler.isTalentInsightsTab && this.jdDataService.isComingFromJobDescription)) {
          // Should not trigger if called from talent-insights with jd parameters
          this.selectRegion(continent);
        }
      }
    }
    );
    this.subscriptions.push(continentUpdateSub);

    // Below method calls always need to be last method calls in ngOnInit
    this.filterAppliedOnYearsOfExperience = this.hasYOEExperienceData();
    this.filterAppliedOnCurrentYearsOfExperience = this.hasCurrentYOEExperienceData();
    if(this.filterData.tograduationyear || this.filterData.fromgraduationyear){
      this.getAggregationReport('graduationyear');
    }
    this.handleExpDataFromTIHistory();
    this.saveSearchName = this.route.snapshot.queryParams['saveSearchName'] || this.localstorageservice.getItem('saveSearchName') || null;

       const jdUpdateEvent = this.jdDataService.getInsightsEvent().subscribe((res: any) => {
      if (res.action == 'refresh') {
         const filterData = this.filterDataHandlerService.fetchFilterData;
      this.locationcontinentsName = filterData.locationcontinents;
      this.locationContinents = filterData.continentstobeincluded;
      this.getexpandrefresheddata(null)
      }
    });
    this.subscriptions.push(jdUpdateEvent);

  }

  /**
   * Handle filter and form data for yearsofexperience and currentyearsofexperience
   * when filters are applied and called from talent insights history component.
   * Aggregate call for aggtype response that also used to render experience graph
   * Sync filter data and form data
   */
  handleExpDataFromTIHistory(){
    if (this.filterAppliedOnYearsOfExperience) {
      this.yearsofexperienceFromFilterData = this.yearsofexperienceFrom.value;
      this.yearsofexperienceToFilterData = this.yearsofexperienceTo.value;
      this.getAggregationReport('totalyearsofexperience');
    }
    if (this.filterAppliedOnCurrentYearsOfExperience) {
      this.currenttoyearsofexperienceFilterData = this.currenttoyearsofexperience.value;
      this.currentfromyearsofexperienceFilterData = this.currentfromyearsofexperience.value;
      this.getAggregationReport('currentyearsofexperience');
    }
  }

  /**Redirection on Click of back button */
  backButtonRedirection() {
    let redirectUrl;
    if (this.isPersonSearchListingPage) {
      redirectUrl = '/person/search';
    }
    else if (this.isTalentInsightsPage) {
      redirectUrl = '/talentpool-insights';
    } else if(this.isCompanyComparePage) {
      redirectUrl = '/webbtree-company-list';
    } else if(this.isCalledFromComponent == 'resume-screen') {
       redirectUrl = '/resume-screen';
    }
    this.router.navigateByUrl(redirectUrl);
  }

  private initializeRequestHandling() {
    // if(this.isCalledFromComponent) return; {
    this.requestNotifier$.pipe(
      groupBy(request => request.aggregatetype),
      mergeMap(group => group.pipe(
        switchMap(({ aggregatetype, localRequestObject, updateSelectedList }) => {
          // If there's an active request for this aggregatetype, cancel it
          if (this.activeRequests[aggregatetype]) {
            this.activeRequests[aggregatetype].next(undefined as any);
            this.activeRequests[aggregatetype].complete();
          }

          // Create a new cancel subject for the current request
          this.activeRequests[aggregatetype] = new Subject<void>();
          if(aggregatetype == 'location' && localRequestObject.exclude_locations.length > 0) {
            delete localRequestObject.typeahead;
            delete localRequestObject.input;
            delete localRequestObject.locations;
          }
          let apiCall: Observable<any>;
          if (this.isCalledFromComponent) {
            const projectnumber = this.aiSourcingService.isAISourcingprojectNumber;
            const cdType = this.router.url?.split('/')[3]
            localRequestObject['candidatetype'] = cdType === 'review' ? 'unactioned' : cdType === 'shortlist' ? 'shortlisted' : cdType === 'archive' ? 'archive' : '';
            if(!localRequestObject['candidatetype']) return;
            apiCall = this.aiSourcingService.getAISourcingFilterAgg(projectnumber, localRequestObject)
          } else {
            apiCall = this.personSearchService.getTotalAggs(localRequestObject)
          }

          return apiCall.pipe(
            takeUntil(this.activeRequests[aggregatetype]),
            takeUntil(this.destroy$),
            tap({
              next: (response) => {
                if (response.status === 'success') {
                  this.reportsAggs[aggregatetype] = response.data.aggregations[aggregatetype];
                  const yoeTypes = [
                    "currentyearsofexperience",
                    "totalyearsofexperience",
                    "averageyearsofexperience",
                  ];
                  if (yoeTypes.includes(aggregatetype)) {
                    this.createYOEData(response.data.aggregations, aggregatetype);
                  } else if(aggregatetype === 'graduationyear'){
                    this.createGraduationYearData(response.data.aggregations, aggregatetype);
                  }
                  this.getTopList(updateSelectedList);
                }
              },
              error: error => console.log('Error occurred:', error), // Log errors
              complete: () => console.log('Request for', aggregatetype, 'completed.') // Log completion
            })
          );
        })
      ))
    ).subscribe();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.aiSuggestion && changes.aiSuggestion.currentValue && !changes.aiSuggestion.firstChange) {
      const s: SuggestedTitle[] = changes.aiSuggestion.currentValue;

      /**
       * Process the suggestion and return already applied chips with existing data/state
       * @param s
       * @param userSelectedList
       */
      const processSuggestion = (s: SuggestedTitle[], userSelectedList: any[]) => {
        return s.map(s => {
          const isAlreadyApplied = userSelectedList.find(j => j.chipkey == s.name && j.isSuggested)
          if (isAlreadyApplied) {
            return Object.assign({}, s, { isSuggested: true, suggestedTitle: s, isExcluded: isAlreadyApplied.isExcluded, isMandatory: isAlreadyApplied.isMandatory, chipkey: isAlreadyApplied.chipkey, chipvalue: isAlreadyApplied.chipvalue, key: isAlreadyApplied.key })
          } else {
            return Object.assign({}, s, { isSuggested: true, suggestedTitle: s, isExcluded: false, isMandatory: false, chipkey: s.name, chipvalue: s.name, key: s.name })
          }
        }).filter(Boolean);
      }

      // process title
      const titleSuggestion = s.filter(s => s.type == 'title');
      const userSelectedTitle = this.jobTitleSelectedList.filter(j => !j.isSuggested);
      const aiSuggestedTitles = processSuggestion(titleSuggestion, userSelectedTitle);
      const combiledTitles = [].concat(aiSuggestedTitles, userSelectedTitle);
      this.jobTitleSelectedList = _.uniq(combiledTitles, 'chipkey');

      // process skill
      const skillSuggestion = s.filter(s => s.type == 'skill');
      const userSelectedSkill = this.skillsSelectedList.filter(j => !j.isSuggested);
      const aiSuggestedSkills = processSuggestion(skillSuggestion, userSelectedSkill);
      const combiledSkills = [].concat(aiSuggestedSkills, userSelectedSkill);
      this.skillsSelectedList = _.uniq(combiledSkills, 'chipkey');


      this.syncFilterData();
      this.filterDataHandlerService.setFilterData(this.filterData);
      this.aggReqObjectHandlerService.setStartIndex(0);
      this.aggService.getPersonSearchRecommendedCandidates(this.extraInfo);
      this.getexpandrefresheddata('jobtitle');
      this.getexpandrefresheddata('skills');
      this.aggReqObjectHandlerService.setStartIndex(0);
      this.filterDataHandlerService.emitfilterMethodObject({ methodName: "selectedItem", filterType: 'jobtitle'  });
    }
  }

  /**
   * Used to form array of objects for highlights filters on the basis of data got from backend.
   */
  highlightOptionsCall() {
    this.personSearchService.getHighlightsOptions().subscribe((res: any) => {
      if (res?.data && Array.isArray(res.data)) {
        this.highLightOptions = this.highlightOptionsObjectFormation(res.data);
      }
    })
  }

  /**
   * Used to form array of Object for highlights filter on the basis of backend data and Map them with label, color and id;
   * @param data array of values of filters
   */
  highlightOptionsObjectFormation(data: string[]) {

    const highlight = [];
    data && data.length && data.map(x => {
      if (x === 'Unicorns') {
        highlight.push(
          { id: 1, label: 'Unicorn Experience', value: `${x}`, color: 'yellow', imageName: 'unicorn' }
        )
      } else if (x === 'Techie') {
        highlight.push(
          { id: 2, label: 'Techie', value: `${x}`, color: 'green', imageName: 'techie' }
        )
      } else if (x === 'Fortune-500') {
        highlight.push(
          { id: 3, label: 'Fortune 500 Experience', value: `${x}`, color: 'fortune', imageName: 'fortune500' }
        )
      } else if (x === 'Tier-1 School') {
        highlight.push(
          { id: 4, label: 'Tier 1 School', value: `${x}`, color: 'teal', imageName: 'tier1school' }
        )
      } else if (x === 'C9 League (China)') {
        highlight.push(
          { id: 5, label: 'C9 League (China)', value: `${x}`, color: 'c9League', imageName: 'c9' }
        )
      } else if (x === 'Ivy League (USA)') {
        highlight.push(
          { id: 6, label: 'Ivy League (USA)', value: `${x}`, color: 'ivy', imageName: 'ivy' }
        )
      } else if (x === 'Group of Eight (Australia)') {
        highlight.push(
          { id: 7, label: 'Group of Eight (Australia)', value: `${x}`, color: 'groupOfEight', imageName: 'go8' }
        )
      } else if (x === 'Russell Group (UK)') {
        highlight.push(
          { id: 8, label: 'Russell Group (UK)', value: `${x}`, color: 'russellGroup', imageName: 'russell' }
        )
      } else if (x === 'MAANG') {
        highlight.push(
          { id: 9, label: 'MAANG', value: `${x}`, color: 'maang', imageName: 'maang' }
        )
      } else if (x === 'DAX 40') {
        highlight.push(
          { id: 10, label: 'DAX 40', value: `${x}`, color: 'dax', imageName: 'dax40' }
        )
      } else if (x === 'NASDAQ 100') {
        highlight.push(
          { id: 11, label: 'NASDAQ 100', value: `${x}`, color: 'nasdaq', imageName: 'nasdaq100' }
        )
      } else if (x === 'Nifty 50 / Sensex') {
        highlight.push(
          { id: 12, label: 'Nifty 50 / Sensex', value: `${x}`, color: 'nifty', imageName: 'nifty50' }
        )
      } else if (x === 'Fortune Global 500') {
        highlight.push(
          { id: 13, label: 'Fortune Global 500', value: `${x}`, color: 'fortuneGlobal', imageName: 'fortuneglobal500' }
        )
      } else if (x === 'S&P 500') {
        highlight.push(
          { id: 14, label: 'S&P 500', value: `${x}`, color: 'sp', imageName: 'sp500' }
        )
      } else if (x === 'Big Four') {
        highlight.push(
          { id: 15, label: 'Big 4', value: `${x}`, color: 'bigfour', imageName: 'big4' }
        )
      } else if (x === 'DOW 30') {
        highlight.push(
          { id: 16, label: 'DOW 30', value: `${x}`, color: 'dow', imageName: 'dow30' }
        )
      } else if (x === 'Fortune 500') {
        highlight.push(
          { id: 17, label: 'Fortune 500', value: `${x}`, color: 'fortune', imageName: 'fortune500' }
        )
      } else if (x === 'Big Oil') {
        highlight.push(
          { id: 18, label: 'Big Oil', value: `${x}`, color: 'bigoil', imageName: 'bigoil' }
        )
      } else if (x === 'FTSE 100') {
        highlight.push(
          { id: 19, label: 'FTSE 100', value: `${x}`, color: 'ftse', imageName: 'ftse100' }
        )
      } else if (x === 'U15 Group (Canada)') {
        highlight.push(
          { id: 20, label: 'U15 Group (Canada)', value: `${x}`, color: 'u15group', imageName: 'u15' }
        )
      } else if (x === 'BATX') {
        highlight.push(
          { id: 21, label: 'BATX', value: `${x}`, color: 'batx', imageName: 'batx' }
        )
      }
    })
    return highlight;
  }

  /**
   * On change on highlights checkbox
   * @param event event of highlight checkbox
   */
  onChangeHighlights(event) {
    this.highlightsSelectedList = this.highLightOptions.filter(x => event.value.includes(x.id))
    this.highlightSelectedControl = _.pluck(this.highlightsSelectedList, 'id');
    this.selectedItem('highlights', null);
  }

  /**
 * Getter to know either current region is europe or not
 */
  get isLocationEurope() {
    if (this.sessionStorageService.getItem('historyRegion')) {
      return this.sessionStorageService.getItem('historyRegion') == 'europe';
    } else
      return this.localstorageservice.getItem('region') == 'europe';
  }

  private getShouldShowStatusCompany() {
    return !this.extraInfo?.redirectData?.additionalFilters?.recentcompanyhires;
  }

  private checkGenderSelectionFromInsights() {
    const redirectDataTI = this.aggService.getTalentInsightsRedirectDataV2();
    // TODO : May need to handle same for company insights as well later
    if (this.extraInfo?.redirectSource === 'talent-insights' && ["male", "female"].includes(redirectDataTI.gender?.toLowerCase())) {
      this.gender = redirectDataTI.gender;
      this.isGenderSelected = true;
      this.isGenderSelectionDisabled = true;
      this.filterDataHandlerService.setGender(redirectDataTI.gender);
    }
  }

  checkGraduationYearFilter() {
    if (this.extraInfo?.redirectSource === 'talent-insights') {
      const redirectDataTI = this.aggService.getTalentInsightsRedirectDataV2();
      this.graduationYearRange.min = parseInt((redirectDataTI.fromgraduationyear || this.graduationYearRange.min ).toString());
      this.graduationYearRange.max = parseInt((redirectDataTI.tograduationyear || this.graduationYearRange.max).toString());
    } else if (this.extraInfo?.redirectSource == 'company-insights') {
      const redirectDataCI = this.aggService.getCompanyInsightsRedirectDataV2();
      this.graduationYearRange.min = parseInt((redirectDataCI?.fromgraduationyear || this.graduationYearRange.min).toString());
      this.graduationYearRange.max = parseInt((redirectDataCI?.tograduationyear || this.graduationYearRange.max).toString());
    }
  }
  /**
   * Set range of years of experience filter on redirection
   */
  checkExpYearFilter() {
    if (this.extraInfo?.redirectSource === 'talent-insights') {
      const redirectDataTI = this.aggService.getTalentInsightsRedirectDataV2();
      this.experienceYearRange.min = (typeof redirectDataTI.yearsofexperienceFrom == 'number' || typeof redirectDataTI.yearsofexperienceFrom == 'string') ? parseInt((redirectDataTI.yearsofexperienceFrom || this.experienceYearRange.min ).toString()) : null;
      this.experienceYearRange.max = (typeof redirectDataTI.yearsofexperienceTo == 'number' || typeof redirectDataTI.yearsofexperienceTo == 'string') ? parseInt((redirectDataTI.yearsofexperienceTo || this.experienceYearRange.max ).toString()) : null;
    } else if (this.extraInfo?.redirectSource == 'company-insights') {
      const redirectDataCI = this.aggService.getCompanyInsightsRedirectDataV2();
      this.experienceYearRange.min = (typeof redirectDataCI.yearsofexperienceFrom == 'number' || typeof redirectDataCI.yearsofexperienceFrom == 'string') ? parseInt((redirectDataCI.yearsofexperienceFrom || this.experienceYearRange.min ).toString()) : null;
      this.experienceYearRange.max = (typeof redirectDataCI.yearsofexperienceTo == 'number' || typeof redirectDataCI.yearsofexperienceTo == 'string') ? parseInt((redirectDataCI.yearsofexperienceTo || this.experienceYearRange.max ).toString()) : null;
    }
  }

  private syncCompanySizeData() {
    const redirectDataTI = this.aggService.getTalentInsightsRedirectDataV2();
    const companySizeTI = "talent-insights" === this.extraInfo.redirectSource && redirectDataTI.companysize?.length ? _.flatten(redirectDataTI.companysize) : [];
    if (this.filterDataHandlerService.isPersonSearchListingPage() && companySizeTI?.length) {
      this.companySizeOption = companySizeTI;
    }
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(sub => sub.unsubscribe());
    this.subscriptionsLike.forEach(sub => sub.unsubscribe());
    // we are resetting the data so that we do not propogate the filter changes into other unwanted components
  //  if(!this.router.url.includes('/company-details')) {
      this.filterDataHandlerService.reset();
     // this.localstorageservice.setItem(GeneralConstants.LS_KEYS.COMPANY_FILTERS, JSON.stringify(this.filterDataHandlerService.fetchFilterData));
    //}

    this.destroy$.next(undefined as any);
    this.destroy$.complete();

  }

  getFilterWiseDataToDisplay(filterName: string, callApi = false) {
if(window.location.pathname?.includes('/ai-sourcing/ai-sourcing-profiles/activity')) return;
    if (filterName === "jobtitle") {
      if (this.aiQuery && !callApi && !this.aiSourcingService.isAISourcingTab) return;
      this.jobTitleStatus === CallStage.CURRENT_OR_PAST.toString() && this.getAggregationReport("jobtitle", callApi);
      this.jobTitleStatus === CallStage.CURRENT.toString() && this.getAggregationReport("current_jobtitle", callApi);
      this.jobTitleStatus === CallStage.PAST.toString() && this.getAggregationReport("pastjobtitle", callApi);
    }
    else if (filterName === "location") { this.getAggregationReport('location_name-location_continent'); }
    else if (filterName === "skills") {
      if (this.aiQuery && !callApi && !this.aiSourcingService.isAISourcingTab) return;
      this.getAggregationReport('skills', callApi);
    }
    else if (filterName === "company") {
      if (this.companyAiSuggestions.length && !this.aiSourcingService.isAISourcingTab) return;
      this.companyStatus === CallStage.CURRENT_OR_PAST.toString() && this.getAggregationReport('company');
      this.companyStatus === CallStage.CURRENT.toString() && this.getAggregationReport('current_company');
      this.companyStatus === CallStage.PAST.toString() && this.getAggregationReport('pastcompany');
    }
    else if (filterName === "company_size") {
      this.getAggregationReport('companysizes');
      this.getAggregationReport('current_companysizes');
    }
    else if (filterName === "industries" || filterName === "industry") {
      this.industryStatus === CallStage.CURRENT_OR_PAST.toString() && this.getAggregationReport('industry');
      this.industryStatus === CallStage.CURRENT.toString() && this.getAggregationReport('current_industry');
      this.industryStatus === CallStage.PAST.toString() && this.getAggregationReport('pastindustry');
    }
    else if (filterName === "yearsofexperience") {
      this.yearsofexperience === "Total" && this.getAggregationReport('totalyearsofexperience');
      this.yearsofexperience === "Average" && this.getAggregationReport('averageyearsofexperience');
    }
    else if (filterName === "gender") { this.getAggregationReport('gender'); }
    else if (filterName === "education") { this.getAggregationReport('education'); }
    else if (filterName === "school") { this.getAggregationReport('school'); }
    else if (filterName === "field_of_study") { this.getAggregationReport('fieldofstudy'); }
    else if (filterName === "likely_to_move_in") { this.getAggregationReport('likelytomove'); }
    else if (filterName === "function") {
      this.functionStatus === CallStage.CURRENT_OR_PAST.toString() && this.getAggregationReport('function');
      this.functionStatus === CallStage.CURRENT.toString() && this.getAggregationReport('current_function');
      this.functionStatus === CallStage.PAST.toString() && this.getAggregationReport('pastfunction');
    }
    else if (filterName === "currentyearsofexperience") { this.getAggregationReport('currentyearsofexperience'); }
    else if (filterName === 'schoollocation') { this.getAggregationReport('school_location') }
    else if (filterName === "seniority") { console.log("No need to call further APIs for ", filterName); }
    else if (filterName === "keyword") {
      console.log('Not calling any APIs on collapse of ', filterName);
      // this.getKeywordTypeaheads();
    }
    else if (filterName === "changedjobs") { }
    else if (filterName === this.filterNames.PAST_JOB_TITLE) {
      if (this.aiQuery && !callApi) return;
      this.getAggregationReport(this.filterNames.PAST_JOB_TITLE, callApi);
    }
    else if(filterName === 'graduationYear'){
      this.getAggregationReport('graduationyear');
    }
    else { console.log("invalid filterName for getFilterWiseDataToDisplay method - ", filterName); }
  }

  // private getKeywordTypeaheads() {
  //   this.personSearchService.getPersonSearchListing('a').subscribe((response: any) => {
  //     if (response.status === 'success') {
  //       this.keywordlist = response.data;
  //     }
  //   });
  // }

  getAggregationReport(aggregatetype: string, updateSelectedList = false) {
    const localRequestObject = this.aggService.getRequestWithFilters(this.extraInfo);
    if (this.talentInsightsReqHandler.isCompanyInsightsTab && !this.router.url.includes('/company-compare')) {
      localRequestObject.companies = this.companyInsightsService.fetchCompanyData?.alternative_names?.length > 0 ? this.companyInsightsService.fetchCompanyData.alternative_names.concat([this.companyInsightsService.fetchCompanyData.name]) : [this.companyInsightsService.fetchCompanyData.name];
      localRequestObject['companyids'] = [this.companyInsightsService.fetchCompanyData.id]
      localRequestObject['calledvia'] = "companypages"
    }
    const type = this.route.snapshot.queryParams['type'];
    const searchSource = this.route.snapshot.queryParams['searchSource'];


    this.addTypeAheads(aggregatetype, localRequestObject);
    if (this.similarCandidateService?.isListingCalledFromSimilarCandidate || type == 'quick-search' || ((searchSource && searchSource == 'history-component') && this.searchKeyword)) {
      localRequestObject['calledfrom'] = 'listing';
      localRequestObject['continentstobeincluded'] = this.locationContinents;
    }
    // this.personSearchService
    //   .getTotalAggs(localRequestObject)
    //   .subscribe((response) => {
    //     if (response.status == "success") {
    //       this.reportsAggs[aggregatetype] = response.data.aggregations[aggregatetype];
    //       const yoeTypes = [
    //         "currentyearsofexperience",
    //         "totalyearsofexperience",
    //       "averageyearsofexperience",
    //       ];
    //       if (yoeTypes.includes(aggregatetype)) { this.createYOEData(response.data.aggregations, aggregatetype); }
    //     }
    //   })
    //   .add(() => this.getTopList(updateSelectedList));

    this.requestNotifier$.next({ aggregatetype, localRequestObject, updateSelectedList });
  }

  /**
  * If user will only select one value and apply, then other value will automatically set to end point of range (0-40)
  */
  setExperienceFormData(type) {
    if (type == 'yearsofexperience' || type == 'all') {
      if (!(this.yearsofexperienceFrom.value != null && this.yearsofexperienceTo.value != null) && (this.yearsofexperienceFrom.value != null || this.yearsofexperienceTo.value != null)) {
        if (this.yearsofexperienceFrom.value == null) {
          this.yearsofexperienceFrom.setValue(0);
        } else if (!this.yearsofexperienceTo.value) {
          this.yearsofexperienceTo.setValue(40);
        }
      }
    }

    //If user will only select one value and apply, then other value will automatically set to end point of range (0-40)
    if (type == 'currentyearsofexperience' || type == 'all') {
      if (!(this.currentfromyearsofexperience.value != null && this.currenttoyearsofexperience.value != null) && (this.currentfromyearsofexperience.value != null || this.currenttoyearsofexperience.value != null)) {
        if (this.currentfromyearsofexperience.value == null) {
          this.currentfromyearsofexperience.setValue(0);
        } else if (!this.currenttoyearsofexperience.value) {
          this.currenttoyearsofexperience.setValue(40);
        }
      }
    }
  }

  /**Used to check for from and to value should be valid and in given range */
  getCurrentYearsValidation() {
    return (
      this.currentfromyearsofexperience.value == null && this.currenttoyearsofexperience.value == null
    ) || (
        (this.currentfromyearsofexperience.value != null && this.currenttoyearsofexperience.value != null) &&
        (this.currentfromyearsofexperience.value > this.currenttoyearsofexperience.value)
      ) || this.currentfromyearsofexperience.value < 0 || this.currentfromyearsofexperience.value > 40 ||
      (this.currenttoyearsofexperience.value > 40) ||
      (this.currenttoyearsofexperience.value != null && this.currenttoyearsofexperience.value < 1)
  }

  /**Used to check for from and to value should be valid and in given range */
  getYearsOfExperienceValidation() {
    return (this.yearsofexperienceTo.value == null && this.yearsofexperienceFrom.value == null) ||
      ((this.yearsofexperienceTo.value != null && this.yearsofexperienceFrom.value != null) &&
        (this.yearsofexperienceFrom.value > this.yearsofexperienceTo.value)) || this.yearsofexperienceFrom.value < 0 || this.yearsofexperienceFrom.value > 40 || this.yearsofexperienceTo.value > 40 || (this.yearsofexperienceTo.value != null && this.yearsofexperienceTo.value < 1)
  }

  validGraduationYears(){
    if(this.tograduationyearFilter && this.fromgraduationyearFilter){
      return this.fromgraduationyearFilter <= this.tograduationyearFilter;
    }
    return true;
  }

  /**
   * Used to fill value of other field when one is selected
   */
  onOptionChangeGraduationFilter(value, type){
    if(type == 'fromgraduationyearFilter'){
      if(value && !this.tograduationyearFilter){
        this.tograduationyearFilter = value;
      }
    }
    else if(type == 'tograduationyearFilter'){
      if(value && !this.fromgraduationyearFilter){
        this.fromgraduationyearFilter = value;
      }
    }
  }

  applyFilter(type) {
    this.syncFilterData();
    this.filterDataHandlerService.setFilterData(this.filterData);

    if (type === 'yearsofexperience') {
      this.setExperienceFormData('yearsofexperience');
      const fromExperience = parseInt(this.yearsofexperienceFrom.value);
      const toExperience = parseInt(this.yearsofexperienceTo.value);
      if (!isNaN(fromExperience) && !isNaN(toExperience)) {
        if (fromExperience <= toExperience) {
          this.yearsofexperienceFromFilterData = this.yearsofexperienceFrom.value;
          this.yearsofexperienceToFilterData = this.yearsofexperienceTo.value;
          this.filterAppliedOnYearsOfExperience = true;
        } else {
          console.error('fromyearsofexperience should be less than toyearsofexperience. type = ', type);
        }

        this.syncFilterData();
        this.filterDataHandlerService.setFilterData(this.filterData);
        this.yearsofexperience === "Total" ? this.getAggregationReport("totalyearsofexperience") : this.getAggregationReport("averageyearsofexperience");
      }
    } else if (type === 'currentyearsofexperience') {
      this.setExperienceFormData('currentyearsofexperience');
      const currentfromExperience = parseInt(this.currentfromyearsofexperience.value);
      const currenttoExperience = parseInt(this.currenttoyearsofexperience.value);
      if (!isNaN(currentfromExperience) && !isNaN(currenttoExperience)) {
        if (currentfromExperience <= currenttoExperience) {
          this.filterAppliedOnCurrentYearsOfExperience = true;
          this.currenttoyearsofexperienceFilterData = this.currenttoyearsofexperience.value;
          this.currentfromyearsofexperienceFilterData = this.currentfromyearsofexperience.value;
        } else {
          console.error('fromyearsofexperience should be less than toyearsofexperience. type = ', type);
        }

        this.syncFilterData();
        this.filterDataHandlerService.setFilterData(this.filterData);
        this.getAggregationReport("currentyearsofexperience");
      }
    }

    if(type === 'graduationYears'){
      console.log('this.tograduationyearFilter', this.tograduationyearFilter);
      console.log('this.fromgraduationyearFilter', this.fromgraduationyearFilter);
        this.isGraduationFilterApplied = true;
        this.syncFilterData();
        this.filterDataHandlerService.setFilterData(this.filterData);
        this.getAggregationReport("graduationyear");
    }

    this.aggReqObjectHandlerService.setStartIndex(0);
    // We need both calls here for proper working
    this.syncFilterData();
    this.filterDataHandlerService.setFilterData(this.filterData);
    this.getexpandrefresheddata(type);
    this.aggReqObjectHandlerService.setStartIndex(0);
    this.filterDataHandlerService.emitfilterMethodObject({ methodName: "applyFilter", filterType: type });
    this.setFilterDataInLocalStorage();
    this.filterDataHandlerService.shouldSendPersonSearchRequest() && this.aggService.getPersonSearchRecommendedCandidates(this.extraInfo);
    this.isSearchSaved = false;
    this.setTalentInsightsHistory();
  }

  private createYOEData(aggregationResponse, aggregatetype: string) {
    const aggregations = Object.assign({}, aggregationResponse);
    const CharForYearsOfExperience = [];
    aggregations[aggregatetype] && aggregations[aggregatetype].forEach((x) => {
      let dataObj = {
        label: `${x.key}`,
        value: x.doc_count,
        tooltext: `${x.key} <br> Talent count: ${x.doc_count}`,
      };
      CharForYearsOfExperience.push(dataObj);
    });

    if (aggregatetype === "averageyearsofexperience" || aggregatetype === "totalyearsofexperience") {
      this.dataSourceYearsOfExperience = {
        dataFormat: "json",
        height: 14,
        width: 14,
        chart: {
          renderAt: "chart-container",
          paletteColors: "#F4AB33",
          captionFontColor: "#F4AB33",
          showPercentValues: "1",
          yAxisNameFontColor: "#F4AB33",
          legendPosition: "right",
          theme: "fusion",
          labelFont: "Poppins",
          legendItemFont: "Poppins",
          baseFont: "Poppins",
          baseFontSize: "11",
          drawanchors: "0",
          showToolTip: "1",
          showValues: "0",
          showYAxisValues: "0",
        },
        data: CharForYearsOfExperience,
      };
    } else if (aggregatetype === "currentyearsofexperience") {
      this.dataSourceCurrentYearsOfExperience = {
        type: "bar2d",
        dataFormat: "json",
        height: 14,
        width: 14,
        chart: {
          renderAt: "chart-container",
          paletteColors: "#F4AB33",
          captionFontColor: "#F4AB33",
          showPercentValues: "1",
          yAxisNameFontColor: "#F4AB33",
          theme: "fusion",
          labelFont: "Poppins",
          legendItemFont: "Poppins",
          baseFont: "Poppins",
          baseFontSize: "11",
          showYAxisValues: "0",
          drawanchors: "0",
          showToolTip: "1",
          showValues: "0",
        },
        data: CharForYearsOfExperience
      };
    }
  }

  private createGraduationYearData(aggregationResponse, aggregatetype: string) {
    const aggregations = Object.assign({}, aggregationResponse);
    const CharForYearOfGraduation = [];
    aggregations[aggregatetype] && aggregations[aggregatetype].forEach((x) => {
      const year = moment(x.key_as_string).format("YYYY");
      if(parseInt(year) > this.graduationYearRange.max || parseInt(year) < this.graduationYearRange.min){
        return;
      }
      let dataObj = {
        label: year,
        value: x.doc_count,
        tooltext: `Year: ${year} <br> Talent count: ${x.doc_count}`,
      };
      CharForYearOfGraduation.push(dataObj);
    });

      this.dataSourceGraduationYears = {
        dataFormat: "json",
        height: 14,
        width: 14,
        chart: {
          renderAt: "chart-container",
          paletteColors: "#F4AB33",
          captionFontColor: "#F4AB33",
          showPercentValues: "1",
          yAxisNameFontColor: "#F4AB33",
          legendPosition: "right",
          theme: "fusion",
          labelFont: "Poppins",
          legendItemFont: "Poppins",
          baseFont: "Poppins",
          baseFontSize: "11",
          drawanchors: "0",
          showToolTip: "1",
          showValues: "0",
          showYAxisValues: "0",
        },
        data: CharForYearOfGraduation,
      };
  }


  clearFilters(type: string, source?: string) {
    const tempContinentStore = this.filterData.continentstobeincluded; // Variable used to temporarily store continent from history after reset all filters in talent-insights
    const resetAITitleList = [];
    this.filterDataHandlerService.reset(type);
    this.filterData = this.filterDataHandlerService.fetchFilterData;
    if (this.isTalentInsightsPage) {
      this.filterData.continentstobeincluded = tempContinentStore;
      if(!this.jdDataService.isComingFromJobDescription)
      source = 'all';
    }

    if (type === 'all' || type === 'overall' || type === 'allfilters') {
      this.overallMatchFilters = [];
      const allCheckbox = document.getElementById('overAllMatch') as HTMLInputElement;
      if (allCheckbox) allCheckbox.checked = false;
      this.matchTypes.forEach(match => {
        const elements = document.getElementsByName(match) as NodeListOf<HTMLInputElement>;
        elements.forEach(el => el.checked = false);
      });
    }
    if(type === 'all' || type == 'graduationYears' || type == 'allfilters'){
      this.tograduationyearFilter = null;
      this.fromgraduationyearFilter = null;
      this.isGraduationFilterApplied = false;
    }

    if (type === "all" || type === "positionhierarchy" || type === "allfilters") {
      this.positionhierarchy = []; }
    if (type === 'all' || type === 'highlight' || type === 'allfilters') {
      this.highlightsSelectedList = [];
      this.highlightSelectedControl = [];
    }

    if (type === "all" || type === "jobtitle" || type === "allfilters") {
      this.jobTitleSelectedList.forEach(value => {
        if (value && value.isSuggested) {
          value.suggestedTitle.selected = false;
          resetAITitleList.push(value);
        }
      });
      this.jobTitleSelectedList = [];
      this.jobTitleStatus = CallStage.CURRENT.toString();
    }
    if (type === "all" || type === "location" || type === "allfilters") {
      this.locationSelectedList = [];

      this.locationDistanceRange = '20';
      this.locationDistanceUnit = 'kilometers'

      this.locationDistanceRangeForFilterData = null;
      this.locationDistanceUnitForFilterData = null;
      this.wholeNumberForDistance = true;
      const filterData = this.filterDataHandlerService.fetchFilterData;
      this.locationContinents = filterData.continentstobeincluded;
      this.locationcontinentsName = filterData.locationcontinents;
      this.locationcontinentsName = _.reject(this.locationcontinentsName, {calledFrom: 'Filter'} )
        this.locationContinents = _.uniq(_.pluck(this.locationcontinentsName, 'continent'));
        this.filterData.locationcontinents = this.locationcontinentsName;
        this.filterData.continentstobeincluded = this.locationContinents?.length ? this.locationContinents : [this.localstorageservice.getItem('defaultContinent')];

      this.filterDataHandlerService.setFilterData(this.filterData);
    }
    if (type === "all" || type === "company" || type === "allfilters") {
      this.companySelectedList = [];
      this.companyStatus = CallStage.CURRENT.toString();
    }
    if (type === "all" || type === "industry" || type === "allfilters") {
      this.industrySelectedList = [];
      this.industryStatus = CallStage.CURRENT.toString();
    }
    if (type === "all" || type === "education" || type === "allfilters") { this.educationSelectedList = []; }
    if (type === "all" || type === "fieldofstudy" || type === "allfilters") { this.fieldOfStudySelectedList = []; }
    if(type === 'all' || type == 'fullname' || type == 'allfilters') this.fullNameSelectedList = [];
    if (type === "all" || type === "gender" || type === "allfilters") {
      this.gender = 'All';
      this.isGenderSelected = false;
      const matrixFilter = new MatrixFilter('gender', {
        target: {
          value: "All"
        }
      });
      // If gender selection is disabled then we should not be able to edit the gender data
      !this.isGenderSelectionDisabled && this.statsMatrixHandlerService.emitFilterMatrixObject(matrixFilter);
      this.checkGenderSelectionFromInsights();
    }
    if (type === "all" || type === "school" || type === "allfilters") { this.schoolSelectedList = []; }
    if (type === "all" || type === "companysize" || type === "allfilters") {
      this.companysize = [];
      this.isCompanySizeSelected = false;
    }
    if (type === "all" || type === "yearsofexperience" || type === "allfilters") {
      this.yearsofexperienceFrom.setValue(null);
      this.yearsofexperienceTo.setValue(null);
      this.filterAppliedOnYearsOfExperience = false;
      this.yearsofexperienceFrom.setValidators([Validators.required, Validators.min(0)]);
      this.yearsofexperienceTo.setValidators([Validators.required, Validators.min(0)]);
      this.yearsofexperience = 'Total';
      this.yearsofexperienceFromFilterData = null;
      this.yearsofexperienceToFilterData = null;
    }
    if (type === "all" || type === "skills" || type === "allfilters") {
      this.skillsSelectedList.forEach(value => {
        if (value && value.isSuggested) {
          value.suggestedTitle.selected = false;
          resetAITitleList.push(value);
        }
      });
      this.skillsSelectedList = [];
    }
    if (type === "all" || type === "likelytomovein" || type === "allfilters") {
      this.filterLikelyToMoveIn = 'All';
      this.candidateslikelytomove = 'All';
      this.isLikelyToMoveInFilterSelected = false;
      const matrixFilter = new MatrixFilter('likelytomovein', {
        target: {
          value: this.isLikelyToMoveInFilterSelected ? 'Yes' : 'All'
        }
      });
      this.statsMatrixHandlerService.emitFilterMatrixObject(matrixFilter);
    }
    if (type === "all" || type === "seniority" || type === "allfilters") { this.seniority = []; }
    if (type === "all" || type === "functions" || type === "allfilters") { this.functionSelectedList = []; }

    if (type === "all" || type === "keyword" || type === "allfilters") { this.keywordSelectedList = []; }
    if (type === "all" || type === "currentyearsofexperience" || type === "allfilters") {
      this.currentfromyearsofexperience.setValue(null);
      this.currenttoyearsofexperience.setValue(null);
      this.filterAppliedOnCurrentYearsOfExperience = false;
      this.currentfromyearsofexperience.setValidators([Validators.required, Validators.min(0)]);
      this.currenttoyearsofexperience.setValidators([Validators.required, Validators.min(0)]);
      this.currenttoyearsofexperienceFilterData = null;
      this.currentfromyearsofexperienceFilterData = null;
    }
    if (type === "yearsofexperience" || type === "allfilters") { this.getAggregationReport("totalyearsofexperience"); }
    if (type === "currentyearsofexperience" || type === "allfilters") { this.getAggregationReport("currentyearsofexperience"); }
    // if (type === "all" || type === "changedjobs") { this.changedJobStatus = 'All'; }
    if (type === "all" || type === "changedjobs" || type === "allfilters") {
      this.changedJobStatus = 'All';
      this.changedJobStatusMatrix = 'All';
      this.changedJobStartDuration = 0;
      this.changedJobEndDuration = 12;
      this.changedJobDuration = null;
      this.aggService.changeJobResetEmit();
    }
    if (type === "all" || type === this.filterNames.PAST_JOB_TITLE || type === "allfilters") { this.pastJobTitleSelectedList = []; }

    if (type == 'search' || type == 'all' || type === "allfilters") {
      this.keywordInput.patchValue(null); this.searchKeyword = ''; this.syncFilterData();
      this.keyWordInputValue = '';
      this.filterDataHandlerService.setFilterData(this.filterData);
      // this.router.navigate([], {
      //   relativeTo: this.route,
      //   queryParams: {
      //     keyword: null,
      //     filtertype: null,
      //     filtervalue: null
      //   },
      //   queryParamsHandling: 'merge',
      // });
    }

    if (type === "all" || type === 'schoollocation' || type === "allfilters") { this.schoolLocationSelectedList = []; }

    if (type === 'all' || type === 'locationRange' || type === "allfilters") {
      this.locationDistanceRange = '20';
      this.locationDistanceUnit = 'kilometers';

      this.locationDistanceRangeForFilterData = null;
      this.locationDistanceUnitForFilterData = null;
    }


    this.filterDataHandlerService.pushAISuggestionData(resetAITitleList);
    if (source === 'tabChange') {
      this.hideExpandSuggession();
    } else {
      this.getexpandrefresheddata(type);
    }

    if (this.areAllFiltersCleared() && (!this.jdDataService.isComingFromJobDescription && !this.jdDataService.isComingFromNLSearch && !this.isSimilarCanidate && this.redirectSource != 'talent-insights' && this.redirectSource != 'company-insights')) {
      this.filterEvent.emit('allfilters');
    }
    this.aggReqObjectHandlerService.setStartIndex(0);
    this.filterDataHandlerService.emitfilterMethodObject({ methodName: "clearFilters", source: source, filterType: type });
    this.setFilterDataInLocalStorage();
    this.filterDataHandlerService.shouldSendPersonSearchRequest() && type != 'allfilters' && this.aggService.getPersonSearchRecommendedCandidates(this.extraInfo);

    this.isSearchSaved = false
    this.setTalentInsightsHistory();
  }

  /**
   *
   * This method is called each time get person search recommended candidate API is called.
   *
   */
  getTopList(updateSelectedList: boolean = false) {
    // I have removed the code to delete the typeahead params because we are not editing the original object anyways
    this.jobTitleTopList = (this.jobTitleStatus == CallStage.CURRENT.toString() ? this.reportsAggs?.current_jobtitle : this.jobTitleStatus == CallStage.PAST.toString() ? this.reportsAggs?.pastjobtitle : this.reportsAggs?.jobtitle) || [];
    this.jobTitleTopList = (this.extraInfo.redirectSource == 'talent-insights' || this.extraInfo.redirectSource == 'company-insights') && this.extraInfo.redirectData?.mandatoryjobtitles ? this.jobTitleTopList.filter(j => !this.extraInfo.redirectData?.mandatoryjobtitles.includes(j.key)) : this.jobTitleTopList;
    this.jobTitleTopList = this.jobTitleTopList.filter(jobTitle => !this.jobTitleSelectedList.some(selectedJobTitle => selectedJobTitle.chipkey.toLowerCase() == jobTitle.key.toLowerCase()));
    if (updateSelectedList) {
      const titlesToBeUpdated = [];
      let noOfSuggestionsToAdd = 5 - (this.aiSuggestedTitles ? this.aiSuggestedTitles.length : 0);
      noOfSuggestionsToAdd && this.jobTitleTopList.forEach((jobTitle) => {
        if (noOfSuggestionsToAdd) {
          const isTitlePresent = this.aiSuggestedTitles.find(j => j.name.toLowerCase() == jobTitle.key.toLowerCase());
          if (!isTitlePresent) {
            titlesToBeUpdated.push({ name: jobTitle.key, selected: false, type: 'title', key: this.getSafeKey(jobTitle.key) });
            noOfSuggestionsToAdd--;
          }
        }
      });
      this.showOpenAITitleSuggestions += titlesToBeUpdated.length;
      this.updatedAiTitleChips.emit(titlesToBeUpdated);
    }
    this.jobTitleTopList = this.jobTitleTopList.slice(0, 5);

    this.pastJobTitleTopList = this.reportsAggs && this.reportsAggs[this.filterNames.PAST_JOB_TITLE] ?
      this.reportsAggs[this.filterNames.PAST_JOB_TITLE] : [];
    this.pastJobTitleTopList = this.aggService.manadatoryApplicable(this.extraInfo) && this.extraInfo.redirectData?.mandatorypastjobtitles ? this.pastJobTitleTopList.filter(j => !this.extraInfo.redirectData.mandatorypastjobtitles.includes(j.key)) : this.pastJobTitleTopList;
    this.pastJobTitleTopList = this.pastJobTitleTopList.filter(pastJobTitle => !this.pastJobTitleSelectedList.some(selectedPastJobTitle => selectedPastJobTitle.chipkey.toLowerCase() == pastJobTitle.key.toLowerCase()))?.slice(0, 5);
    if (updateSelectedList) {
      const titlesToBeUpdated = [];
      let noOfSuggestionsToAdd = 5 - (this.aiSuggestedPastJobTitles ? this.aiSuggestedPastJobTitles.length : 0);
      noOfSuggestionsToAdd && this.pastJobTitleTopList.forEach((jobTitle) => {
        if (noOfSuggestionsToAdd) {
          const isTitlePresent = this.aiSuggestedPastJobTitles.find(j => j.name.toLowerCase() == jobTitle.key.toLowerCase());
          if (!isTitlePresent) {
            titlesToBeUpdated.push({ name: jobTitle.key, selected: false, type: 'title', key: this.getSafeKey(jobTitle.key) });
            noOfSuggestionsToAdd--;
          }
        }
      });
      this.showOpenAIPastJobTitleSuggestions += titlesToBeUpdated.length;
      this.updatedAiPastJobTitleChips.emit(titlesToBeUpdated);
    }


    this.locationTopList = this.reportsAggs['location_name-location_continent'] ? this.reportsAggs['location_name-location_continent'] : this.reportsAggs['location'] ? this.reportsAggs['location'] : [];
    this.locationTopList = this.extraInfo.redirectSource == 'talent-insights' && this.extraInfo.redirectData?.location ? this.locationTopList.filter(l => !this.extraInfo.redirectData?.location.includes(l.key)) : this.extraInfo.redirectSource == 'company-insights' && this.extraInfo.redirectData?.locations ? this.locationTopList.filter(l => !this.extraInfo.redirectData.locations?.includes(l.key)) : this.locationTopList;
    this.locationTopList = (this.extraInfo.redirectSource == 'talent-insights' || this.extraInfo.redirectSource == 'company-insights') && this.extraInfo.redirectData?.mandatorylocations ? this.locationTopList.filter(l => !this.extraInfo.redirectData?.mandatorylocations?.includes(l.key)) : this.locationTopList;
    this.locationTopList = this.locationTopList.filter(location => !this.locationSelectedList.some(selectedLocation => selectedLocation.chipkey.toLowerCase() == location.key.toLowerCase())).slice(0, 5);
    this.aggService.setLocationTopList(this.locationTopList);

    this.skillsTopList = this.reportsAggs?.skills ? this.reportsAggs?.skills : [];
    this.skillsTopList = (this.extraInfo.redirectSource == 'talent-insights' || this.extraInfo.redirectSource == 'company-insights') && this.extraInfo.redirectData?.skills ? this.skillsTopList.filter(s => !this.extraInfo.redirectData?.skills?.includes(s.key)) : this.skillsTopList;
    this.skillsTopList = (this.extraInfo.redirectSource == 'talent-insights' || this.extraInfo.redirectSource == 'company-insights') && this.extraInfo.redirectData?.mandatoryskills ? this.skillsTopList.filter(s => !this.extraInfo.redirectData?.mandatoryskills?.includes(s.key)) : this.skillsTopList;
    this.skillsTopList = this.skillsTopList.filter(skill => !this.skillsSelectedList.some(selectedSkill => selectedSkill.chipkey.toLowerCase() == skill.key.toLowerCase()));
    if (updateSelectedList) {
      const skillsToBeUpdated = [];
      let noOfSuggestionsToAdd = 5 - (this.aiSuggestedSkills ? this.aiSuggestedSkills.length : 0);
      noOfSuggestionsToAdd && this.skillsTopList.forEach((skill) => {
        if (noOfSuggestionsToAdd) {
          const isSkillPresent = this.aiSuggestedSkills.find(s => s.name.toLowerCase() == skill.key.toLowerCase());
          if (!isSkillPresent) {
            skillsToBeUpdated.push({ name: skill.key, selected: false, type: 'skill', key: this.getSafeKey(skill.key) });
            noOfSuggestionsToAdd--;
          }
        }
      });
      this.showOpenAISkillsSuggestions += skillsToBeUpdated.length;
      this.updatedAiSkillChips.emit(skillsToBeUpdated);
    }
    this.skillsTopList = this.skillsTopList.slice(0, 5);
    this.companyTopList = (this.companyStatus == 'Current' ? this.reportsAggs?.current_company : this.companyStatus == 'Past' ? this.reportsAggs?.pastcompany : this.reportsAggs?.company) || [];
    this.companyTopList = this.extraInfo.redirectSource == 'talent-insights' && this.extraInfo.redirectData?.mandatorycompanies ? this.companyTopList?.filter(c => !this.extraInfo.redirectData?.mandatorycompanies?.includes(c.key)) : this.companyTopList;
    this.companyTopList = this.extraInfo.redirectSource == 'company-insights' && this.extraInfo?.redirectData?.winningtalent ? this.companyTopList?.filter(c => !this.extraInfo.redirectData?.winningtalent?.includes(c.key)) : this.extraInfo.redirectSource == 'company-insights' && this.extraInfo.redirectData?.losingtalent ? this.companyTopList?.filter(c => !this.extraInfo?.redirectData?.losingtalent?.includes(c.key)) : this.companyTopList;
    this.companyTopList = this.extraInfo.redirectSource == 'company-insights' && this.extraInfo?.redirectData?.name ? this.companyTopList?.filter(c => c.key != this.extraInfo.redirectData?.name) : this.companyTopList;
    this.companyTopList = this.companyTopList.filter(company => !this.companySelectedList?.some(selectedCompany => selectedCompany.chipkey.toLowerCase() == company.key.toLowerCase())).slice(0, 5);

    this.aggService.setCompanyTopList(this.companyTopList);

    this.industryTopList = (this.industryStatus == 'Current' ? this.reportsAggs?.current_industry : this.industryStatus == 'Past' ? this.reportsAggs?.pastindustry : this.reportsAggs?.industry) || [];
    this.industryTopList = (this.extraInfo.redirectSource == 'talent-insights') && this.extraInfo.redirectData?.mandatoryindustries ? this.industryTopList?.filter(i => !this.extraInfo.redirectData?.mandatoryindustries?.includes(i.key)) : this.industryTopList;
    this.industryTopList = this.industryTopList?.filter(industry => !this.industrySelectedList?.some(selectedIndustry => selectedIndustry.chipkey.toLowerCase() == industry.key.toLowerCase())).slice(0, 5);

    this.educationTopList = this.reportsAggs?.education ? this.reportsAggs?.education : [];
    this.educationTopList = this.educationTopList?.filter(education => !this.educationSelectedList?.some(selectedEducation => selectedEducation?.chipkey?.toLowerCase() == education?.key?.toLowerCase())).slice(0, 5);

    this.schoolLocationTopList = this.reportsAggs?.school_location ? this.reportsAggs?.school_location : [];
    this.schoolLocationTopList = this.schoolLocationTopList?.filter(education => !this.schoolLocationSelectedList?.some(selectedEducation => selectedEducation?.chipkey?.toLowerCase() == education?.key?.toLowerCase())).slice(0, 5);

    this.fieldOfStudyTopList = this.reportsAggs?.fieldofstudy ? this.reportsAggs?.fieldofstudy : [];
    this.fieldOfStudyTopList = (this.extraInfo.redirectSource == 'talent-insights' || this.extraInfo.redirectSource == 'company-insights') && this.extraInfo.redirectData?.mandatoryeducationalmajors ? this.fieldOfStudyTopList?.filter(f => !this.extraInfo.redirectData?.mandatoryeducationalmajors?.includes(f.key)) : this.fieldOfStudyTopList;
    this.fieldOfStudyTopList = this.fieldOfStudyTopList?.filter(fieldOfStudy => !this.fieldOfStudySelectedList?.some(selectedFieldOfStudy => selectedFieldOfStudy?.chipkey?.toLowerCase() == fieldOfStudy?.key?.toLowerCase())).slice(0, 5);

    // this.keywordTopList = this.reportsAggs?.keyword ? this.reportsAggs?.keyword : [];
    // TODO : Confirm with Snehal about how to handle this case
    // this.fieldOfStudyTopList = (this.extraInfo.redirectSource == 'talent-insights' || this.extraInfo.redirectSource == 'company-insights') && this.extraInfo.redirectData?.mandatoryeducationalmajors ? this.fieldOfStudyTopList?.filter(f => !this.extraInfo.redirectData?.mandatoryeducationalmajors?.includes(f.key)) : this.fieldOfStudyTopList;
    // this.keywordTopList = this.keywordTopList?.filter(keyword => !this.keywordSelectedList?.some(selectedKeyword => selectedKeyword?.chipkey?.toLowerCase() == keyword?.key?.toLowerCase())).slice(0, 5);

    this.schoolTopList = this.reportsAggs?.school ? this.reportsAggs?.school : [];
    this.schoolTopList = (this.extraInfo.redirectSource == 'talent-insights' || this.extraInfo.redirectSource == 'company-insights') && this.extraInfo.redirectData?.mandatoryschools ? this.schoolTopList?.filter(s => !this.extraInfo.redirectData?.mandatoryschools?.includes(s.key)) : this.schoolTopList;
    this.schoolTopList = this.schoolTopList.filter(school => !this.schoolSelectedList?.some(selectedSchool => selectedSchool?.chipkey?.toLowerCase() == school?.key?.toLowerCase())).slice(0, 5);

    this.functionTopList = (this.functionStatus == 'Current' ? this.reportsAggs?.current_function : this.functionStatus == 'Past' ? this.reportsAggs?.pastfunction : this.reportsAggs?.function) || [];
    this.functionTopList = this.extraInfo.redirectSource == 'talent-insights' && this.extraInfo.redirectData?.functions ? this.functionTopList?.filter(f => !this.extraInfo?.redirectData?.functions?.includes(f.key)) : this.functionTopList;
    // this.functionTopList = this.extraInfo.redirectSource == 'company-insights' && this.extraInfo.redirectData?.mandatoryfunctions ? this.functionTopList?.filter(f => !this.extraInfo.redirectData?.mandatoryfunctions?.includes(f?.key)) : this.functionTopList;
    this.functionTopList = this.functionTopList?.filter(func => !this.functionSelectedList?.some(selectedfunction => selectedfunction?.chipkey?.toLowerCase() == func?.key?.toLowerCase())).slice(0, 5);
    //console.log("data", data);
  }

  companySizeHandler(event) {
    let value = event.value;
    this.companysize = _.without(this.companysize, "All")
  }

  seniorityHandler(event) {
    let value = event.value;
    this.seniority = _.without(this.seniority, "All")
  }


  /**
   * Method to handle overall match filter
   * @param event
   * @param type
   */
  addOverallMatchFilter(event: any, type: string) {
    const isChecked = event.target.checked;

    if (type === 'ALL') {
      if (isChecked) {
        this.overallMatchFilters = this.matchTypes.map((res: string) => res);
      } else {
        this.overallMatchFilters = [];
      }

      this.matchTypes.forEach(match => {
        const elements = document.getElementsByName(match) as NodeListOf<HTMLInputElement>;
        elements.forEach(el => el.checked = isChecked);
      });

    } else {
      if (isChecked) {
        if (!this.overallMatchFilters.includes(type)) {
          this.overallMatchFilters.push(type);
        }
      } else {
        this.overallMatchFilters = this.overallMatchFilters.filter(f => f !== type);
      }

      const allCheckbox = document.getElementById('overAllMatch') as HTMLInputElement;
      if (this.overallMatchFilters.length < this.matchTypes.length) {
        if (allCheckbox) allCheckbox.checked = false;
      }

      if (this.overallMatchFilters.length === this.matchTypes.length) {
        if (allCheckbox) allCheckbox.checked = true;
      }
    }

    this.syncFilterData();
    this.filterDataHandlerService.setFilterData(this.filterData);
    this.aggReqObjectHandlerService.setStartIndex(0);
    this.getexpandrefresheddata(type);
    this.filterDataHandlerService.emitfilterMethodObject({ methodName: "selectedItem" });
  };

  selectedItem(event, type) {
    const inputElements: NodeListOf<Element> = document.querySelectorAll('.mat-input-element');
    inputElements.forEach((element: Element) => {
      (element as HTMLInputElement).blur();
    });
    const hasEuAccess = this.localstorageservice.getItem('hasEUPersonSearchAccess');
    if (((hasEuAccess == 1 && this.isPersonSearchListingPage) || (this.hasEUTalentInsightsAccess == 1 && this.isTalentInsightsPage)) && event && event?.option && event?.option?.value?.continent == 'europe' && type == 'location') {
      const euData = this.localstorageservice.getItem('euConscent');
      const now = new Date().getTime();
      this.locationInput.setValue(event.option.value.key);
      if (euData) {
        const parsedData = JSON.parse(euData);
        if (!parsedData.lastShown || now - parseInt(parsedData.lastShown, 10) > 24 * 60 * 60 * 1000) {
          const modalRef = this.modalService.open(EuropeAccessModalComponent, { windowClass: 'euAccessModal', centered: true, backdrop: 'static', keyboard: false });
          modalRef.result.then((res) => {
            if (res.action == "success") {
              this.selectedItemFilter(event, type)
            } else {
              this.locationInput.reset();
            }
          })
        } else
          this.selectedItemFilter(event, type);
      } else {
    const modalRef = this.modalService.open(EuropeAccessModalComponent, { windowClass: 'euAccessModal', centered: true, backdrop: 'static', keyboard: false });
          modalRef.result.then((res) => {
            if (res.action == "success") {
              this.selectedItemFilter(event, type)
            } else {
              this.locationInput.reset();
   }
          })      }
    } else {
      this.selectedItemFilter(event, type)
   }


  }

  getexpandrefresheddata(type: string | null) {
    //for company filter
    if (document.getElementById('collapseFour')?.classList.contains('show') && type != 'company') {
      this.companyStatus === CallStage.CURRENT_OR_PAST.toString() && this.getAggregationReport('company');
      this.companyStatus === CallStage.CURRENT.toString() && this.getAggregationReport('current_company');
      this.companyStatus === CallStage.PAST.toString() && this.getAggregationReport('pastcompany');
    }
    //for jobtitle
    if (document.getElementById('collapseOne')?.classList.contains('show') && type != 'jobtitle') {
      this.jobTitleStatus === CallStage.CURRENT_OR_PAST.toString() && this.getAggregationReport("jobtitle");
      this.jobTitleStatus === CallStage.CURRENT.toString() && this.getAggregationReport("current_jobtitle");
      this.jobTitleStatus === CallStage.PAST.toString() && this.getAggregationReport("pastjobtitle");
    }
    //for past jobtitle
    if (document.getElementById('collapsePastJobTitle')?.classList.contains('show') && type !== this.filterNames.PAST_JOB_TITLE) {
      this.getAggregationReport(this.filterNames.PAST_JOB_TITLE);
    }
    //for location
    if (document.getElementById('collapseTwo')?.classList.contains('show') && type != 'location') {
      this.getAggregationReport('location_name-location_continent');
    }
    //for skills
    if (document.getElementById('collapseThree')?.classList.contains('show') && type != 'skills') {
      this.getAggregationReport('skills');
    }
    //for industries
    if (document.getElementById('collapseSix')?.classList.contains('show') && type != 'industry') {
      this.industryStatus === CallStage.CURRENT_OR_PAST.toString() && this.getAggregationReport('industry');
      this.industryStatus === CallStage.CURRENT.toString() && this.getAggregationReport('current_industry');
      this.industryStatus === CallStage.PAST.toString() && this.getAggregationReport('pastindustry');
    }
    //for education
    if (document.getElementById('collapseTwelve')?.classList.contains('show') && type != 'education') {
      this.getAggregationReport('education');
    }
    //for school
    if (document.getElementById('collapseFourteen')?.classList.contains('show') && type != 'school') {
      this.getAggregationReport('school');
    }
    // for field of study
    if (document.getElementById('collapseFifteen')?.classList.contains('show') && type != 'fieldofstudy') {
      this.getAggregationReport('fieldofstudy');
    }
    // for functions
    if (document.getElementById('collapseEighteen')?.classList.contains('show') && type != 'function') {
      this.functionStatus === CallStage.CURRENT_OR_PAST.toString() && this.getAggregationReport('function');
      this.functionStatus === CallStage.CURRENT.toString() && this.getAggregationReport('current_function');
      this.functionStatus === CallStage.PAST.toString() && this.getAggregationReport('pastfunction');
    }
    // for years of experience
    if (document.getElementById('collapseSeven')?.classList.contains('show') && type !== 'yearsofexperience') {
      this.yearsofexperience === "Total" ?
        this.getAggregationReport('totalyearsofexperience') :
        this.getAggregationReport('averageyearsofexperience');
    }
    // for years of experience
    if (document.getElementById('collapeSevenCurrent')?.classList.contains('show') && type !== 'currentyearsofexperience') {
      this.getAggregationReport('currentyearsofexperience');
    }
    // for years of experience
    if (document.getElementById('schoollocation')?.classList.contains('show') && type !== 'schoollocation') {
      this.getAggregationReport('school_location');
    }
    if(document.getElementById('collapseGraduation')?.classList.contains('show')){
      this.getAggregationReport('graduationyear');
    }
  }

  filterByStatus(event, type) {
    this.aggReqObjectHandlerService.setStartIndex(0);
    this.filterDataHandlerService.emitfilterMethodObject({ methodName: "filterByStatus" });
    if (type === 'jobtitle') { this.jobTitleStatus = event.target.value; }
    if (type === 'company') { this.companyStatus = event.target.value; }
    if (type === 'industry') { this.industryStatus = event.target.value; }
    if (type === 'yearsofexperience') {
      this.yearsofexperience = event.target.value;
      this.filterDataHandlerService.emitYearsOfExperienceType({
        yoeType: this.yearsofexperience,
        emmitedFrom: GeneralConstants.COMPONENT_NAME.PERSON_SEARCH_FILTER
      });
    }

    this.aggReqObjectHandlerService.setStartIndex(0);
    this.syncFilterData();
    this.filterDataHandlerService.setFilterData(this.filterData);
    this.setFilterDataInLocalStorage();
    this.filterDataHandlerService.shouldSendPersonSearchRequest() && this.aggService.getPersonSearchRecommendedCandidates(this.extraInfo);
    this.getFilterWiseDataToDisplay(type);
    this.filterDataHandlerService.emitfilterMethodObject({ methodName: "selectedItem" });
  }

  getCompanyLogoForCompanyChips(companyList: Array<string>) {
    if (!companyList || !companyList.length) return;
    const updatedCompanyList = companyList.map(companyName => {
      const name = companyName.split(".searchastext");
      return (name[0]).toLowerCase();
    }).filter(Boolean);

    const payload = updatedCompanyList.map(item=>{
      if(item){
        return {name: item};
      }
    }).filter(Boolean);

    payload?.length &&
    this.personSearchService.getCompanyLogoV2(payload).subscribe((res: any) => {
      this.companySelectedList?.length && this.companySelectedList.map(company => {
        if (res && res.data?.length) {
          res.data.map(logosData => {
            if (((logosData.key).toLowerCase() === (company.chipkey).toLowerCase()) || ((logosData.key).toLowerCase() === (company.key).toLowerCase())) {
              company['companylogo'] = logosData?.companylogo;
            }
          })
        }
      })
    })
  }

  addToSelectedList(item, type, from: any = null) {
    const hasEuAccess = this.localstorageservice.getItem('hasEUPersonSearchAccess');
   if (((hasEuAccess == 1 && this.isPersonSearchListingPage) || (this.hasEUTalentInsightsAccess == 1 && this.isTalentInsightsPage)) && item && item?.location_continent && item?.location_continent[0]?.key =='europe' && type == 'location') {
      const euData = this.localstorageservice.getItem('euConscent');
      const now = new Date().getTime();
      this.locationInput.setValue(item.key);
      if (euData) {
        const parsedData = JSON.parse(euData);
        if (!parsedData.lastShown || now - parseInt(parsedData.lastShown, 10) > 24 * 60 * 60 * 1000) {
          const modalRef = this.modalService.open(EuropeAccessModalComponent, { windowClass: 'euAccessModal', centered: true, backdrop: 'static', keyboard: false });
          modalRef.result.then((res) => {
            if (res.action == "success") {
              this.addToSelectFilterModal(item, type, from)
            } else {
              this.locationInput.reset();
            }
          })
        } else
          this.addToSelectFilterModal(item, type, from);
      } else {
        const modalRef = this.modalService.open(EuropeAccessModalComponent, { windowClass: 'euAccessModal', centered: true, backdrop: 'static', keyboard: false });
        modalRef.result.then((res) => {
          if (res.action == "success") {
            this.addToSelectFilterModal(item, type, from)
          } else {
            this.locationInput.reset();
          }
        })
      }
    } else {
      this.addToSelectFilterModal(item, type, from)
   }
}

  excludeFilterItem(item, type) {
    if (type === "jobtitle") {
      this.jobTitleSelectedList = this.jobTitleSelectedList?.map(jt => jt.key == item ? { ...jt, isExcluded: !jt.isExcluded } : jt);
    } else if (type === "location") {

  this.locationSelectedList = this.locationSelectedList?.map(loc =>
    loc.key === item ? { ...loc, isExcluded: !loc.isExcluded } : loc
  );

  const filter = this.filterDataHandlerService.fetchFilterData;
  this.locationcontinentsName = filter.locationcontinents;
  this.locationContinents = filter.continentstobeincluded;

  const selectedItem = this.locationSelectedList?.find(
    x => x.key.trim().toLowerCase() === item.trim().toLowerCase()
  );

  if (selectedItem?.isExcluded) {
    this.locationcontinentsName = this.locationcontinentsName?.filter(
      x =>
        !(
          x.key.trim().toLowerCase() === item.trim().toLowerCase() &&
          x.calledFrom === 'Filter'
        )
    );
  } else {
    const alreadyExists = this.locationcontinentsName?.some(
      x =>
        x.key.trim().toLowerCase() === item.trim().toLowerCase() &&
        x.calledFrom === 'Filter'
    );

    if (!alreadyExists) {
      this.locationcontinentsName?.push({
        key: selectedItem?.key,
        continent: selectedItem?.continent,
        calledFrom: 'Filter'
      });
    }
  }

  // 🔁 Update continents list
  this.locationContinents = _.uniq(
    _.pluck(this.locationcontinentsName, 'continent')
  );
} else if (type === "company") {
      this.companySelectedList = this.companySelectedList.map(company => company.key == item ? { ...company, isExcluded: !company.isExcluded } : company);
    } else if (type === this.filterNames.PAST_JOB_TITLE) {
      this.pastJobTitleSelectedList = this.pastJobTitleSelectedList.map(jt => jt.key == item ? { ...jt, isExcluded: !jt.isExcluded } : jt);
    } else if (type === "industry") {
      this.industrySelectedList = this.industrySelectedList.map(ind => ind.key == item ? { ...ind, isExcluded: !ind.isExcluded } : ind);
    } else if (type == 'schoollocation') {
      this.schoolLocationSelectedList = this.schoolLocationSelectedList.map(sl => sl.key == item ? { ...sl, isExcluded: !sl.isExcluded } : sl);
    } else if (type == 'skills') {
      this.skillsSelectedList = this.skillsSelectedList.map(s => s.key == item ? { ...s, isExcluded: !s.isExcluded } : s);
    } else if (type == 'functions') {
      this.functionSelectedList = this.functionSelectedList.map(s => s.key == item ? { ...s, isExcluded: !s.isExcluded } : s);
    }
    this.aggReqObjectHandlerService.setStartIndex(0);
    this.syncFilterData();
    this.filterDataHandlerService.setFilterData(this.filterData);
    this.aggReqObjectHandlerService.setStartIndex(0);
    this.setFilterDataInLocalStorage();
    this.filterDataHandlerService.shouldSendPersonSearchRequest() && this.aggService.getPersonSearchRecommendedCandidates(this.extraInfo);
    this.getexpandrefresheddata(type);
    this.filterDataHandlerService.emitfilterMethodObject({ methodName: "excludeFilterItem", filterType: type });
    this.setTalentInsightsHistory();

    this.isSearchSaved = false;
  }

  removeChip(value, type) {
    const inputElements: NodeListOf<Element> = document.querySelectorAll('.mat-input-element');
    inputElements.forEach((element: Element) => {
      (element as HTMLInputElement).blur();
    });
    switch (type) {
      case 'jobtitle':
        this.jobTitleSelectedList = this.jobTitleSelectedList.filter(item => item.key !== value.key);
        break;
      case this.filterNames.PAST_JOB_TITLE:
        this.pastJobTitleSelectedList = this.pastJobTitleSelectedList.filter(item => item.key !== value.key);
        break;
      case 'skills':
        this.skillsSelectedList = this.skillsSelectedList.filter(item => item.key !== value.key);
        break;
      case 'company':
        this.companySelectedList = this.companySelectedList.filter(item => item.key !== value.key);
        if (!value.isSuggested) {
          const companyList = this.companySelectedList.filter(c => !c.isSuggested);
          if (companyList && companyList.length) {
            this.getCompanyAiSuggestions();
          }
        }
        break;
      case 'industry':
        this.industrySelectedList = this.industrySelectedList.filter(item => item.key !== value.key);
        break;
      case 'fieldofstudy':
        this.fieldOfStudySelectedList = this.fieldOfStudySelectedList.filter(item => item.key !== value.key);
        break;

      case 'fullname':
          this.fullNameSelectedList = this.fullNameSelectedList.filter(item => item.key !== value.key);

      case 'companysize':
        if (value === "All") {
          this.companysize = [];
        } else {
          this.companysize = this.companysize.filter(item => item !== value);
        }
        break;
      case 'school':
        this.schoolSelectedList = this.schoolSelectedList.filter(item => item.key !== value.key);
        break;
      case 'education':
        this.educationSelectedList = this.educationSelectedList.filter(item => item.key !== value.key);
        break;
      case 'location':
           const filter = this.filterDataHandlerService.fetchFilterData
        this.locationcontinentsName = filter.locationcontinents;
        this.locationContinents = filter.continentstobeincluded;
        this.locationSelectedList = this.locationSelectedList.filter(item => item.key !== value.key);
        const locationsObj = this.locationSelectedList.filter(x => x.isExcluded != true);
        this.locationContinents = _.uniq(_.pluck(locationsObj, 'continent'));
        this.locationContinents = this.locationContinents?.filter(item => item !== null && item !== undefined);
this.locationcontinentsName = this.locationcontinentsName?.filter(
  x => !(
    x.key?.trim()?.toLowerCase() === value.key?.trim()?.toLowerCase() &&
    x.calledFrom === 'Filter'
  )
);        this.locationContinents = _.uniq(_.pluck(this.locationcontinentsName, 'continent'));
       break;
      case 'functions':
        this.functionSelectedList = this.functionSelectedList.filter(item => item.key !== value.key);
        break;
      case 'seniority':
        if (value === "All")
          this.seniority = [];
        else
          this.seniority = this.seniority.filter(item => item !== value);
        break;
      case 'keyword':
        this.keywordSelectedList = this.keywordSelectedList.filter(item => item.key != value.key);
        this.keyword_input.patchValue(null);
        break;
      case 'schoollocation':
        this.schoolLocationSelectedList = this.schoolLocationSelectedList.filter(item => item.key !== value.key);
      case 'highlight':
        this.highlightsSelectedList = this.highlightsSelectedList.filter(item => item.id != value.id)
        this.highlightSelectedControl = _.pluck(this.highlightsSelectedList, 'id');
        break;
      case 'positionhierarchy':
        if (value === "All")
        this.positionhierarchy = [];
      else
        this.positionhierarchy = this.positionhierarchy.filter(item => item !== value);
        break;
      default:
        console.log('removeChip not implemented for - ', type);
        break;
    }

        if (this.areAllFiltersCleared() && (!this.jdDataService.isComingFromJobDescription && !this.jdDataService.isComingFromNLSearch && !this.isSimilarCanidate &&  this.redirectSource != 'talent-insights' && this.redirectSource != 'company-insights')) {
  this.filterEvent.emit('allfilters');
    }
    // set data for suggested chips deselection
    if (value && value.isSuggested && (type == 'skills' || type == 'jobtitle')) {
      value.suggestedTitle.selected = false;
      this.filterDataHandlerService.pushAISuggestionData([value]);
    }
    this.aggReqObjectHandlerService.setStartIndex(0);
    this.syncFilterData();
    this.filterDataHandlerService.setFilterData(this.filterData);
    this.aggReqObjectHandlerService.setStartIndex(0);
    this.setFilterDataInLocalStorage();
    this.filterDataHandlerService.shouldSendPersonSearchRequest() && this.aggService.getPersonSearchRecommendedCandidates(this.extraInfo);
    this.getexpandrefresheddata(type);
    this.filterDataHandlerService.emitfilterMethodObject({ methodName: "removeChip", filterType: type });

    this.isSearchSaved = false;
    this.setTalentInsightsHistory();
  }

  mandatoryFilterItem(item, type) {
    if (type === "jobtitle") {
      this.jobTitleSelectedList = this.jobTitleSelectedList.map(jt => jt.key == item ? { ...jt, isMandatory: !jt.isMandatory } : jt);
    } else if (type === "skills") {
      this.skillsSelectedList = this.skillsSelectedList.map(skill => skill.key == item ? { ...skill, isMandatory: !skill.isMandatory } : skill);
    }
    this.aggReqObjectHandlerService.setStartIndex(0);
    this.syncFilterData();
    this.filterDataHandlerService.setFilterData(this.filterData);
    this.aggReqObjectHandlerService.setStartIndex(0);
    this.setFilterDataInLocalStorage();
    this.filterDataHandlerService.shouldSendPersonSearchRequest() && this.aggService.getPersonSearchRecommendedCandidates(this.extraInfo);
    this.getexpandrefresheddata(type);
    this.filterDataHandlerService.emitfilterMethodObject({ methodName: "mandatoryFilterItem" });
  }

  // Keeping track of whether we already have a request in pipeline or not
  typeaheadSubscription: Subscription = null;
  typeAheadSearch(event, type) {
    const requestObject = this.aggService.getRequestWithFilters();
    if (requestObject && requestObject['aggregatetype']) {
      delete requestObject['aggregatetype'];
    }

    let region: string;
    if (this.isCalledFromComponent == 'ai-sourcing') {
      region = this.projectDetails?.continent;
    } else {
      region = this.selectedContinent;
    };

    const searchValue = (event.target as HTMLInputElement).value;
      if (!(type == 'skills' || type == 'company') && searchValue.length < this.minSearchLengthToActivateTypeaheads) return;

    if (this.typeaheadSubscription)
      this.typeaheadSubscription.unsubscribe();
    switch (type) {

      case 'jobtitle': {
        requestObject['typeahead'] = this.jobTitleStatus == 'Current or Past' ? 'typeahead_jobtitle' : this.jobTitleStatus == 'Current' ? 'typeahead_currentjobtitle' : 'typeahead_pastjobtitle';
        requestObject['input'] = searchValue;
        this.showJobTitleLoader = true;
        this.typeaheadSubscription = this.personSearchService.getPersonSearchListing(searchValue, 'jobtitle').subscribe((response: any) => {
          if (response.status == 'success' && response.data) {
            this.jobTitleList = response.data;
            this.showJobTitleLoader = false
          }
        });
        break;
      }
      case this.filterNames.PAST_JOB_TITLE: {
        requestObject['typeahead'] = 'typeahead_pastjobtitle';
        requestObject['input'] = searchValue;
        this.showPastJobTitleLoader = true;
        this.typeaheadSubscription = this.personSearchService.getPersonSearchListing(searchValue, 'jobtitle').subscribe((response: any) => {
          if (response.status == 'success' && response.data) {
            this.pastJobTitleList = response.data;
            this.showPastJobTitleLoader = false;
          }
        });
        break;
      }
      case 'skills': {
        //  if(searchValue.length>0){
        requestObject['typeahead'] = 'typeahead_skills';
        requestObject['input'] = searchValue;
        if(searchValue.length>0){
          this.showSkillLoader = true;
        }else{
          this.showSkillLoader = false;
        }
        this.typeaheadSubscription && this.typeaheadSubscription.unsubscribe();
         this.typeaheadSubscription = this.personSearchService.getPersonSearchListing(searchValue, 'skill').subscribe((response: any) => {
          if (response.status == 'success' && response.data) {
            this.skillsList = response.data;
            this.showSkillLoader = false
          }
        });
        break;
      }
      case 'company': {
        requestObject['typeahead'] = this.companyStatus == 'Current or Past' ? 'typeahead_company' : this.companyStatus == 'Current' ? 'typeahead_currentcompany' : 'typeahead_pastcompany';
        requestObject['input'] = searchValue;
         if(searchValue.length>0){
          this.showCompanyLoader = true;
         }else{
          this.showCompanyLoader = false;
        }
        this.typeaheadSubscription && this.typeaheadSubscription.unsubscribe();
        this.typeaheadSubscription = this.personSearchService.getPersonSearchListing(searchValue, 'company').subscribe(async (response: any) => {
          if (response.status == 'success' && response.data) {
            const payload = [];
            response.data.forEach(item=>
              payload.push({
                name: item.value
              })
            )
            const companyList = response.data.length ? await this.personSearchService.getCompanyLogoV2(payload).toPromise() : { data: [] };
            this.companyList = companyList.data;
            this.showCompanyLoader = false
          }
        });
        break;
      }
      case 'industry': {
        requestObject['typeahead'] = this.industryStatus == 'Current or Past' ? 'typeahead_industry' : this.industryStatus == 'Current' ? 'typeahead_currentindustry' : 'typeahead_pastindustry';
        requestObject['input'] = searchValue;
        this.showIndustryLoader = true;
        this.typeaheadSubscription = this.personSearchService.getPersonSearchListing(searchValue, 'industry').subscribe((response: any) => {
          if (response.status == 'success' && response.data) {
            this.industryList = response.data;
            this.showIndustryLoader = false
          }
        });
        break;
      }
      case 'fieldofstudy': {
        requestObject['typeahead'] = 'typeahead_fieldofstudy';
        requestObject['input'] = searchValue;
        this.showFieldOfStudyLoader = true;
        this.typeaheadSubscription = this.personSearchService.getPersonSearchListing(searchValue, 'fieldofstudy').subscribe((response: any) => {
          if (response.status == 'success' && response.data) {
            this.fieldOfStudyList = response.data;
            this.showFieldOfStudyLoader = false
          }
        });
        break;
      }
      case 'fullname': {
        this.showFullNameLoader = true;
        requestObject['input'] = searchValue
        this.typeaheadSubscription = this.personSearchService.getPersonSearchListing(searchValue, 'fullname').subscribe((response:any)=>{
          if(response.status == 'success' && response.data){
            this.fullNameList = response.data;
            this.showFullNameLoader = false;
          }
        });
        break;
      }
      case 'companysize': {
        requestObject['typeahead'] = this.jobTitleStatus == 'All' ? 'typeahead_companysize' : 'typeahead_currentcompanysize';
        requestObject['input'] = searchValue;
        this.typeaheadSubscription = this.personSearchService.getPersonSearchListing(searchValue, null).subscribe((response: any) => {
          if (response.status == 'success' && response.data) {
            const rangeValue = (range) => {
              const match = range.match(/(\d+)/g);
              const start = parseInt(match[0]);
              return Math.floor(start / 10);
            };

            this.companySizeList = response.data.sort((a, b) => {
              const aValue = rangeValue(a.key);
              const bValue = rangeValue(b.key);
              return aValue - bValue;
            });
          }
        });
        break;
      }
      case 'education': {
        requestObject['typeahead'] = 'typeahead_education';
        requestObject['input'] = searchValue;
        this.showEducationLoader = true;
        this.typeaheadSubscription = this.personSearchService.getPersonSearchListing(searchValue, 'education').subscribe((response: any) => {
          if (response.status == 'success' && response.data) {
            this.educationList = response.data;
            this.showEducationLoader = false
          }
        });
        break;
      }
      case 'school': {
        requestObject['typeahead'] = 'typeahead_school';
        requestObject['input'] = searchValue;
        this.showSchoolLoader = true;
        this.typeaheadSubscription = this.personSearchService.getPersonSearchListing(searchValue, 'school').subscribe((response: any) => {
          if (response.status == 'success' && response.data) {
            this.schoolList = response.data;
            this.showSchoolLoader = false
          }
        });
        break;
      }
      case 'location': {
        requestObject['typeahead'] = 'typeahead_location';
        requestObject['input'] = searchValue;
        this.showLocationLoader = true;
        this.typeaheadSubscription = this.personSearchService.getPersonSearchListing(searchValue, 'location').subscribe((response: any) => {
          if (response.status == 'success' && response.data) {
            this.locationList = response.data;
            // if(this.isCompanyInsightsDetails) {
            // //  this.locationList.push(this.continentList);
            //   this.locationList = _.flatten(this.locationList);
            //   this.locationList = this.locationList.filter((x) =>{ return x.value.toLowerCase().includes(searchValue.toLowerCase()) });
            // }
            this.showLocationLoader = false
          }
        });
        break;
      }
      case 'functions': {
        requestObject['typeahead'] = 'typeahead_functions';
        requestObject['input'] = searchValue;
        this.showFunctionsLoader = true;
        this.typeaheadSubscription = this.personSearchService.getPersonSearchListing(searchValue, 'function').subscribe((response: any) => {
          if (response.status == 'success' && response.data) {
            this.functionsList = response.data;
            this.showFunctionsLoader = false
          }
        });
        break;
      }
      case 'keyword': {
        this.showKeywordLoader = true;
        this.typeaheadSubscription = this.personSearchService.getPersonSearchListing(searchValue, null).subscribe((response: any) => {
          if (response.status == 'success') {
            this.keywordlist = response.data;
            this.showKeywordLoader = false
          }
        });
        break;
      }
      case 'schoollocation': {
        this.showSchoolLocationLoader = true;
        this.typeaheadSubscription = this.personSearchService.getPersonSearchListing(searchValue, 'school_location').subscribe((response: any) => {
          if (response.status == 'success') {
            this.schoolLocationList = response.data;
            this.showSchoolLocationLoader = false
          }
        });
        break;
      }


    }
  }

  // Call this function whenever the user types something
  onTypeAheadSearch(event: Event, type: string) {
    // Emit the event and type as an object through the typeAheadSubject to apply debounce
    this.typeAheadSubject.next({ event, type });
  }

  shouldShowFilter(filter: string) {
    return this.filterDataHandlerService.shouldShowFilter(filter);
  }

  shouldShowStatus() {
    return this.filterDataHandlerService.shouldShowStatus();
  }

  shouldShowSuggestions() {
    return this.filterDataHandlerService.shouldNotShowSuggestion();
  }

  private syncFilterData() {
    this.filterData = this.filterDataHandlerService.fetchFilterData;

    this.filterData.overallMatchFilters = _.clone(this.overallMatchFilters, true);

    const globalFilterData = this.filterDataHandlerService.fetchFilterData;
    this.filterData.booleanquery = this.keywordInput.value ? this.keywordInput.value : '*';
    this.filterData.savehistory = this.savehistory;
    this.filterData.isInsightsActive = this.isInsightsActive;
    this.filterData.isListingActive = this.isListingActive;
    this.filterData.jobTitleSelectedList = _.clone(this.jobTitleSelectedList, true);
    this.filterData.jobTitleStatus = this.jobTitleStatus;

    this.filterData.pastJobTitleSelectedList = _.clone(this.pastJobTitleSelectedList, true);

    this.filterData.skillsSelectedList = _.clone(this.skillsSelectedList, true);
    this.filterData.locationSelectedList = _.clone(this.locationSelectedList, true);
    const locationType = _.pluck(this.locationSelectedList, 'location_type');
    this.location_type = locationType.length > 0 && locationType.indexOf('city') !== -1 ? 'city' : null;
      const locationsObj = this.locationSelectedList.filter(x => x.isExcluded != true);

    this.locationContinents = this.locationContinents?.length ? this.locationContinents : _.uniq(_.pluck(locationsObj, 'continent'));
    this.locationContinents = this.locationContinents?.filter(item => item !== null && item !==  undefined && item !== '');
    this.filterData.continentstobeincluded = this.locationContinents?.length ? this.locationContinents : [this.localstorageservice.getItem('defaultContinent')];


    this.filterData.companySelectedList = _.clone(this.companySelectedList, true);
    this.filterData.companyStatus = this.companyStatus;

    this.filterData.industrySelectedList = _.clone(this.industrySelectedList, true);
    this.filterData.industryStatus = this.industryStatus;

    this.filterData.fieldOfStudySelectedList = _.clone(this.fieldOfStudySelectedList, true);
    this.filterData.fullNameSelectedList = _.clone(this.fullNameSelectedList,true);

    this.filterData.companysize = this.companysize;
    this.filterData.companySizeSelectedList = this.companySizeSelectedList;
    this.filterData.isCompanySizeSelected = this.isCompanySizeSelected;

    this.filterData.schoolSelectedList = _.clone(this.schoolSelectedList, true);
    this.filterData.schoolLocationSelectedList = _.clone(this.schoolLocationSelectedList, true);

    this.filterData.educationSelectedList = _.clone(this.educationSelectedList, true);

    this.filterData.gender = this.gender;
    this.filterData.isGenderSelected = this.isGenderSelected;

    this.filterData.seniority = this.seniority;

    this.filterData.filterLikelyToMoveIn = this.filterLikelyToMoveIn;
    this.filterData.isLikelyToMoveInFilterSelected = this.isLikelyToMoveInFilterSelected;
    this.filterData.candidateslikelytomove = this.candidateslikelytomove;

    this.filterData.functionSelectedList = _.clone(this.functionSelectedList, true);

    this.filterData.changedJobStatus = this.changedJobStatus;
    this.filterData.changedJobStartDuration = this.changedJobStartDuration;
    this.filterData.changedJobEndDuration = this.changedJobEndDuration

    this.filterData.yearsofexperience = this.yearsofexperience;
    this.filterData.yearsofexperienceFrom = (typeof this.yearsofexperienceFromFilterData == 'string') ? parseInt(this.yearsofexperienceFromFilterData) : this.yearsofexperienceFromFilterData;
    this.filterData.yearsofexperienceTo = (typeof this.yearsofexperienceToFilterData == 'string') ? parseInt(this.yearsofexperienceToFilterData) : this.yearsofexperienceToFilterData;
    this.filterData.filterAppliedOnYearsOfExperience = this.filterAppliedOnYearsOfExperience;

    this.filterData.currentfromyearsofexperience = this.currentfromyearsofexperienceFilterData;
    this.filterData.currenttoyearsofexperience = this.currenttoyearsofexperienceFilterData;
    this.filterData.filterAppliedOnCurrentYearsOfExperience = this.filterAppliedOnCurrentYearsOfExperience;

    this.filterData.changedJobStatus = this.changedJobStatus;

    // Highlight filter
    this.filterData.profilehighlights = _.pluck(this.highlightsSelectedList, 'value');

    if (this.locationSelectedList?.length > 0) {
    this.filterData.distancefromselectedlocationsmeasurementunit = this.locationDistanceUnitForFilterData || 'kilometers';
      this.filterData.distancefromselectedlocations = Number(this.locationDistanceRangeForFilterData || '20');
    } else {
      this.filterData.distancefromselectedlocationsmeasurementunit = null;
      this.filterData.distancefromselectedlocations = null;
    }

    this.filterData.searchHistoryRegion = this.sessionStorageService.getItem("historyRegion")
    // this.filterData.keywordSelectedList = _.clone(this.keywordSelectedList, true);

    //  if (this.filterDataHandlerService.isPersonSearchListingPage()) {
    this.filterData.booleanquery = this.searchKeyword ? this.searchKeyword : '*';
    // }

    if (!this.talentInsightsReqHandler.isTalentInsightsTab) {
      this.filterData.talentdiscoveryhistoryid = globalFilterData.talentdiscoveryhistoryid;
    }
    this.filterData.positionhierarchy = this.positionhierarchy;

    /**Years of graduation */
    this.filterData.tograduationyear = this.tograduationyearFilter;
    this.filterData.fromgraduationyear = this.fromgraduationyearFilter;

    const filterDataForList = {
      ...this.filterData,
      jobTitleSelectedList: this.filterData.jobTitleSelectedList?.filter((j: any) => !j.isSuggested) || [],
      pastJobTitleSelectedList: this.filterData.pastJobTitleSelectedList?.filter((j: any) => !j.isSuggested) || [],
      skillsSelectedList: this.filterData.skillsSelectedList?.filter((s: any) => !s.isSuggested) || [],
    };
   this.filterList = JSON.stringify(filterDataForList || '{}');
   this.filterData.nlsearchquery = this.localstorageservice.getItem('nlSearchKeyword');
   this.filterData.locationcontinents = this.locationcontinentsName;

  }

  private syncLocalDataWithFilterObject() {
    this.jobTitleSelectedList = _.clone(this.filterData?.jobTitleSelectedList, true);
    this.jobTitleStatus = this.filterData.jobTitleStatus;

    this.pastJobTitleSelectedList = _.clone(this.filterData?.pastJobTitleSelectedList, true);

    this.skillsSelectedList = _.clone(this.filterData?.skillsSelectedList, true);

    this.locationSelectedList = _.clone(this.filterData?.locationSelectedList, true);

    this.companySelectedList = _.clone(this.filterData.companySelectedList, true);
    this.companyStatus = this.filterData.companyStatus;

    this.industrySelectedList = _.clone(this.filterData.industrySelectedList, true);
    this.industryStatus = this.filterData.industryStatus;

    this.fieldOfStudySelectedList = this.filterData.fieldOfStudySelectedList.length ? _.clone(this.filterData.fieldOfStudySelectedList, true):[];
    this.fullNameSelectedList = this.filterData.fullNameSelectedList.length ? _.clone(this.filterData.fullNameSelectedList, true) : [];
    this.companysize = this.filterData.companysize;
    this.companySizeSelectedList = this.filterData.companySizeSelectedList;
    this.isCompanySizeSelected = this.filterData.isCompanySizeSelected;

    this.schoolSelectedList = _.clone(this.filterData.schoolSelectedList, true);
    this.schoolLocationSelectedList = _.clone(this.filterData.schoolLocationSelectedList, true);


    this.educationSelectedList = _.clone(this.filterData.educationSelectedList, true);

    this.gender = this.filterData.gender;
    this.isGenderSelected = this.filterData.isGenderSelected;

    this.seniority = this.filterData.seniority;

    this.filterLikelyToMoveIn = this.filterData.filterLikelyToMoveIn;
    this.isLikelyToMoveInFilterSelected = this.filterData.isLikelyToMoveInFilterSelected;
    this.candidateslikelytomove = this.filterData.candidateslikelytomove;

    this.functionSelectedList = _.clone(this.filterData.functionSelectedList, true);

    this.changedJobStatus = this.filterData.changedJobStatus;

    this.yearsofexperience = this.filterData.yearsofexperience;
    this.filterData.yearsofexperienceFrom && this.yearsofexperienceFrom.setValue(this.filterData.yearsofexperienceFrom);
    this.filterData.yearsofexperienceTo && this.yearsofexperienceTo.setValue(this.filterData.yearsofexperienceTo);

    this.filterData.currentfromyearsofexperience && this.currentfromyearsofexperience.setValue(this.filterData.currentfromyearsofexperience);
    this.filterData.currenttoyearsofexperience && this.currenttoyearsofexperience.setValue(this.filterData.currenttoyearsofexperience);

    this.keywordSelectedList = _.clone(this.filterData.keywordSelectedList, true);
    this.positionhierarchy = this.filterData.positionhierarchy;
    this.tograduationyearFilter = this.filterData.tograduationyear;
    this.fromgraduationyearFilter = this.filterData.fromgraduationyear;
    this.locationcontinentsName = this.filterData.locationcontinents;
    this.locationContinents = this.filterData.continentstobeincluded;
  }

  private addTypeAheads(aggregatetype: string, localRequestObject: any) {
    switch (aggregatetype) {
      case "current_company": {
        Object.assign(localRequestObject, {
          resultsize: 1,
          aggregatetype: aggregatetype,
          typeahead: "typeahead_currentcompany",
          input: "",
        });
        break;
      }
      case "current_jobtitle": {
        Object.assign(localRequestObject, {
          resultsize: 1,
          aggregatetype: aggregatetype,
          typeahead: "typeahead_currentjobtitle",
          input: "",
        });
        break;
      }
      case "current_industry": {
        Object.assign(localRequestObject, {
          resultsize: 1,
          aggregatetype: aggregatetype,
          typeahead: "typeahead_currentindustry",
          input: "",
        });
        break;
      }
      case "location": {
        Object.assign(localRequestObject, {
          resultsize: 1,
          aggregatetype: aggregatetype,
          typeahead: "typeahead_location",
          input: "",
        });
        break;
      }
      case "skill": {
        Object.assign(localRequestObject, {
          resultsize: 1,
          aggregatetype: aggregatetype,
          typeahead: "typeahead_skills",
          input: "",
        });
        break;
      }
      case "function": {
        Object.assign(localRequestObject, {
          resultsize: 1,
          aggregatetype: aggregatetype,
          typeahead: "typeahead_function",
          input: "",
        });
        break;
      }
      case "school_location": {
        Object.assign(localRequestObject, {
          resultsize: 1,
          aggregatetype: aggregatetype,
        });
        delete localRequestObject["talentdiscoveryhistoryid"];
        delete localRequestObject["calledfrom"];
        break;
      }


      default: {
        console.log('in default - aggregate type - ', aggregatetype);

        Object.assign(localRequestObject, {
          resultsize: 1,
          aggregatetype: aggregatetype,
        });
        delete localRequestObject["input"];
        delete localRequestObject["typeahead"];
        if (aggregatetype == "jobtitle") { localRequestObject["aggregatetype"] = this.getTableByStatus(); }
      }
    }
    delete localRequestObject["talentdiscoveryhistoryid"];
    delete localRequestObject["calledfrom"];
  }

  private getTableByStatus(): any {
    switch (this.jobTitleStatus) {
      case CallStage.CURRENT_OR_PAST.toString():
        return "jobtitle";
      case CallStage.PAST.toString():
        return "pastjobtitle";
      default:
        return "current_jobtitle";
    }
  }

  private callTypeAheadSearch(event: Event, type: string) {
    this.typeAheadSearch(event, type);
  }

  wholeNumberValidation(event) {
    if (/^\-?\d+$/.test(event.target.value)) {
      this.wholeNumberForDistance = true;
    }
    else { this.wholeNumberForDistance = false; }
  }

  private setReceivedData() {
    const receivedData = this.dataService.getData();

    if (!receivedData)
      return;

    if (receivedData.calledFrom == 'advance') {
      this.tabType = 'advanced-search';
      delete receivedData?.requestObject?.fetchtotalpersoncountincontinent;

      const companyList = receivedData.allLists.companySelectedList.filter(c => !c.isSuggested);
      if (companyList && companyList.length) {
        this.getCompanyAiSuggestions();
      }
      for (let x of Object.keys(receivedData.allLists)) {
        // Explicitly allow for this conditions becuse "yearsofexperienceFrom" & "currentfromyearsofexperience" gives by default 0
        if (!receivedData.allLists[x] && (x != 'yearsofexperienceFrom') && (x != 'currentfromyearsofexperience'))
          continue;
        if(x == 'tograduationyear'){
          this.tograduationyearFilter = receivedData.allLists[x];
          this.isGraduationFilterApplied = true;
        } else if(x == 'fromgraduationyear'){
          this.fromgraduationyearFilter = receivedData.allLists[x];
          this.isGraduationFilterApplied = true;
        }
        else if (x == 'yearsofexperienceFrom') {
          this.yearsofexperienceFrom.setValue(receivedData.allLists[x]);
        } else if (x == 'yearsofexperienceTo') {
          this.yearsofexperienceTo.setValue(receivedData.allLists[x]);
        } else if (x == 'currentfromyearsofexperience') {
          this.currentfromyearsofexperience.setValue(receivedData.allLists[x]);
        } else if (x == 'currenttoyearsofexperience') {
          this.currenttoyearsofexperience.setValue(receivedData.allLists[x]);
        } else {
          this[x] = receivedData.allLists[x];
          const keysToRemove = new Set(receivedData.allLists.contactSelectedList.map(item => item.key));
          receivedData.allLists.contactsAvailableArray = receivedData.allLists.contactsAvailableArray.filter(item => !keysToRemove.has(item.key));
        }

        if (x === 'gender') {
          this.isGenderSelected = receivedData.allLists[x]?.toLowerCase() === 'male' || receivedData.allLists[x]?.toLowerCase() === 'female';
        }

        if (x === 'companySelectedList') {
          if (receivedData.allLists[x] && receivedData.allLists[x].length) {

            const companyList = _.pluck(receivedData.allLists[x], 'key');
            this.getCompanyLogoForCompanyChips(companyList);
          }
        }

        if (x == 'distancefromselectedlocations' && receivedData.allLists[x] != 0) {
          this.locationDistanceRange = String(receivedData.allLists[x]);
          this.locationDistanceUnit = receivedData.allLists['distancefromselectedlocationsmeasurementunit'] || 'kilometers';

          this.locationDistanceRangeForFilterData = this.locationDistanceRange;
          this.locationDistanceUnitForFilterData = this.locationDistanceUnit;

          this.locationDistanceRangefromAdvance = this.locationDistanceRange;

        }
        if(x== 'booleanquery'){
          this.searchKeyword = receivedData.allLists[x] != '*' ? receivedData.allLists[x] : '*';
        }
        if (x == 'profilehighlights') {
          this.highlightsSelectedList = this.highlightOptionsObjectFormation(receivedData.allLists[x]);
          this.highlightSelectedControl = _.pluck(this.highlightsSelectedList, 'id');
        }
      if(x == 'positionhierarchies') {
          this.positionhierarchy = receivedData.allLists[x];
        }
        if(x == 'continentstobeincluded') {
          this.locationContinents = receivedData.allLists[x];
        }
        if(x == 'locationcontinents') {
          this.locationcontinentsName = receivedData.allLists[x]
        }
        // else if (x === 'companysize') {
        //   this.isCompanySizeSelected = receivedData?.allLists[x]?.trim()?.toLowerCase() !== 'all';
        // }
      }

      //There is some insconsistency in data of experience some time it gives [] or null, that's why setValue to null for all empty array
      this.experienceDataConsistency();

      this.setExperienceFormData('all');

    } else if (receivedData.calledFrom == 'history') {
      const companyList = receivedData.allLists.companySelectedList.filter(c => !c.isSuggested);
      if (companyList && companyList.length) {
        this.getCompanyAiSuggestions();
      }
      for (let x of Object.keys(receivedData.allLists)) {
        // Explicitly allow for this conditions becuse "yearsofexperienceFrom" & "currentfromyearsofexperience" gives by default 0
        if (!receivedData.allLists[x] && (x != 'yearsofexperienceFrom') && (x != 'currentfromyearsofexperience'))
          continue;
        if (x == 'profilehighlights') {
          this.highlightsSelectedList = this.highlightOptionsObjectFormation(receivedData.allLists[x]);
          this.highlightSelectedControl = _.pluck(this.highlightsSelectedList, 'id');
        }
        if(x == 'tograduationyear'){
          this.tograduationyearFilter = receivedData.allLists[x];
          this.isGraduationFilterApplied = true;
        } else if(x == 'fromgraduationyear'){
          this.fromgraduationyearFilter = receivedData.allLists[x];
          this.isGraduationFilterApplied = true;
        }
        else if (x == 'yearsofexperienceFrom') {
          this.yearsofexperienceFrom.setValue(receivedData.allLists[x]);
        } else if (x == 'yearsofexperienceTo') {
          this.yearsofexperienceTo.setValue(receivedData.allLists[x]);
        } else if (x == 'currentfromyearsofexperience') {
          this.currentfromyearsofexperience.setValue(receivedData.allLists[x]);
        } else if (x == 'currenttoyearsofexperience') {
          this.currenttoyearsofexperience.setValue(receivedData.allLists[x]);
        } else if (x === 'gender') {
          this.isGenderSelected = receivedData.allLists[x]?.toLowerCase() === 'male' || receivedData.allLists[x]?.toLowerCase() === 'female';
          this[x] = receivedData.allLists[x];
        } else if (x == 'continentstobeincluded') {
          if(receivedData.allLists.locationSelectedList && receivedData.allLists.locationSelectedList.length > 0) {
            this.locationSelectedList = receivedData.allLists.locationSelectedList;
          } else if(!this.jdDataService.isComingFromJobDescription && !this.jdDataService.isComingFromNLSearch && !this.similarCandidateService.isListingCalledFromSimilarCandidate){
          this.searchHistoryRegion = receivedData.allLists["continentstobeincluded"][0];
          if(this.searchHistoryRegion)
            this.locationSelectedList.push({key: this.searchHistoryRegion, chipkey: this.searchHistoryRegion, value: this.searchHistoryRegion, location_type: 'continent'});
          }
          if(this.jdDataService.isComingFromJobDescription || this.jdDataService.isComingFromNLSearch || this.similarCandidateService.isListingCalledFromSimilarCandidate || this.isTalentInsightsPage){
            this.locationContinents = receivedData.allLists[x];
          }
        } else {
          this[x] = receivedData.allLists[x];
        }
        if (x == 'changedjobs') {
          this.changedJobStatus = receivedData.allLists[x];
        }
        if (x == 'changedjobsstartdurationinmonths') {
          this.changedJobStartDuration = receivedData.allLists[x];
          this.changedJobDuration = receivedData.allLists[x];
        }
        if (x == 'changedjobsenddurationinmonths') {
          this.changedJobEndDuration = receivedData.allLists[x];
        }
        if (x == 'filterLikelyToMoveIn') {
          this.candidateslikelytomove = receivedData.allLists[x];
        }
        if (x === 'companySelectedList') {
          if (receivedData.allLists[x] && receivedData.allLists[x].length) {

            const companyList = _.pluck(receivedData.allLists[x], 'key');
            this.getCompanyLogoForCompanyChips(companyList);
          }
        }
        if (x == 'distancefromselectedlocations' && receivedData.allLists[x] != 0) {
          this.locationDistanceRange = String(receivedData.allLists[x]);
          this.locationDistanceUnit = receivedData.allLists['distancefromselectedlocationsmeasurementunit'] || 'kilometers';

          this.locationDistanceRangeForFilterData = this.locationDistanceRange;
          this.locationDistanceUnitForFilterData = this.locationDistanceUnit;
        }
        if(x == 'positionhierarchies') {
          this.positionhierarchy = receivedData.allLists[x];
        }
        this.saveSearchTalentDiscoveryHistoryId = this.route.snapshot.queryParams.talentdiscoveryhistoryid;
        console.log(this.saveSearchTalentDiscoveryHistoryId, "talentdiscoveryhistoryid from query params in person search filter")

        this.experienceDataConsistency();

      }
    }
    try {
      this.yearsofexperience = !receivedData?.allLists?.yearsofexperience ? "Total" : receivedData?.allLists?.yearsofexperience;
      this.jobTitleStatus = !receivedData?.allLists?.jobTitleStatus ? CallStage.CURRENT.toString() : receivedData?.allLists?.jobTitleStatus;
      this.companyStatus = !receivedData?.allLists?.companyStatus ? CallStage.CURRENT.toString() : receivedData?.allLists?.companyStatus;
      this.industryStatus = !receivedData?.allLists?.industryStatus ? CallStage.CURRENT.toString() : receivedData?.allLists?.industryStatus;


      this.filterData = this.filterDataHandlerService.fetchFilterData;
      setTimeout(() => {
        this.filterDataHandlerService.emitfilterMethodObject({ methodName: '' });
      });
    } catch (error) {
      console.log('exception while setting data from data service');
      console.log(error);
    }
    if(this.areAllFiltersCleared() &&  (!this.jdDataService.isComingFromJobDescription && !this.jdDataService.isComingFromNLSearch && !this.isSimilarCanidate &&  this.redirectSource != 'talent-insights' && this.redirectSource != 'company-insights')) {
      this.filterEvent.emit('allfilters')
    }
  }

  /**
   *  There is some insconsistency in data of experience some time it gives [] or null, that's why setValue to null for all empty array
   */
  experienceDataConsistency() {
    if (this.yearsofexperienceTo?.value?.length == 0) this.yearsofexperienceTo.setValue(null)
    if (this.yearsofexperienceFrom?.value?.length == 0) this.yearsofexperienceFrom.setValue(null)
    if (this.currenttoyearsofexperience?.value?.length == 0) this.currenttoyearsofexperience.setValue(null)
    if (this.currentfromyearsofexperience?.value?.length == 0) this.currentfromyearsofexperience.setValue(null);
    this.yearsofexperienceFromFilterData = this.yearsofexperienceFrom.value;
    this.yearsofexperienceToFilterData = this.yearsofexperienceTo.value;
    this.currenttoyearsofexperienceFilterData = this.currenttoyearsofexperience.value;
    this.currentfromyearsofexperienceFilterData = this.currentfromyearsofexperience.value;
  }

  private setMatrixFilterData(matrixFilter: MatrixFilter) {
    if (matrixFilter.type === "gender") {
      this.gender = matrixFilter?.event?.target?.value;
      this.isGenderSelected = this.gender != 'All';
    } else if (matrixFilter.type === "likelytomovein") {
      this.filterLikelyToMoveIn = matrixFilter?.event?.target?.value;
      this.isLikelyToMoveInFilterSelected = this.filterLikelyToMoveIn === 'Yes';
      this.candidateslikelytomove = this.filterLikelyToMoveIn;
    } else if (matrixFilter.type === "changedJobs") {
      this.changedJobStatusMatrix = matrixFilter?.event?.target?.value;
      this.changedJobStartDuration = this.changedJobDuration;
      if (this.changedJobStatusMatrix === 'yes') {
        this.changedJobStatus = 'yes';
        this.changedJobEndDuration = matrixFilter?.event?.target?.endDuration;
      }
      else if (this.changedJobStatusMatrix === 'all' && this.changedJobStartDuration && this.changedJobEndDuration != 0) {
        this.changedJobStatus = 'no';
      }
      else {
        this.changedJobStatus = 'all';
      }
    }
    // We are emitting "selectedItem" event so that the pagination can be reset whenever matrix filter changes
    this.syncDataAndMakeAggregateCalls(matrixFilter.type, "selectedItem");
  }

  private syncDataAndMakeAggregateCalls(aggregateType: string, methodName?: string) {
    this.syncFilterData();
    this.filterDataHandlerService.setFilterData(this.filterData);
    this.aggReqObjectHandlerService.setStartIndex(0);
    this.setFilterDataInLocalStorage();
    this.filterDataHandlerService.shouldSendPersonSearchRequest() && this.aggService.getPersonSearchRecommendedCandidates(this.extraInfo);
    this.getexpandrefresheddata(aggregateType);
    // We are emitting this event so that the pagination can be reset whenever matrix filter changes
    if (!!methodName) this.filterDataHandlerService.emitfilterMethodObject({ methodName: methodName })
  }

  private handleYOEUpdateEvent(typeData: {
    yoeType: string;
    emmitedFrom: string;
  }) {
    if (typeData.emmitedFrom === GeneralConstants.COMPONENT_NAME.PERSON_SEARCH_FILTER)
      return;
    this.yearsofexperience = typeData.yoeType;
    this.filterDataHandlerService.setYOEType(this.yearsofexperience);

    if (GeneralConstants.YOE_TYPE.AVG === typeData.yoeType) {
      this.getAggregationReport("averageyearsofexperience");
    }
    else if (GeneralConstants.YOE_TYPE.TOTAL === typeData.yoeType) {
      this.getAggregationReport("totalyearsofexperience");
    }
  }

  private hasYOEExperienceData(): boolean {
    return typeof this.yearsofexperienceFrom?.value === "number" &&
      typeof this.yearsofexperienceTo?.value === "number" &&
      this.yearsofexperienceFrom?.value >= 0 &&
      this.yearsofexperienceTo?.value >= 0;
  }

  private hasCurrentYOEExperienceData(): boolean {
    return typeof this.currentfromyearsofexperience?.value === "number" &&
      typeof this.currenttoyearsofexperience?.value === "number" &&
      this.currentfromyearsofexperience?.value >= 0 &&
      this.currenttoyearsofexperience?.value >= 0;
  }


  showQuickSearchFilters() {
    if (this.filterType == 'skill') {
      this.skillsSelectedList.push({ key: this.searchChips == 'SearchChips' ? this.filterValue + '.searchastext' : this.filterValue, isExcluded: false, isMandatory: false, chipkey: this.filterValue });
    } if (this.filterType == 'jobtitle') {
      this.jobTitleSelectedList.push({ key: this.searchChips == 'SearchChips' ? this.filterValue + '.searchastext' : this.filterValue, isExcluded: false, isMandatory: false, chipkey: this.filterValue });
    } if (this.filterType == 'company') {
      this.companySelectedList.push({ key: this.searchChips == 'SearchChips' ? this.filterValue + '.searchastext' : this.filterValue, isExcluded: false, isMandatory: false, chipkey: this.filterValue });
      this.getCompanyLogoForCompanyChips([this.filterValue]);
    } if (this.filterType == 'searchKeyword' || this.keywordInput.value) {
      this.keywordInput.patchValue(this.searchKeyword);
      this.keyWordInputValue = this.searchKeyword;
    } if (this.filterType == 'fullname') {
      this.fullNameSelectedList.push({ key: this.searchChips == 'SearchChips' ? this.filterValue + '.searchastext' : this.filterValue, chipkey: this.filterValue });
    } if (this.searchTitle) {
      this.jobTitleSelectedList.push({ key: this.searchTitle, isExcluded: false, isMandatory: false, chipkey: this.searchTitle });
    } if (this.searchCompany) {
      this.companySelectedList.push({ key: this.searchCompany, isExcluded: false, isMandatory: false, chipkey: this.searchCompany });
    }
    //  this.aggReqObjectHandlerService.setStartIndex(0);
    this.syncFilterData();
    this.filterDataHandlerService.setFilterData(this.filterData);
    //  this.aggReqObjectHandlerService.setStartIndex(0);
    this.setFilterDataInLocalStorage(true);
    this.aggService.getPersonSearchRecommendedCandidates(this.extraInfo);
    this.getexpandrefresheddata(this.filterType);
    this.filterDataHandlerService.emitfilterMethodObject({ methodName: "addToSelectedList", filterType: this.filterType });
  }

  search(event) {
    event.preventDefault();

    this.searchKeyword = this.keywordInput.value.trim();
    this.keyWordInputValue = this.searchKeyword;
    // this.router.navigate([], {
    //   relativeTo: this.route,
    //   queryParams: {
    //     keyword: this.keywordInput.value.trim()
    //   },
    //   queryParamsHandling: 'merge',
    // });
    this.filterData.booleanquery = this.searchKeyword;
    this.filterEvent.emit('showFilters');

    this.syncFilterData();
    this.filterDataHandlerService.setFilterData(this.filterData);
    this.aggReqObjectHandlerService.setStartIndex(0);
    this.setFilterDataInLocalStorage();
    this.aggService.getPersonSearchRecommendedCandidates(this.extraInfo);
    this.getexpandrefresheddata(this.filterType);


    this.searchDisable = false;
    if (this.filterDataHandlerService.isRedirectFromCompanyInsightsPage || this.filterDataHandlerService.isRedirectFromTalentInsightsPage || this.similarCandidateService.isListingCalledFromSimilarCandidate || this.isReportDetails || this.isCompanyInsightsDetails) {
      this.syncFilterData();
      this.filterDataHandlerService.setFilterData(this.filterData);
      this.aggReqObjectHandlerService.setStartIndex(0);
      this.aggService.getPersonSearchRecommendedCandidates(this.extraInfo);
      this.getexpandrefresheddata(this.filterType);
    }
    this.isSearchSaved = false;
    this.setTalentInsightsHistory();
    this.filterDataHandlerService.emitfilterMethodObject({ methodName: "searchInput", filterType: 'keyword' });
  }

  /**
   * Used to call search history api only for talent insights
   */
  setTalentInsightsHistory() {
    if(!this.talentInsightsReqHandler.isTalentInsightsTab) return;
    const reqBody = this.aggService.getRequestWithFilters(this.extraInfo)
    delete reqBody['aggregatetype'];
    delete reqBody['aggregatescount'];
    delete reqBody['resultsize'];
    delete reqBody['startindex'];

    reqBody['talentdiscoveryhistoryid'] = this.localstorageservice.getItem('talentInsightsHistoryId');
    reqBody['module'] = GlobalService.HISTORY_MODULE.TALENT_INSIGHTS;
     const aiSuggestions = this.localstorageservice.getItem('aiSuggestions');
    if(aiSuggestions) {
    const job_search_keys = {
      jobtitles: aiSuggestions?.jobtitles,
      skills: aiSuggestions?.skills
    }
    reqBody['job_search_keys'] = job_search_keys;
    }
    this.personSearchService.setInsightsHistory(reqBody).subscribe((res) => {
      this.localstorageservice.setItem('talentInsightsHistoryId', res.talentdiscoveryhistoryid);
    });
  }

  searchclick() {
    this.searchDisable = true;
  }

  /**
   * Check if current search (via historyid) is saved
   */
  getSavedSearchDetails() {
    this.isSearchSaved = false;
    const module = (this.isPersonSearchListingPage) ? GlobalService.HISTORY_MODULE.PERSON_SEARCH : GlobalService.HISTORY_MODULE.TALENT_INSIGHTS;
    const historyid = (this.isPersonSearchListingPage) ? this.talentDiscoveryHistoryId : this.localstorageservice.getItem('talentInsightsHistoryId');
    this.personSearchService.getSaveSearchHistory(0, module, historyid).subscribe((res: any) => {
      if (res && res.status === 'success') {
        if (res.message && (Array.isArray(res.message) && res.message?.length)) {
          this.savedSearchDetails = res.message[0];
          this.savedSearchDetails && (this.isSearchSaved = true);
        }
      }
    });
  }

  saveSearch() {
    // console.log("hhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhh", this.talentDiscoveryHistoryId, this.isPersonSearchListingPage)
    if (!this.talentDiscoveryHistoryId && this.isPersonSearchListingPage) return;
    const module = (this.isPersonSearchListingPage) ? GlobalService.HISTORY_MODULE.PERSON_SEARCH : GlobalService.HISTORY_MODULE.TALENT_INSIGHTS;
    const modalRef = this.modalService.open(SaveSearchModalComponent, { windowClass: "modalExtract", centered: true, keyboard: false, backdrop: 'static' });
    modalRef.componentInstance.talentdiscoveryhistoryid = (this.isPersonSearchListingPage) ? this.talentDiscoveryHistoryId : this.localstorageservice.getItem('talentInsightsHistoryId');
    modalRef.componentInstance.module = module;
    modalRef.result
      .then((message: any) => {
        if (message && message === 'Saved successfully') {
          this.isSearchSaved = true;
          this.saveSearchTalentDiscoveryHistoryId = (this.isPersonSearchListingPage) ? this.talentDiscoveryHistoryId : this.localstorageservice.getItem('talentInsightsHistoryId');
          this.successMessage = 'Search saved successfully';

        }
      })
      .catch((err: any) => {
        this.errorMessage = 'Something went wrong';
      })
      .finally(() => {
        // this.getSavedSearchDetails();
        setTimeout(() => {
          this.successMessage = '';
          this.errorMessage = '';
        }, 5000);
      })
    const data = this.filterDataHandlerService.fetchFilterData
    data.talentdiscoveryhistoryid = null;
    this.filterDataHandlerService.setFilterData(data);

    // if(this.isPersonSearchListingPage){
    //   this.talentDiscoveryHistoryId = null;
    //   this.localstorageservice.setItem('talentdiscoveryhistoryid', null);
    // } else{
    //   this.localstorageservice.setItem('talentInsightsHistoryId', null);
    // }
  }

  selectRegion(region) {
    this.searchHistoryRegion = null;
    this.showregion = region;
    //Highlight filter is not present in europe region.
    if (region === 'europe') {
      this.highlightsSelectedList = [];
      this.highlightSelectedControl = [];
    }
    if (this.isPersonSearchListingPage) {
      this.localstorageservice.setItem('region', region)
    }
    else if (this.isTalentInsightsPage) {
      this.localstorageservice.setItem('talentRegion', region);
    }
    this.locationSelectedList = [];
    this.localstorageservice.setItem('region', region)
    this.sessionStorageService.setItem("historyRegion", null)
    // this.filterDataHandlerService.setUpdatedContinent(true)
    this.syncFilterData();
    if (this.isTalentInsightsPage) {
      this.filterData['continentstobeincluded'] = [this.showregion];
    }
    this.filterDataHandlerService.setFilterData(this.filterData);
    this.aggReqObjectHandlerService.setStartIndex(0);
    this.setFilterDataInLocalStorage();
    this.filterDataHandlerService.emitfilterMethodObject({ methodName: "changeContinent" });

    this.aggService.getPersonSearchRecommendedCandidates(this.extraInfo);
    this.getexpandrefresheddata(this.filterType);
    this.document.documentElement.scrollTop = 0;

    this.isSearchSaved = false;
    this.setTalentInsightsHistory();
  }

  keyword(event) {
    if (event.target.value == "") {
      this.keywordInput.patchValue(null); this.searchKeyword = '';
      this.keyWordInputValue = '';
      this.router.navigate([], {
        relativeTo: this.route,
        queryParams: {
          keyword: ''
        },
        queryParamsHandling: 'merge',
      });
      this.syncFilterData();
      this.filterDataHandlerService.setFilterData(this.filterData);
      this.aggReqObjectHandlerService.setStartIndex(0);
      this.aggService.getPersonSearchRecommendedCandidates(this.extraInfo);
      this.getexpandrefresheddata(this.filterType);
      this.filterDataHandlerService.emitfilterMethodObject({ methodName: "searchInput" });
    }
  }

  getExpandFilterData() {
    if (document.getElementById('collapseOne')?.classList.contains('show') && this.jobTitleSelectedList.length > 0) {
      this.getFilterWiseDataToDisplay('jobtitle')
    }

    if (document.getElementById('collapseFour')?.classList.contains('show') && this.companySelectedList.length > 0) {
      this.getFilterWiseDataToDisplay('company')
    }
    //for past jobtitle
    if (document.getElementById('collapsePastJobTitle')?.classList.contains('show') && this.pastJobTitleSelectedList.length > 0) {
      this.getFilterWiseDataToDisplay(this.filterNames.PAST_JOB_TITLE);
    }
    //for location
    if (document.getElementById('collapseTwo')?.classList.contains('show') && this.locationSelectedList.length > 0) {
      this.getFilterWiseDataToDisplay('location');
    }
    //for skills
    if (document.getElementById('collapseThree')?.classList.contains('show') && this.skillsSelectedList.length > 0) {
      this.getFilterWiseDataToDisplay('skills');
    }
    //for industries
    if (document.getElementById('collapseSix')?.classList.contains('show') && this.industrySelectedList.length > 0) {
      this.getFilterWiseDataToDisplay('industry')
    }
    //for education
    if (document.getElementById('collapseTwelve')?.classList.contains('show') && this.educationSelectedList.length > 0) {
      this.getFilterWiseDataToDisplay('education');
    }
    //for school
    if (document.getElementById('collapseFourteen')?.classList.contains('show') && this.schoolSelectedList.length > 0) {
      this.getFilterWiseDataToDisplay('school');
    }
    // for field of study
    if (document.getElementById('collapseFifteen')?.classList.contains('show') && this.fieldOfStudySelectedList.length > 0) {
      this.getFilterWiseDataToDisplay('field_of_study');
    }
    // for functions
    if (document.getElementById('collapseEighteen')?.classList.contains('show') && this.functionSelectedList.length > 0) {
      this.getFilterWiseDataToDisplay('function');
    }
    // for years of experience
    if (document.getElementById('collapseSeven')?.classList.contains('show') && this.hasYOEExperienceData()) {
      this.getFilterWiseDataToDisplay('yearsofexperience')
    }
    // for years of experience
    if (document.getElementById('collapeSevenCurrent')?.classList.contains('show') && this.hasCurrentYOEExperienceData()) {
      this.getFilterWiseDataToDisplay('currentyearsofexperience');
    }
    // for education location
    if (document.getElementById('schoollocation')?.classList.contains('show') && this.schoolLocationSelectedList.length > 0) {
      this.getFilterWiseDataToDisplay('schoollocation');
    }
  }

  /**
   * Method to refresh all the open suggession filter
   */
  hideExpandSuggession() {

    /** Default State fro jobtitles aggregate */
    // if (document.getElementById('collapseOne')?.classList.contains('show') && this.jobTitleSelectedList.length == 0) {
    //   document.getElementById('collapseOne').classList.remove('show');
    //   document.getElementById('collapseOneBtn').classList.add('collapsed');
    //   this.jobTitleTopList = [];
    // }

    const collapseOne = document.getElementById('collapseOne');
    const collapseOneBtn = document.getElementById('collapseOneBtn');

    if (
      collapseOne?.classList.contains('show') &&
      this.jobTitleSelectedList.length === 0
    ) {
      collapseOne.classList.remove('show');

      collapseOneBtn?.classList.add('collapsed');

      this.jobTitleTopList = [];
    }

    /** Default State fro company aggregate */
    if (document.getElementById('collapseFour')?.classList.contains('show') && this.companySelectedList.length == 0) {
      document.getElementById('collapseFour').classList.remove('show');
      document.getElementById('collapseFourBtn').classList.add('collapsed');
      this.companyTopList = [];
    }

    //for past jobtitle
    if (document.getElementById('collapsePastJobTitle')?.classList.contains('show') && this.pastJobTitleSelectedList.length == 0) {
      document.getElementById('collapsePastJobTitle').classList.remove('show');
      document.getElementById('collapsePastJobTitleBtn').classList.add('collapsed');
      this.pastJobTitleTopList = [];
    }

    //for location
    if (document.getElementById('collapseTwo')?.classList.contains('show') && this.locationSelectedList.length == 0) {
      document.getElementById('collapseTwo').classList.remove('show');
      document.getElementById('collapseTwoBtn').classList.add('collapsed');
      this.locationTopList = [];
    }

    //for skills
    if (document.getElementById('collapseThree')?.classList.contains('show') && this.skillsSelectedList.length == 0) {
      this.skillsTopList = [];
      document.getElementById('collapseThree').classList.remove('show');
      document.getElementById('collapseThreeBtn').classList.add('collapsed');
    }

    //for industries
    if (document.getElementById('collapseSix')?.classList.contains('show') && this.industrySelectedList.length == 0) {
      document.getElementById('collapseSix').classList.remove('show');
      document.getElementById('collapseSixBtn').classList.add('collapsed');
      this.industryTopList = [];
    }

    //for education
    if (document.getElementById('collapseTwelve')?.classList.contains('show') && this.educationSelectedList.length == 0) {
      document.getElementById('collapseTwelve').classList.remove('show');
      document.getElementById('collapseTwelveBtn').classList.add('collapsed');
      this.educationTopList = [];
    }

    //for school
    if (document.getElementById('collapseFourteen')?.classList.contains('show') && this.schoolSelectedList.length == 0) {
      document.getElementById('collapseFourteen').classList.remove('show');
      document.getElementById('collapseFourteenBtn').classList.add('collapsed');
      this.schoolTopList = [];
    }

    // for field of study
    if (document.getElementById('collapseFifteen')?.classList.contains('show') && this.fieldOfStudySelectedList.length == 0) {
      document.getElementById('collapseFifteen').classList.remove('show');
      document.getElementById('collapseFifteenBtn').classList.add('collapsed');
      this.fieldOfStudyTopList = [];
    }

    // for functions
    if (document.getElementById('collapseEighteen')?.classList.contains('show') && this.functionSelectedList.length == 0) {
      document.getElementById('collapseEighteen').classList.remove('show');
      document.getElementById('collapseEighteenBtn').classList.add('collapsed');
      this.functionTopList = [];
    }

    // for years of experience
    if (document.getElementById('collapseSeven')?.classList.contains('show')) {
      document.getElementById('collapseSeven').classList.remove('show');
      document.getElementById('collapseSevenBtn').classList.add('collapsed');
    }

    // for years of experience
    if (document.getElementById('collapeSevenCurrent')?.classList.contains('show')) {
      document.getElementById('collapeSevenCurrent').classList.remove('show');
      document.getElementById('collapeSevenCurrentBtn').classList.add('collapsed');
    }

    // for education location
    if (document.getElementById('schoollocation')?.classList.contains('show') && this.schoolLocationSelectedList.length == 0) {
      document.getElementById('schoollocation').classList.remove('show');
      document.getElementById('schoollocationBtn').classList.add('collapsed');
      this.schoolLocationTopList = [];
    }
  };

  removeTypeahead(type: any) {
    const maxLength = 3
    switch (type) {
      case 'jobtitle': {
        if (!(this.jobTitleInput && this.jobTitleInput.value && this.jobTitleInput.value.length >= maxLength)) {
          this.jobTitleList = []
        }
        break;
      }
      case 'skills': {
        if (!(this.skillsInput && this.skillsInput.value)) {
          this.skillsList = []
        }
        break;
      }
      case 'company': {
        if (!(this.companyInput && this.companyInput.value)) {
          this.companyList = []
        }
        break;
      }
      case 'industry': {
        if (!(this.industryInput && this.industryInput.value && this.industryInput.value.length >= maxLength)) {
          this.industryList = []
        }
        break;
      }
      case 'fieldofstudy': {
        if (!(this.fieldOfStudyInput && this.fieldOfStudyInput.value && this.fieldOfStudyInput.value.length >= maxLength)) {
          this.fieldOfStudyList = []
        }
        break;
      }
      case 'fullname': {
        if(!(this.fullNameInput.value?.length >= maxLength)){
          this.fullNameList = [];
        }
        break;
      }
      case 'education': {
        if (!(this.educationInput && this.educationInput.value && this.educationInput.value.length >= maxLength)) {
          this.educationList = []
        }
        break;
      }
      case 'school': {
        if (!(this.schoolInput && this.schoolInput.value && this.schoolInput.value.length >= maxLength)) {
          this.schoolList = []
        }
        break;
      }
      case 'location': {
        if (!(this.locationInput && this.locationInput.value && this.locationInput.value.length >= maxLength)) {
          this.locationList = []
        }
        break;
      }
      case 'pastjobtitle': {
        if (!(this.pastJobTitleInput && this.pastJobTitleInput.value && this.pastJobTitleInput.value.length >= maxLength)) {
          this.pastJobTitleList = []
        }
        break;
      }
      case 'functions': {
        if (!(this.functionsInput && this.functionsInput.value && this.functionsInput.value.length >= maxLength)) {
          this.functionsList = []
        }
        break;
      }
      case 'schoollocation': {
        if (!(this.schoolLocationInput && this.schoolLocationInput.value && this.schoolLocationInput.value.length >= maxLength)) {
          this.schoolLocationList = []
        }
        break;
      }
    }
  }

  openaiTitleLoading({ state, count, suggested }) {
    this.isOpenAITitleLoading = state;
    this.showOpenAITitleSuggestions = count;
    suggested && (this.aiSuggestedTitles = suggested);
    this.aiQuery && !state && (suggested !== undefined && suggested !== null) && suggested.length < 5 && this.getFilterWiseDataToDisplay('jobtitle', true);
  }

  setTitleSuggestions(suggestions: SuggestedTitle[]) {
    // generate key for each suggestion
    const suggestionsWithKey = suggestions.map(suggestion => {
      return {
        key: `${suggestion.name}.aisearch`,
        chipkey: suggestion.name,
        isExcluded: false,
        isMandatory: false,
        isSuggestion: true,
        isSuggested: true,
        suggestedTitle: { name: suggestion.name, selected: true, type: 'title', key: this.getSafeKey(suggestion.name) }
      };
    });
    const existingSuggestions = this.jobTitleSelectedList.filter(suggestion => suggestion.isSuggested);
    const newSuggestions = suggestionsWithKey.filter(suggestion => !existingSuggestions.find(existingSuggestion => existingSuggestion.chipkey === suggestion.chipkey));
    let removedSuggestions = [];
    if (newSuggestions.length) {
      this.jobTitleSelectedList = this.jobTitleSelectedList.concat(newSuggestions);
    } else {
      removedSuggestions = existingSuggestions.filter(suggestion => !suggestionsWithKey.find(s => s.chipkey === suggestion.chipkey));
      removedSuggestions.length && (this.jobTitleSelectedList = this.jobTitleSelectedList.filter(chiplist => chiplist.chipkey != removedSuggestions[0].chipkey));
    }

    this.updateFilterData('jobtitle');
  }

  openaiPastJobTitleLoading({ state, count, suggested }) {
    this.isOpenAIPastJobTitleLoading = state;
    this.showOpenAIPastJobTitleSuggestions = count;

    suggested && (this.aiSuggestedPastJobTitles = suggested);

    this.aiQuery && !state && (suggested !== undefined && suggested !== null) && suggested.length < 5 && this.getFilterWiseDataToDisplay('pastjobtitle', true);
  }

  setPastJobTitleSuggestions(suggestions: SuggestedTitle[]) {
    // generate key for each suggestion
    const suggestionsWithKey = suggestions.map(suggestion => {
      return {
        key: `${suggestion.name}.aisearch`,
        chipkey: suggestion.name,
        isExcluded: false,
        isMandatory: false,
        isSuggestion: true,
        isSuggested: true,
        suggestedTitle: { name: suggestion.name, selected: true, type: 'title', key: this.getSafeKey(suggestion.name) }
      };
    });
    const existingSuggestions = this.pastJobTitleSelectedList.filter(suggestion => suggestion.isSuggested);
    const newSuggestions = suggestionsWithKey.filter(suggestion => !existingSuggestions.find(existingSuggestion => existingSuggestion.chipkey === suggestion.chipkey));
    let removedSuggestions = [];
    if (newSuggestions.length) {
      this.pastJobTitleSelectedList = this.pastJobTitleSelectedList.concat(newSuggestions);
    } else {
      removedSuggestions = existingSuggestions.filter(suggestion => !suggestionsWithKey.find(s => s.chipkey === suggestion.chipkey));
      removedSuggestions.length && (this.pastJobTitleSelectedList = this.pastJobTitleSelectedList.filter(chiplist => chiplist.chipkey != removedSuggestions[0].chipkey));
    }

    this.updateFilterData('pastjobtitle');
  }

  openaiSkillsLoading({ state, count, suggested }) {
    this.isOpenAISkillsLoading = state;
    this.showOpenAISkillsSuggestions = count;

    suggested && (this.aiSuggestedSkills = suggested);
    this.aiQuery && !state && (suggested !== undefined && suggested !== null) && suggested.length < 5 && this.getFilterWiseDataToDisplay('skills', true);
  }

  setSkillsSuggestions(suggestions: SuggestedTitle[]) {
    const suggestionsWithKey = suggestions.map(suggestion => {
      return {
        key: `${suggestion.name}.aisearch`,
        chipkey: suggestion.name,
        isExcluded: false,
        isMandatory: false,
        isSuggestion: true,
        isSuggested: true,
        suggestedTitle: { name: suggestion.name, selected: true, type: 'skill', key: this.getSafeKey(suggestion.name) }
      };
    });
    const existingSuggestions = this.skillsSelectedList.filter(suggestion => suggestion.isSuggested);
    const newSuggestions = suggestionsWithKey.filter(suggestion => !existingSuggestions.find(existingSuggestion => existingSuggestion.chipkey === suggestion.chipkey));
    let removedSuggestions = [];
    if (newSuggestions.length) {
      this.skillsSelectedList = this.skillsSelectedList.concat(newSuggestions);
    } else {
      removedSuggestions = existingSuggestions.filter(suggestion => !suggestionsWithKey.find(s => s.chipkey === suggestion.chipkey));
      removedSuggestions.length && (this.skillsSelectedList = this.skillsSelectedList.filter(chiplist => chiplist.chipkey != removedSuggestions[0].chipkey));
    }
    this.updateFilterData('skills');
  }

  private getSafeKey(str: string): string {
    return str.toLowerCase().replace(/[^a-zA-Z0-9]/g, '');
  }

  updateFilterData(type: string) {
    this.aggReqObjectHandlerService.setStartIndex(0);
    this.syncFilterData();
    this.filterDataHandlerService.setFilterData(this.filterData);
    this.aggReqObjectHandlerService.setStartIndex(0);
    if (this.isCompanyInsightsDetails) {
      this.getTopList();
    }
    this.setFilterDataInLocalStorage();
    this.filterDataHandlerService.shouldSendPersonSearchRequest() && this.aggService.getPersonSearchRecommendedCandidates(this.extraInfo);
    this.getexpandrefresheddata(type);
    this.filterDataHandlerService.emitfilterMethodObject({ methodName: "addToSelectedList", filterType: type });
    this.document.documentElement.scrollTop = 0;

    this.isSearchSaved = false;
    this.setTalentInsightsHistory();
  }

  getCompanyAiSuggestions() {
    this.companyAiSuggestions = [];
    const payload = {
      startindex: 0,
      resultsize: 10,
      searchviaboolean: true,
      booleanquery: "*",
      industries: [],
      locations: [],
      companysizes: [],
      companynames: this.companySelectedList.filter(c => !c.isSuggesteds).map(company => company.key.replace('.aisearch', '')),
    }
    this.companyInsightsService.getRecommendedcompanies(payload).subscribe((res: any) => {
      if (res && res.status === 'success') {
        this.industryForCompanyAiSuggestions = res?.data?.results ? res?.data?.results.filter(company => this.companySelectedList.find(c => c.chipkey.toLowerCase() == company.name)).map(company => company.industry) : [];
        const localRequestObject = this.aggService.getRequestWithFilters(this.extraInfo);
        localRequestObject['industries'] = _.uniq(this.industryForCompanyAiSuggestions);

        const aggregatetype = this.companyStatus == 'Current' ? 'current_company' : this.companyStatus == 'Past' ? 'pastcompany' : 'company'
        this.addTypeAheads(aggregatetype, localRequestObject);

        this.personSearchService.getTotalAggs(localRequestObject).subscribe((response) => {
          if (response && response.status === 'success') {
            const reportsAggs = response.data.aggregations;
            this.companyAiSuggestions = this.companyStatus == 'Current' ? reportsAggs?.current_company : this.companyStatus == 'Past' ? reportsAggs?.pastcompany : reportsAggs?.company || [];;
            this.companyAiSuggestions = this.companyAiSuggestions.filter(c => !this.companySelectedList.find(company => company.chipkey.toLowerCase() == c.key)).slice(0, 5).map(c => ({
              ...c, key: `${c.key}.aisearch`,
              chipkey: c.key,
              isExcluded: false,
              isMandatory: false,
              isSuggestion: true,
              isSuggested: true,
            }))
          }
        });
      }
    });
  }

  showEUAcknowledgeModal(type?) {
    const euData = this.localstorageservice.getItem('euConscent');
    const now = new Date().getTime();

    if (euData) {
      const parsedData = JSON.parse(euData);
      if (!parsedData.lastShown || now - parseInt(parsedData.lastShown, 10) > 24 * 60 * 60 * 1000) {
        const modalRef = this.modalService.open(EuropeAccessModalComponent, { windowClass: 'euAccessModal', centered: true, backdrop: 'static', keyboard: false });
        modalRef.result.then((res) => {
          if (res.action == "success") {
            this.aggReqObjectHandlerService.setStartIndex(0);
            this.syncFilterData();
            this.filterDataHandlerService.setFilterData(this.filterData);
            this.aggReqObjectHandlerService.setStartIndex(0);
            if (this.isCompanyInsightsDetails) {
              this.getTopList();
            }
            this.filterDataHandlerService.shouldSendPersonSearchRequest() && this.aggService.getPersonSearchRecommendedCandidates(this.extraInfo);
            this.getexpandrefresheddata(type);
            this.filterDataHandlerService.emitfilterMethodObject({ methodName: "addToSelectedList", filterType: type });
            this.document.documentElement.scrollTop = 0;

            this.isSearchSaved = false;
            this.setTalentInsightsHistory();
          }
        })
      }
    } else {
      this.aggReqObjectHandlerService.setStartIndex(0);
      this.syncFilterData();
      this.filterDataHandlerService.setFilterData(this.filterData);
      this.aggReqObjectHandlerService.setStartIndex(0);
      if (this.isCompanyInsightsDetails) {
        this.getTopList();
      }
      this.filterDataHandlerService.shouldSendPersonSearchRequest() && this.aggService.getPersonSearchRecommendedCandidates(this.extraInfo);
      this.getexpandrefresheddata(type);
      this.filterDataHandlerService.emitfilterMethodObject({ methodName: "addToSelectedList", filterType: type });
      this.document.documentElement.scrollTop = 0;

      this.isSearchSaved = false;
      this.setTalentInsightsHistory();
    }
  }

/**
 * select keyword filter data
 * @param item
 * @param type
 * @param from
 */
  addToSelectFilterModal(item, type, from: any = null) {
    switch (type) {
      case 'jobtitle': {
        if (from == 'enter') {
          item = { key: item.toLowerCase(), doc_count: 0 }
          this.jobTitleSelectedList.push({ key: item.key + ".searchastext", isExcluded: false, isMandatory: false, chipkey: item.key });
        } else {
          if (this.talentInsightsReqHandler.isTalentInsightsTab) {
            this.jobTitleSelectedList.push({ key: item.key + ".searchastext", isExcluded: false, isMandatory: false, chipkey: item.key });
          } else {
            this.jobTitleSelectedList.push({ ...item, isExcluded: false, isMandatory: false, chipkey: item.key });
          }
        }
        this.jobTitleSelectedList = _.uniq(this.jobTitleSelectedList, 'chipkey');
        this.jobTitleInput.reset();
        break;
      }
      case this.filterNames.PAST_JOB_TITLE: {
        if (from == 'enter') {
          item = { key: item.toLowerCase(), doc_count: 0 }
          this.pastJobTitleSelectedList.push({ key: item.key + ".searchastext", isExcluded: false, isMandatory: false, chipkey: item.key });
        } else {
          if (this.talentInsightsReqHandler.isTalentInsightsTab) {
            this.pastJobTitleSelectedList.push({ key: item.key + ".searchastext", isExcluded: false, isMandatory: false, chipkey: item.key });
          } else {
            this.pastJobTitleSelectedList.push({ ...item, isExcluded: false, isMandatory: false, chipkey: item.key });
          }
        }
        this.pastJobTitleSelectedList = _.uniq(this.pastJobTitleSelectedList, 'chipkey');
        this.pastJobTitleInput.reset();
        break;
      }
      case 'location': {
        if (from == 'enter') {
          item = { key: item.toLowerCase(), doc_count: 0 }
          this.locationSelectedList.push({ key: item.key + ".searchastext", isExcluded: false, isMandatory: false, chipkey: item.key, location_type: null });
        } else {
          this.locationSelectedList.push({ key: item?.key , isExcluded: false, isMandatory: false, chipkey: item.key, continent: item?.location_continent ? item?.location_continent[0]?.key: null });
        }
          const filter = this.filterDataHandlerService.fetchFilterData
        this.locationcontinentsName = filter.locationcontinents;
        this.locationContinents = filter.continentstobeincluded;
        this.locationSelectedList = _.uniq(this.locationSelectedList, 'chipkey');
        const includeLocations = this.locationSelectedList.filter(x=>x.isExcluded == false);
        this.locationContinents.push(_.uniq(_.pluck(includeLocations, 'continent')));
        this.locationContinents = _.uniq(_.flatten(this.locationContinents));
        this.locationContinents = this.locationContinents?.filter(item => item !== null && item !== undefined);
        this.locationContinents = _.flatten(_.uniq(this.locationContinents));
        if (item?.location_continent && item?.location_continent.length) {
          this.locationcontinentsName?.push({ key: item?.key, continent: item?.location_continent[0]?.key, calledFrom: 'Filter' })
        }
        this.locationInput.reset();
        break;
      }
      case 'skills': {
        if (from == 'enter') {
          item = { key: item.toLowerCase(), doc_count: 0 }
          this.skillsSelectedList.push({ key: item.key + '.searchastext', isExcluded: false, isMandatory: false, chipkey: item.key });
        } else {
          this.skillsSelectedList.push({ ...item, isExcluded: false, isMandatory: false, chipkey: item.key });
        }
        this.skillsSelectedList = _.uniq(this.skillsSelectedList, 'chipkey');
        this.skillsInput.reset();
        break;
      }
      case 'company': {
        if (from == 'enter') {
          item = { key: item.toLowerCase(), doc_count: 0 }
          this.companySelectedList.push({ key: item.key + '.searchastext', isExcluded: false, isMandatory: false, chipkey: item.key, companylogo: item?.companylogo });
          this.getCompanyLogoForCompanyChips([item.key]);
        } else {
          this.companySelectedList.push({ ...item, isExcluded: false, isMandatory: false, chipkey: item.chipkey ? item.chipkey : item.key, companylogo: item?.companylogo });
        }
        this.companySelectedList = _.uniq(this.companySelectedList, 'chipkey');
        this.companyAiSuggestions = this.companyAiSuggestions.filter(c => !this.companySelectedList.some(cs => cs.chipkey == c.chipkey));

        if (!item.isSuggested) {
          const companyList = this.companySelectedList.filter(c => !c.isSuggested);
          if (companyList && companyList.length && !this.aiSourcingService.isAISourcingTab) {
            this.getCompanyAiSuggestions();
          }
        }
        this.companyInput.reset();
        break;
      }
      case 'industry': {
        if (from == 'enter') {
          item = { key: item.toLowerCase(), doc_count: 0 }
          this.industrySelectedList.push({ key: item.key + '.searchastext', isExcluded: false, isMandatory: false, chipkey: item.key });
        } else {
          this.industrySelectedList.push({ ...item, isExcluded: false, isMandatory: false, chipkey: item.key });
        }
        this.industrySelectedList = _.uniq(this.industrySelectedList, 'chipkey');
        this.industryInput.reset();
        break;
      }
      case 'fieldofstudy': {
        if (from == 'enter') {
          item = { key: item.toLowerCase(), doc_count: 0 }
          this.fieldOfStudySelectedList.push({ key: item.key + '.searchastext', isExcluded: false, isMandatory: false, chipkey: item.key });
        } else {
          this.fieldOfStudySelectedList.push({ ...item, isExcluded: false, isMandatory: false, chipkey: item.key });
        }
        this.fieldOfStudySelectedList = _.uniq(this.fieldOfStudySelectedList, 'chipkey');
        this.fieldOfStudyInput.reset();
        break;
      }
      case 'fullname': {
        if(from == 'enter'){
          item = {key: item.toLowerCase(), doc_count: 0};
          this.fullNameSelectedList.push({key: item.key + `.searchastext`, isExcluded: false, isMandatory: false, chipkey: item.key});
        } else{
          this.fullNameSelectedList
        }
        this.fullNameSelectedList = _.uniq(this.fullNameSelectedList,'chipkey');
        this.fullNameInput.reset();
        break;
      }
      case 'school': {
        if (from == 'enter') {
          item = { key: item.toLowerCase(), doc_count: 0 }
          this.schoolSelectedList.push({ key: item.key + '.searchastext', isExcluded: false, isMandatory: false, chipkey: item.key });
        } else {
          this.schoolSelectedList.push({ ...item, isExcluded: false, isMandatory: false, chipkey: item.key });
        }
        this.schoolSelectedList = _.uniq(this.schoolSelectedList, 'chipkey');
        this.schoolInput.reset();
        break;
      }
      case 'education': {
        if (from == 'enter') {
          item = { key: item.toLowerCase(), doc_count: 0 }
          this.educationSelectedList.push({ key: item.key + '.searchastext', isExcluded: false, isMandatory: false, chipkey: item.key });
        } else {
          this.educationSelectedList.push({ ...item, isExcluded: false, isMandatory: false, chipkey: item.key });
        }
        this.educationSelectedList = _.uniq(this.educationSelectedList, 'chipkey');
        this.educationInput.reset();
        break;
      }
      case 'function': {
        if (from == 'enter') {
          item = { key: item.toLowerCase(), doc_count: 0 }
          this.functionSelectedList.push({ key: item.key + '.searchastext', isExcluded: false, isMandatory: false, chipkey: item.key });
        } else {
          let tooltipText = `Selecting ${item.key.replaceAll('_', ' ')} includes all its specializations.`
          this.functionSelectedList.push({ ...item, isExcluded: false, isMandatory: false, chipkey: item.key, type: 'function', tooltipText });
        }
        this.functionSelectedList = _.uniq(this.functionSelectedList, 'chipkey');
        this.functionsInput.reset();
        break;
      }
      case 'keyword': {
        if (from == 'enter') {
          item = { key: item.toLowerCase(), doc_count: 0 }
          this.keywordSelectedList.push({ key: item.key, isExcluded: false, isMandatory: false, chipkey: item.key });
        } else {
          this.keywordSelectedList.push({ ...item, isExcluded: false, isMandatory: false, chipkey: item.key });
        }
        this.keywordSelectedList = _.uniq(this.keywordSelectedList, 'chipkey');
        this.keyword_input.reset();
        break;
      }
      case 'schoollocation': {
        if (from == 'enter') {
          item = { key: item.toLowerCase(), doc_count: 0 }
          this.schoolLocationSelectedList.push({ key: item.key + ".searchastext", isExcluded: false, isMandatory: false, chipkey: item.key });
        } else {
          this.schoolLocationSelectedList.push({ ...item, isExcluded: false, isMandatory: false, chipkey: item.key });
        }
        this.schoolLocationSelectedList = _.uniq(this.schoolLocationSelectedList, 'chipkey');
        this.schoolLocationInput.reset();
        break;
      }
    }
        this.filterEvent.emit('showFilters');

    this.aggReqObjectHandlerService.setStartIndex(0);
    this.syncFilterData();
    this.filterDataHandlerService.setFilterData(this.filterData);
    this.aggReqObjectHandlerService.setStartIndex(0);
    if (this.isCompanyInsightsDetails || this.aiSourcingService.isAISourcingTab) {
      this.getTopList();
    }
    this.filterDataHandlerService.shouldSendPersonSearchRequest() && this.aggService.getPersonSearchRecommendedCandidates(this.extraInfo);
    this.getexpandrefresheddata(type);
    this.filterDataHandlerService.emitfilterMethodObject({ methodName: "addToSelectedList", filterType: type });
    this.document.documentElement.scrollTop = 0;
    this.setFilterDataInLocalStorage();
    this.isSearchSaved = false;
    this.setTalentInsightsHistory();
  }

/**
 * Selected filter from dropdown
 * @param event
 * @param type
 */
  selectedItemFilter(event, type) {
    switch (type) {
      case 'jobtitle': {
        this.jobTitleList = []
        if (this.talentInsightsReqHandler.isTalentInsightsTab) {
          this.jobTitleSelectedList.push({ key: event.option.value.key + ".searchastext", isExcluded: false, isMandatory: false, chipkey: event.option.value.key });
        } else {
          if (!this.jobTitleSelectedList) {
            this.jobTitleSelectedList = [];
          }
          this.jobTitleSelectedList.push({ ...event.option.value, isExcluded: false, isMandatory: false, chipkey: event.option.value.key });
        }
        this.jobTitleSelectedList = _.uniq(this.jobTitleSelectedList, 'chipkey');
        this.jobTitleInput.reset();
        break;
      }
      case this.filterNames.PAST_JOB_TITLE: {
        this.pastJobTitleList = []
        if (this.talentInsightsReqHandler.isTalentInsightsTab) {
          this.pastJobTitleSelectedList.push({ key: event.option.value.key + ".searchastext", isExcluded: false, isMandatory: false, chipkey: event.option.value.key });
        } else {
          if (!this.pastJobTitleSelectedList) {
            this.pastJobTitleSelectedList = [];
          }
          this.pastJobTitleSelectedList.push({ ...event.option.value, isExcluded: false, isMandatory: false, chipkey: event.option.value.key });
        }
        this.pastJobTitleSelectedList = _.uniq(this.pastJobTitleSelectedList, 'chipkey');
        this.pastJobTitleInput.reset();
        break;
      }
      case 'skills': {
        this.skillsList = [];
        if (!this.skillsSelectedList) {
          this.skillsSelectedList = [];
        }
          this.skillsSelectedList.push({ ...event.option.value, isExcluded: false, isMandatory: false, chipkey: event.option.value.key });
        this.skillsSelectedList = _.uniq(this.skillsSelectedList, 'chipkey');
        this.skillsInput.reset();
        break;
      }
      case 'company': {
        this.companyList = []
        if (!this.companySelectedList) {
          this.companySelectedList = [];
        }
          this.companySelectedList.push({ ...event.option.value, isExcluded: false, isMandatory: false, chipkey: event.option.value.key, companylogo: event.option.value.companylogo });
        this.companySelectedList = _.uniq(this.companySelectedList, 'chipkey');
        this.companyAiSuggestions = this.companyAiSuggestions.filter(c => !this.companySelectedList.some(cs => cs.chipkey == c.chipkey));
        const companyList = this.companySelectedList.filter(c => !c.isSuggested);
        if (companyList && companyList.length && !this.aiSourcingService.isAISourcingTab) {
          this.getCompanyAiSuggestions();
        }

        this.companyInput.reset();
        break;
      }
      case 'industry': {
        this.industryList = []
        this.industrySelectedList.push({ ...event.option.value, isExcluded: false, isMandatory: false, chipkey: event.option.value.key });
        this.industrySelectedList = _.uniq(this.industrySelectedList, 'chipkey');
        this.industryInput.reset();
        break;
      }
      case 'fieldofstudy': {
        this.fieldOfStudyList = [];
        this.fieldOfStudySelectedList.push({ ...event.option.value, isExcluded: false, isMandatory: false, chipkey: event.option.value.key });
        this.fieldOfStudySelectedList = _.uniq(this.fieldOfStudySelectedList, 'chipkey');
        this.fieldOfStudyInput.reset();
        break;
      }
      case 'fullname': {
        this.fullNameList = [];
        this.fullNameSelectedList.push({ ...event.option.value, isExcluded: false, isMandatory: false, chipkey: event.option.value.key });
        this.fullNameSelectedList = _.uniq(this.fullNameSelectedList, 'chipkey');
        this.fullNameInput.reset();
        break;
      }
      case 'companysize': {
        this.companySizeHandler(event)
        // this.companysize = event.value;
        this.isCompanySizeSelected = this.companysize.length > 0;
        break;
      }
      case 'school': {
        this.schoolList = [];
        if (!this.schoolSelectedList) {
          this.schoolSelectedList = [];
        }
        this.schoolSelectedList.push({ ...event.option.value, isExcluded: false, isMandatory: false, chipkey: event.option.value.key });
        this.schoolSelectedList = _.uniq(this.schoolSelectedList, 'chipkey');
        this.schoolInput.reset();
        break;
      }
      case 'education': {
        this.educationList = [];
        if (!this.educationSelectedList) {
          this.educationSelectedList = [];
        }
        this.educationSelectedList.push({ ...event.option.value, isExcluded: false, isMandatory: false, chipkey: event.option.value.key });
        this.educationSelectedList = _.uniq(this.educationSelectedList, 'chipkey');
        this.educationInput.reset();
        break;
      }
      case 'gender': {
        this.gender = event.target.value;
        this.isGenderSelected = this.gender != 'All';
        this.statsMatrixHandlerService.emitFilterMatrixObject(new MatrixFilter(type, event));
        break;
      }
      case 'seniority': {
        this.seniorityHandler(event)
        break;
      }
      case 'location': {
        this.locationList = [];
        if (!this.locationSelectedList) {
          this.locationSelectedList = [];
        }
        const filter = this.filterDataHandlerService.fetchFilterData
        this.locationcontinentsName = filter.locationcontinents;
        this.locationContinents = filter.continentstobeincluded;
        this.locationSelectedList.push({ ...event.option.value, isExcluded: false, isMandatory: false, chipkey: event.option.value.key, location_type: event.option.value.type, continent: event.option.value.continent });
        this.locationSelectedList = _.uniq(this.locationSelectedList, 'chipkey');
        const locationType = _.pluck(this.locationSelectedList, 'location_type');
        this.location_type = locationType.length > 0 && locationType.indexOf('city') !== -1 ? 'city' : null;
        this.locationContinents.push(_.uniq(_.pluck(this.locationSelectedList, 'continent')));
        this.locationContinents = _.flatten(_.uniq(this.locationContinents));
        this.locationcontinentsName?.push({key: event.option.value.key, continent:  event.option.value.continent, calledFrom: 'Filter' })
        this.locationInput.reset();
        break;
      }
      case 'likelytomovein': {
        this.filterLikelyToMoveIn = event.target.value;
        this.isLikelyToMoveInFilterSelected = this.filterLikelyToMoveIn === 'Yes';
        this.candidateslikelytomove = this.filterLikelyToMoveIn;
        this.statsMatrixHandlerService.emitFilterMatrixObject(new MatrixFilter(type, event));
        break;
      }
      case 'function': {
        this.functionsList = [];
        if (!this.functionSelectedList) {
          this.functionSelectedList = [];
        }
        const type = event?.option?.value?.function_type || 'function';
        let tooltipText = ``;
        GlobalService.titleCase
        if (type == 'specialization') {
          tooltipText = `${GlobalService.titleCase(event?.option?.value?.key.replaceAll('_', ' '))} is a specialization under ${GlobalService.titleCase(event?.option?.value?.parent_function.replaceAll('_', ' '))}`
        } else {
          tooltipText = `Selecting ${GlobalService.titleCase(event?.option?.value?.key.replaceAll('_', ' '))} includes all its specializations.`
        }
        this.functionSelectedList.push({ ...event.option.value, isExcluded: false, isMandatory: false, chipkey: event.option.value.key, type: event.option.value.function_type, tooltipText });
        this.functionSelectedList = _.uniq(this.functionSelectedList, 'chipkey');
        this.functionsInput.reset();
        break;
      }
      case 'changedJobs': {
        this.changedJobStatus = 'no';
        this.changedJobDuration = parseInt(event.target.value);
        this.changedJobStartDuration = this.changedJobDuration;
        this.changedJobEndDuration = 12;
        this.aggService.changeJobResetEmit();
        // this.isChangedJobsSelected = (this.changedJobStatus === 'yes')
        break;
      }
      case 'keyword': {
        this.keywordSelectedList.push({ ...event.option.value, isExcluded: false, isMandatory: false, chipkey: event.option.value.key });
        this.keywordSelectedList = _.uniq(this.keywordSelectedList, 'chipkey');
        this.keyword_input.reset();
        break;
      }
      case 'schoollocation': {
        this.schoolLocationList = []
        this.schoolLocationSelectedList.push({ ...event.option.value, isExcluded: false, isMandatory: false, chipkey: event.option.value.key });
        this.schoolLocationSelectedList = _.uniq(this.schoolLocationSelectedList, 'chipkey');
        // this.keywordlist = this.keywordlist.filter((el: any) => !this.keywordSelectedList.some((kw: any) => kw.chipkey == el));
        this.schoolLocationInput.reset();
        break;
      }
      case 'locationRange': {
        this.locationDistanceRangeForFilterData = this.locationDistanceRange;
        this.locationDistanceUnitForFilterData = this.locationDistanceUnit;
        break;
      }
      case 'positionhierarchy': {
        let value = event.value;
        this.positionhierarchy = _.without(this.positionhierarchy, "All")
        value = _.without(value, "All")
        if (value.length == 10) {
          this.positionhierarchy = value;
          this.positionhierarchy.push("All")
        } else {
          this.positionhierarchy = _.uniq(this.positionhierarchy.concat(value));
        }
        break;
      }
    }
    this.filterEvent.emit('showFilters');

    this.syncFilterData();
    this.filterDataHandlerService.setFilterData(this.filterData);
    this.aggReqObjectHandlerService.setStartIndex(0);
    this.filterDataHandlerService.shouldSendPersonSearchRequest() && this.aggService.getPersonSearchRecommendedCandidates(this.extraInfo);
    this.getexpandrefresheddata(type);
    this.aggReqObjectHandlerService.setStartIndex(0);
      this.filterDataHandlerService.emitfilterMethodObject({ methodName: "selectedItem", filterType: type });

    this.document.documentElement.scrollTop = 0;
    this.setFilterDataInLocalStorage();
    this.isSearchSaved = false;
    this.setTalentInsightsHistory();
   // this.setCompanyInsightsHistory();
  }

/**
 * set Filter data
 * @param replace
 */
  setFilterDataInLocalStorage(replace: boolean = false) {
    // debugger
    if(window.location.pathname !== '/person/search/listing' && !window.location.pathname.includes('/report-details')) return;
    let filterData = this.filterDataHandlerService.fetchFilterData;
    // if(this.isTalentInsightsPage){
    //   // console.log(this.localstorageservice.getItem('talentregion'),'continent')
    //   filterData.continentstobeincluded = this.localstorageservice.getItem('talentRegion')
    // }else{
    //   filterData.continentstobeincluded = this.localstorageservice.getItem('region')
    // }
    // console.log(filterData,'filterData to be stored');
    const requestObject = this.aggService.getRequestWithFilters();
    filterData.booleanquery = this.keywordInput.value ? this.keywordInput.value : this.searchKeyword ? this.searchKeyword : requestObject.booleanquery ? requestObject.booleanquery : "*";
    const localKey = GlobalService.hash(JSON.stringify(cjson.compress(filterData)));
    if (!window.location.search.includes(localKey)) {
      localStorage.setItem(localKey, JSON.stringify(cjson.compress(filterData)));
      // console.log('filterData set', JSON.stringify(filterData));
      // localStorage.setItem(GeneralConstants.LS_KEYS.TALENT_FILTERS, JSON.stringify(cjson.compress(filterData)));

      this.localstorageservice.setItem(GeneralConstants.LS_KEYS.TALENT_FILTERS, JSON.stringify(filterData));
      const parsedUrl = this.router.parseUrl(this.router.url);
      const uniqueHash = this.route.snapshot.queryParams.uniqueHash;
      const redirectSource = parsedUrl.queryParams.redirectSource;
      this.locationService[replace ? 'replaceState' : 'go'](parsedUrl.toString().split('?')[0], 'filter=' + encodeURIComponent(localKey) + (this.searchKeyword && this.searchKeyword !== '' ? `&keyword=${this.searchKeyword}` : '') + (this.tabType && this.tabType !== '' ? `&type=${this.tabType}` : '') + (this.filterType && this.filterType !== '' ? `&filtertype=${this.filterType}` : '') + (this.filterValue && this.filterValue !== '' ? `&filtervalue=${this.filterValue}` : '') + (this.searchSource && this.searchSource !== '' ? `&searchSource=${this.searchSource}` : '') + (uniqueHash && uniqueHash !== '' ? `&uniqueHash=${uniqueHash}` : '') + (redirectSource && redirectSource !== '' ? `&redirectSource=${redirectSource}` : ''));
    }
  }

/**
 * Update all selected filter from localstorage
 * @param filter - Filter key to get filterdata from localstorage
 */
  loadFilterFromLocalStorage(filterData: any) {
    // const cacheRequest = localStorage.getItem(filter);
    // const filterData = cjson.decompress(JSON.parse(cacheRequest));
    // console.log(filterData, 'line 3487');

    if(filterData && !filterData.calledFrom){
    if (filterData && filterData.booleanquery) {

      this.searchKeyword = filterData.booleanquery;
      this.keywordInput.patchValue(filterData.booleanquery !== "*" ? filterData.booleanquery : '');
    } else {
      this.keywordInput.patchValue(null);
      this.searchKeyword = '';
    }

    if(this.localstorageservice.getItem('talentdiscoveryhistoryid')) {
      this.talentDiscoveryHistoryId = null;
    } else {
      if(filterData.talentdiscoveryhistoryid){
        this.talentDiscoveryHistoryId = filterData.talentdiscoveryhistoryid;
      } else if(this.talentDiscoveryHistoryId) {
        this.talentDiscoveryHistoryId = this.talentDiscoveryHistoryId;
      } else {
        this.talentDiscoveryHistoryId = null;
      }
    }

    if(this.browserBackEvent && this.localstorageservice.getItem('talentdiscoveryhistoryid')) {
      this.savehistory = true;
    } else if (this.browserBackEvent) {
      this.savehistory = false;
      this.savehistory = true;
    }  else {
      if(filterData && filterData.savehistory) {
        this.savehistory = filterData.savehistory;
      } else {
        this.savehistory = false;
      }
    }

    if (filterData && filterData.jobTitleStatus) {
      this.jobTitleStatus = filterData.jobTitleStatus;
    } else {
      this.jobTitleStatus = CallStage.CURRENT.toString();;
    }

    if (filterData && filterData.companyStatus) {
      this.companyStatus = filterData.companyStatus;
    } else {
      this.companyStatus = CallStage.CURRENT.toString();;
    }

    if (filterData && filterData.industryStatus) {
      this.industryStatus = filterData.industryStatus;
    } else {
      this.industryStatus = CallStage.CURRENT.toString();;
    }

    if (filterData && filterData.jobTitleSelectedList) {
      this.jobTitleSelectedList = _.clone(filterData.jobTitleSelectedList, true);
    } else {
      this.jobTitleSelectedList = [];
    }

    if (filterData && filterData.pastJobTitleSelectedList) {
      this.pastJobTitleSelectedList = _.clone(filterData.pastJobTitleSelectedList, true);
    } else {
      this.pastJobTitleSelectedList = [];
    }

    if (filterData && filterData.locationSelectedList) {
      this.locationSelectedList = _.clone(filterData.locationSelectedList, true);
      const locationType = _.pluck(this.locationSelectedList, 'location_type');
      this.location_type = locationType.length > 0 && locationType.indexOf('city') !== -1 ? 'city' : null;
    } else {
      this.locationSelectedList = [];
      this.location_type = null;
    }

    if (filterData && filterData.skillsSelectedList) {
      this.skillsSelectedList = _.clone(filterData.skillsSelectedList, true);
    } else {
      this.skillsSelectedList = [];
    }

    if (filterData && filterData.companySelectedList) {
      this.companySelectedList = _.clone(filterData.companySelectedList, true);
    } else {
      this.companySelectedList = [];
    }

    if (filterData && filterData.companysize) {
      if(filterData.companysize.includes("All")){
        this.isCompanySizeSelected = filterData.companySizeSelectedList?.length ? true: false;
        this.companysize = ["All","1-10", "11-50", "51-200", "201-500", "501-1000", "1001-5000", "5001-10000", "10001+"]
      }else{
        this.isCompanySizeSelected = filterData.companySizeSelectedList?.length ? true: false;
        this.companysize = _.clone(filterData.companysize, true);
      }
    } else {
      this.isCompanySizeSelected  = false;
      this.companysize = ["All","1-10", "11-50", "51-200", "201-500", "501-1000", "1001-5000", "5001-10000", "10001+"]
    }

    if (filterData && filterData.profilehighlights) {
      this.highlightsSelectedList = this.highlightOptionsObjectFormation(filterData.profilehighlights);
      this.highlightSelectedControl = _.pluck(this.highlightsSelectedList, 'id');
    } else {
      this.highlightsSelectedList = [];
      this.highlightSelectedControl = [];
    }

    if (filterData && filterData.industrySelectedList) {
      this.industrySelectedList = _.clone(filterData.industrySelectedList, true);
    } else {
      this.industrySelectedList = [];
    }

    if (filterData && filterData.functionSelectedList) {
      this.functionSelectedList = _.clone(filterData.functionSelectedList, true);
    } else {
      this.functionSelectedList = [];
    }

    if (filterData && filterData.seniority) {
      if(filterData.seniority.includes("All")){
        this.seniority = ["All", "cxo","director", "entry", "manager","owner", "partner","senior","training","unpaid","vp"]
      }else{
        this.seniority = _.clone(filterData.seniority, true);
      }
    } else {
      this.seniority = ["All", "cxo","director", "entry", "manager","owner", "partner","senior","training","unpaid","vp"]
    }

    if (filterData && filterData.educationSelectedList) {
      this.educationSelectedList = _.clone(filterData.educationSelectedList, true);
    } else {
      this.educationSelectedList = [];
    }

    if (filterData && filterData.schoolLocationSelectedList) {
      this.schoolLocationSelectedList = _.clone(filterData.schoolLocationSelectedList, true);
    } else {
      this.schoolLocationSelectedList = [];
    }

    if (filterData && filterData.schoolSelectedList) {
      this.schoolSelectedList = _.clone(filterData.schoolSelectedList, true);
    } else {
      this.schoolSelectedList = [];
    }

    if (filterData && filterData.fieldOfStudySelectedList) {
      this.fieldOfStudySelectedList = _.clone(filterData.fieldOfStudySelectedList, true);
    } else {
      this.fieldOfStudySelectedList = [];
    }

    // Full Name
    if (filterData && filterData.fullNameSelectedList) {
      this.fullNameSelectedList = _.clone(filterData.fullNameSelectedList, true);
    } else {
      this.fullNameSelectedList = [];
    }

    if (filterData && filterData.gender) {
      this.gender = filterData.gender;
    } else {
      this.gender = 'All';
    }

    this.isGenderSelected = filterData? filterData.isGenderSelected : false;

    if (filterData && (filterData.yearsofexperienceFrom || filterData.yearsofexperienceTo) ) {
      this.yearsofexperienceFrom.setValue(filterData.yearsofexperienceFrom);
      this.yearsofexperienceTo.setValue(filterData.yearsofexperienceTo);
      this.yearsofexperienceFromFilterData = filterData.yearsofexperienceFrom;
      this.yearsofexperienceToFilterData = filterData.yearsofexperienceTo;
      this.filterAppliedOnYearsOfExperience = true;
      this.yearsofexperience = filterData.yearsofexperience ? filterData.yearsofexperience : 'Total';
    } else {
      this.yearsofexperienceFrom.setValue(null);
      this.yearsofexperienceTo.setValue(null);
      this.yearsofexperienceFromFilterData = null;
      this.yearsofexperienceToFilterData = null;
      this.filterAppliedOnYearsOfExperience = false;
      this.yearsofexperience = 'Total';
      this.yearsofexperienceFrom.setValidators([Validators.required, Validators.min(0)]);
      this.yearsofexperienceTo.setValidators([Validators.required, Validators.min(0)]);
    }

    if (filterData && (filterData.currentfromyearsofexperience || filterData.currenttoyearsofexperience) ) {
      this.currentfromyearsofexperience.setValue(filterData.currentfromyearsofexperience);
      this.currenttoyearsofexperience.setValue(filterData.currenttoyearsofexperience);
      this.currentfromyearsofexperienceFilterData = filterData.currentfromyearsofexperience;
      this.currenttoyearsofexperienceFilterData = filterData.currenttoyearsofexperience;
      this.filterAppliedOnYearsOfExperience = true;
    } else {
      this.currentfromyearsofexperience.setValue(null);
      this.currenttoyearsofexperience.setValue(null);
      this.filterAppliedOnCurrentYearsOfExperience = false;
      this.currenttoyearsofexperienceFilterData = null;
      this.currentfromyearsofexperienceFilterData = null;
      this.currentfromyearsofexperience.setValidators([Validators.required, Validators.min(0)]);
      this.currenttoyearsofexperience.setValidators([Validators.required, Validators.min(0)]);
    }
    if(filterData.tograduationyear || filterData.fromgraduationyear){
      this.tograduationyearFilter = filterData.tograduationyear;
      this.fromgraduationyearFilter = filterData.fromgraduationyear;
      this.isGraduationFilterApplied = true;
    }else{
      this.tograduationyearFilter = null;
      this.fromgraduationyearFilter = null;
      this.isGraduationFilterApplied = false;
    }
    if(filterData && filterData.distancefromselectedlocations) {
      this.locationDistanceRange = filterData.distancefromselectedlocations;
    } else{
      this.locationDistanceRange = '20';
    }

    if(filterData && filterData.distancefromselectedlocationsmeasurementunit) {
      this.locationDistanceUnit = filterData.distancefromselectedlocationsmeasurementunit;
    } else{
      this.locationDistanceUnit = 'kilometers'
    }

    if(filterData.searchHistoryRegion){
      this.searchHistoryRegion = filterData.searchHistoryRegion;
      this.sessionStorageService.setItem('historyRegion', filterData.searchHistoryRegion)
    }else{
      this.searchHistoryRegion = null;
      this.sessionStorageService.setItem('historyRegion', null)
    }
    if(filterData.continentstobeincluded){
      this.locationContinents = filterData.continentstobeincluded;
    } else {
       const locationsObj = this.locationSelectedList.filter(x => x.isExcluded != true);

    this.locationContinents = this.locationContinents?.length ? this.locationContinents : _.uniq(_.pluck(locationsObj, 'continent'));
    this.locationContinents = this.locationContinents?.filter(item => item !== null && item !==  undefined && item !== '');
    this.filterData.continentstobeincluded = this.locationContinents?.length ? this.locationContinents : [];

  }

    if(filterData && (filterData.isListingActive || filterData.isInsightsActive)) {
      this.isListingActive = filterData.isListingActive;
      this.isInsightsActive = filterData.isInsightsActive;
    } else {
      this.isListingActive = true;
      this.isInsightsActive = false;
    }

    if(filterData && filterData.positionhierarchy) {
      this.positionhierarchy = filterData.positionhierarchy;
    }

        if (this.areAllFiltersCleared() &&  (!this.jdDataService.isComingFromJobDescription && !this.jdDataService.isComingFromNLSearch && !this.isSimilarCanidate &&  this.redirectSource != 'talent-insights' && this.redirectSource != 'company-insights')) {
  this.filterEvent.emit('allfilters');
    }else {
      this.filterEvent.emit("showData")
       this.browserBackEvent = false;
    this.isSearchSaved = false;
    this.localstorageservice.setItem('talentdiscoveryhistoryid', null);
    }

  } else{
    if (this.areAllFiltersCleared() &&  (!this.jdDataService.isComingFromJobDescription && !this.jdDataService.isComingFromNLSearch && !this.isSimilarCanidate &&  this.redirectSource != 'talent-insights' && this.redirectSource != 'company-insights')) {
  this.filterEvent.emit('allfilters');
    } else {
      this.filterEvent.emit("showData")
    }
    this.browserBackEvent = false;
    this.isSearchSaved = false;
    this.localstorageservice.setItem('talentdiscoveryhistoryid', null);
    this.dataService.setData(filterData);
  }

  };

  changeContinent() {
    // Access flags don't vary by which region tab is being viewed, so this just needs the
    // already-loaded signal, not a fresh network call.
    const accessData = this.transactionService.access();
    if (accessData) {
        this.localstorageservice.setItem('hasEUPersonSearchAccess', accessData.haseupersonsearchaccess);
        this.localstorageservice.setItem('hasEUTalentInsightsAccess', accessData.haseutalentinsightsaccess)

        const currentRegion = this.localstorageservice.getItem('region');
        if(currentRegion == 'europe' && !accessData.haseupersonsearchaccess) {
          this.personSearchService.getGeoIpLocationOfUser.subscribe((response: any) => {
            const region = response.continent ? response.continent.toLowerCase() : 'asia';
            this.showregion = region;
            this.localstorageservice.setItem('region', region);
            this.aggService.emitContinentEvent(this.showregion);
            this.filterData.savehistory = true;
            this.filterData.talentdiscoveryhistoryid = null;

            this.filterDataHandlerService.setFilterData(this.filterData);
            this.aggReqObjectHandlerService.setStartIndex(0);
            this.setFilterDataInLocalStorage();
            this.filterDataHandlerService.emitfilterMethodObject({ methodName: "changeContinent" });

            this.aggService.getPersonSearchRecommendedCandidates(this.extraInfo);
            this.getexpandrefresheddata(this.filterType);
            this.document.documentElement.scrollTop = 0;

            this.isSearchSaved = false;
            this.setTalentInsightsHistory();
          });
        }
      }
  }

    isLocationDisabled(location: any): boolean {
      if(this.isPersonSearchListingPage) {
         return this.hasEuAccess != 1 && location.location_continent.toLowerCase() === 'europe';
      } else if(this.isTalentInsightsPage) {
        return this.hasEUTalentInsightsAccess != 1 && location.location_continent.toLowerCase() === 'europe';
      }
      return false;
  }

  getTooltipText(location: any): string {
    if(this.isLocationDisabled(location)) {
      return 'This location cannot be selected due to GDPR regulations.\n As part of our commitment to EU data protection regulations, candidate personal data (PII) is not displayed or processed for EU-based profiles.';
    } else {
      return `${this.capitalizeFirst(location?.value)} | ${this.capitalizeFirst(location?.location_type)}`;
    }
  }

capitalizeFirst(value: string): string {
  if (!value) return '';

  return value
    .toLowerCase()
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}

resetAllFilters() {
  if(this.jdDataService.isComingFromJobDescription || this.jdDataService.isComingFromNLSearch || this.isSimilarCanidate) {
    this.clearFilters('all')
  } else {
  this.filterDataHandlerService.reset('all');
  this.localstorageservice.setItem('talentdiscoveryhistoryid', null);
  this.dataService.setData(null);
  this.clearFilters('allfilters');
  this.filterEvent.emit('allfilters');
  }

}

areAllFiltersCleared(): boolean {
  return (
    !this.jobTitleSelectedList?.length &&
    !this.locationSelectedList?.length &&
    !this.companySelectedList?.length &&
    !this.industrySelectedList?.length &&
    !this.educationSelectedList?.length &&
    !this.fieldOfStudySelectedList?.length &&
    !this.skillsSelectedList?.length &&
    !this.functionSelectedList?.length &&
    !this.keywordSelectedList?.length &&
    !this.schoolSelectedList?.length &&
    !this.schoolLocationSelectedList?.length &&
    !this.pastJobTitleSelectedList?.length &&
    !this.highlightsSelectedList?.length &&
    !this.positionhierarchy?.length &&
    !this.companysize?.length &&
    !this.seniority?.length &&
    !this.fullNameSelectedList?.length &&
    !this.keyWordInputValue &&

    // Gender
    this.gender === 'All' &&

    // Likely to move
    this.filterLikelyToMoveIn === 'All' &&

    // Experience filters
    !this.yearsofexperienceFrom.value &&
    !this.yearsofexperienceTo.value &&
    !this.currentfromyearsofexperience.value &&
    !this.currenttoyearsofexperience.value &&

    // Graduation
    !this.fromgraduationyearFilter &&
    !this.tograduationyearFilter &&

    // Location range
    this.locationDistanceRange === '20' &&
    this.locationDistanceUnit === 'kilometers'
  );
}

toggleDropdown() {
  this.isOpen = !this.isOpen;
}

  goBackToProjectList(): void {
    this.aiSourcingHandlerService.setDisplayPageEvent('project-details');
    this.router.navigate(['/ai-sourcing/project-list']);
  };
updateSaveSearch() {
  const module = (this.isPersonSearchListingPage) ? GlobalService.HISTORY_MODULE.PERSON_SEARCH : GlobalService.HISTORY_MODULE.TALENT_INSIGHTS;
    const modalRef = this.modalService.open(SaveSearchModalComponent, { windowClass: "modalExtract", centered: true, keyboard: false, backdrop: 'static' });
    modalRef.componentInstance.talentdiscoveryhistoryid = this.saveSearchTalentDiscoveryHistoryId;
    modalRef.componentInstance.module = module;
    modalRef.componentInstance.type = 'update';
    modalRef.componentInstance.searchName = this.localstorageservice.getItem('saveSearchName');
    modalRef.result
      .then((message: any) => {
        if (message && message === 'Update successfully') {
          this.isSearchSaved = true;
          this.saveSearchTalentDiscoveryHistoryId =this.saveSearchTalentDiscoveryHistoryId;
          this.successMessage = 'Search updated successfully';
         }
      })
      .catch((err: any) => {
        this.errorMessage = 'Something went wrong';
      })
      .finally(() => {
        // this.getSavedSearchDetails();
        setTimeout(() => {
          this.successMessage = '';
          this.errorMessage = '';
        }, 5000);
      })
    const data = this.filterDataHandlerService.fetchFilterData
    data.talentdiscoveryhistoryid = null;
    this.filterDataHandlerService.setFilterData(data);

}

toggleFilter(filterName: string) {
   this.collapsedFilters[filterName] = !this.collapsedFilters[filterName];

      this.getFilterWiseDataToDisplay(filterName)

}

isExpanded(filterName: string, selectedList?: any[]): boolean {
  if (this.collapsedFilters[filterName] !== undefined) {
    return this.collapsedFilters[filterName];
  }

  return selectedList?.length > 0;
}
}
